import type { District } from "./types";

/**
 * All 435 House districts as drawn for Nov 3, 2026 (new maps in AL, CA,
 * FL, LA, NC, OH, TN, TX and UT; Missouri votes on its 2022 lines).
 * `harris2024` and the county weights come from The Downballot's 2024
 * presidential results by 2026 district (county and partial-county
 * votes); finalists from Silver Bulletin's FLIPR table, Oct 28, 2026.
 * `left` is the Democrat (or an independent outpolling them), `right`
 * the Republican (or an independent where none runs); finalists of one
 * party, or a missing side, mean the seat is already decided. `holder`
 * is the party of the member now holding the seat number.
 */
export const DISTRICTS: District[] = [
  {
    counties: [],
    harris2024: 0.4315,
    holder: "R",
    id: "AK-AL",
    incumbent: "Nick Begich",
    left: { name: "Hill", party: "I" },
    right: { name: "Nicholas Begich", party: "R" },
    state: "AK",
  },
  {
    counties: [
      ["01097", 534],
      ["01003", 373],
      ["01039", 48],
      ["01053", 46],
    ],
    harris2024: 0.3183,
    holder: "R",
    id: "AL-01",
    incumbent: "Barry Moore",
    left: { name: "Clyde Jones", party: "D" },
    right: { name: "Jerry Carl", party: "R" },
    state: "AL",
  },
  {
    counties: [
      ["01101", 306],
      ["01069", 151],
      ["01031", 76],
      ["01113", 71],
      ["01045", 65],
      ["01051", 62],
      ["01109", 45],
      ["01061", 42],
      ["01005", 34],
      ["01067", 32],
      ["01013", 29],
      ["01087", 27],
      ["01041", 22],
      ["01085", 19],
      ["01011", 14],
      ["01039", 5],
    ],
    harris2024: 0.4277,
    holder: "D",
    id: "AL-02",
    incumbent: "Shomari Figures",
    left: { name: "Shomari Figures", party: "D" },
    right: { name: "Rhett Marques", party: "R" },
    state: "AL",
  },
  {
    counties: [
      ["01081", 231],
      ["01015", 154],
      ["01055", 146],
      ["01115", 138],
      ["01121", 100],
      ["01123", 63],
      ["01017", 45],
      ["01019", 41],
      ["01111", 35],
      ["01029", 24],
      ["01027", 21],
    ],
    harris2024: 0.2646,
    holder: "R",
    id: "AL-03",
    incumbent: "Mike Rogers",
    left: { name: "Lee McInnis", party: "D" },
    right: { name: "Mike Rogers", party: "R" },
    state: "AL",
  },
  {
    counties: [
      ["01043", 133],
      ["01095", 125],
      ["01125", 122],
      ["01077", 106],
      ["01127", 92],
      ["01049", 91],
      ["01009", 87],
      ["01033", 84],
      ["01093", 42],
      ["01059", 37],
      ["01133", 34],
      ["01057", 26],
      ["01075", 21],
    ],
    harris2024: 0.1654,
    holder: "R",
    id: "AL-04",
    incumbent: "Robert Aderholt",
    left: { name: "Amanda Pusczek", party: "D" },
    right: { name: "Robert Aderholt", party: "R" },
    state: "AL",
  },
  {
    counties: [
      ["01089", 558],
      ["01103", 152],
      ["01083", 151],
      ["01071", 67],
      ["01079", 46],
      ["01077", 26],
    ],
    harris2024: 0.3525,
    holder: "R",
    id: "AL-05",
    incumbent: "Dale Strong",
    left: { name: "Andrew Sneed", party: "D" },
    right: { name: "Dale Strong", party: "R" },
    state: "AL",
  },
  {
    counties: [
      ["01073", 418],
      ["01117", 329],
      ["01001", 81],
      ["01051", 68],
      ["01021", 57],
      ["01007", 27],
      ["01037", 15],
      ["01121", 5],
    ],
    harris2024: 0.325,
    holder: "R",
    id: "AL-06",
    incumbent: "Gary Palmer",
    left: { name: "Maurice Mercer", party: "D" },
    right: { name: "Gary Palmer", party: "R" },
    state: "AL",
  },
  {
    counties: [
      ["01073", 505],
      ["01125", 151],
      ["01047", 52],
      ["01025", 40],
      ["01099", 33],
      ["01091", 32],
      ["01107", 30],
      ["01129", 28],
      ["01065", 24],
      ["01023", 22],
      ["01035", 20],
      ["01119", 18],
      ["01131", 17],
      ["01105", 15],
      ["01063", 13],
    ],
    harris2024: 0.5897,
    holder: "D",
    id: "AL-07",
    incumbent: "Terri Sewell",
    left: { name: "Terri Sewell", party: "D" },
    right: { name: "Ammie Akin", party: "R" },
    state: "AL",
  },
  {
    counties: [
      ["05031", 136],
      ["05085", 112],
      ["05005", 77],
      ["05009", 63],
      ["05055", 58],
      ["05035", 54],
      ["05063", 51],
      ["05093", 39],
      ["05089", 29],
      ["05135", 27],
      ["05111", 26],
      ["05037", 24],
      ["05121", 24],
      ["05065", 22],
      ["05123", 22],
      ["05137", 22],
      ["05075", 21],
      ["05001", 20],
      ["05021", 18],
      ["05049", 18],
      ["05107", 18],
      ["05067", 17],
      ["05129", 14],
      ["05017", 13],
      ["05041", 13],
      ["05079", 12],
      ["05117", 12],
      ["05119", 12],
      ["05077", 9],
      ["05095", 9],
      ["05147", 8],
    ],
    harris2024: 0.2691,
    holder: "R",
    id: "AR-01",
    incumbent: "Rick Crawford",
    left: { name: "Terri Yarbrough Green", party: "D" },
    right: { name: "Rick Crawford", party: "R" },
    state: "AR",
  },
  {
    counties: [
      ["05119", 448],
      ["05125", 180],
      ["05045", 170],
      ["05145", 97],
      ["05023", 40],
      ["05029", 27],
      ["05141", 24],
      ["05105", 14],
    ],
    harris2024: 0.4204,
    holder: "R",
    id: "AR-02",
    incumbent: "French Hill",
    left: { name: "Chris Jones", party: "D" },
    right: { name: "French Hill", party: "R" },
    state: "AR",
  },
  {
    counties: [
      ["05007", 415],
      ["05143", 314],
      ["05131", 133],
      ["05033", 77],
      ["05015", 37],
      ["05087", 24],
    ],
    harris2024: 0.372,
    holder: "R",
    id: "AR-03",
    incumbent: "Steve Womack",
    left: { name: "Robb Ryerse", party: "D" },
    right: { name: "Steve Womack", party: "R" },
    state: "AR",
  },
  {
    counties: [
      ["05051", 151],
      ["05115", 86],
      ["05069", 77],
      ["05091", 56],
      ["05139", 55],
      ["05059", 44],
      ["05071", 32],
      ["05103", 31],
      ["05113", 30],
      ["05053", 29],
      ["05083", 29],
      ["05027", 28],
      ["05019", 27],
      ["05119", 27],
      ["05003", 25],
      ["05047", 25],
      ["05043", 23],
      ["05149", 23],
      ["05057", 22],
      ["05081", 17],
      ["05133", 17],
      ["05061", 16],
      ["05109", 16],
      ["05131", 16],
      ["05097", 13],
      ["05101", 13],
      ["05025", 12],
      ["05127", 12],
      ["05011", 11],
      ["05099", 10],
      ["05039", 8],
      ["05073", 8],
      ["05013", 7],
    ],
    harris2024: 0.2967,
    holder: "R",
    id: "AR-04",
    incumbent: "Bruce Westerman",
    left: { name: "James Russell", party: "D" },
    right: { name: "Bruce Westerman", party: "R" },
    state: "AR",
  },
  {
    counties: [["04013", 1000]],
    harris2024: 0.4843,
    holder: "R",
    id: "AZ-01",
    incumbent: "David Schweikert",
    left: { name: "Amish Shah", party: "D" },
    right: { name: "Jay Feely", party: "R" },
    state: "AZ",
  },
  {
    counties: [
      ["04025", 359],
      ["04021", 203],
      ["04005", 168],
      ["04017", 122],
      ["04001", 77],
      ["04007", 66],
      ["04009", 3],
      ["04013", 2],
      ["04015", 1],
    ],
    harris2024: 0.4244,
    holder: "R",
    id: "AZ-02",
    incumbent: "Eli Crane",
    left: { name: "Jonathan Nez", party: "D" },
    right: { name: "Eli Crane", party: "R" },
    state: "AZ",
  },
  {
    counties: [["04013", 1000]],
    harris2024: 0.7015,
    holder: "D",
    id: "AZ-03",
    incumbent: "Yassamin Ansari",
    left: { name: "Yassamin Ansari", party: "D" },
    right: null,
    state: "AZ",
  },
  {
    counties: [["04013", 1000]],
    harris2024: 0.5338,
    holder: "D",
    id: "AZ-04",
    incumbent: "Greg Stanton",
    left: { name: "Greg Stanton", party: "D" },
    right: { name: "Zuhdi Jasser", party: "R" },
    state: "AZ",
  },
  {
    counties: [
      ["04013", 815],
      ["04021", 185],
    ],
    harris2024: 0.399,
    holder: "R",
    id: "AZ-05",
    incumbent: "Andy Biggs",
    left: { name: "Elizabeth Lee", party: "D" },
    right: { name: "Mark Lamb", party: "R" },
    state: "AZ",
  },
  {
    counties: [
      ["04019", 760],
      ["04003", 109],
      ["04021", 91],
      ["04009", 32],
      ["04011", 8],
    ],
    harris2024: 0.4962,
    holder: "R",
    id: "AZ-06",
    incumbent: "Juan Ciscomani",
    left: { name: "JoAnna Mendoza", party: "D" },
    right: { name: "Juan Ciscomani", party: "R" },
    state: "AZ",
  },
  {
    counties: [
      ["04019", 633],
      ["04013", 138],
      ["04027", 113],
      ["04023", 68],
      ["04003", 38],
      ["04021", 9],
    ],
    harris2024: 0.6119,
    holder: "D",
    id: "AZ-07",
    incumbent: "Adelita Grijalva",
    left: { name: "Adelita Grijalva", party: "D" },
    right: { name: "Daniel Butierez", party: "R" },
    state: "AZ",
  },
  {
    counties: [["04013", 1000]],
    harris2024: 0.4176,
    holder: "R",
    id: "AZ-08",
    incumbent: "Abe Hamadeh",
    left: { name: "Bernadette Greene-Placentia", party: "D" },
    right: { name: "Abraham Hamadeh", party: "R" },
    state: "AZ",
  },
  {
    counties: [
      ["04013", 617],
      ["04015", 274],
      ["04027", 90],
      ["04012", 19],
    ],
    harris2024: 0.3433,
    holder: "R",
    id: "AZ-09",
    incumbent: "Paul Gosar",
    left: { name: "Danielle Sterbinsky", party: "D" },
    right: { name: "Paul Gosar", party: "R" },
    state: "AZ",
  },
  {
    counties: [
      ["06097", 405],
      ["06007", 276],
      ["06103", 78],
      ["06045", 73],
      ["06033", 70],
      ["06035", 33],
      ["06021", 31],
      ["06063", 29],
      ["06091", 5],
    ],
    harris2024: 0.5631,
    holder: "R",
    id: "CA-01",
    incumbent: "James Gallagher",
    left: { name: "Mike McGuire", party: "D" },
    right: { name: "James Gallagher", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06041", 370],
      ["06089", 228],
      ["06023", 165],
      ["06097", 93],
      ["06093", 55],
      ["06045", 37],
      ["06015", 27],
      ["06105", 14],
      ["06049", 10],
    ],
    harris2024: 0.6272,
    holder: "D",
    id: "CA-02",
    incumbent: "Jared Huffman",
    left: { name: "Jared Huffman", party: "D" },
    right: { name: "Robin Littau", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06067", 564],
      ["06061", 200],
      ["06057", 169],
      ["06017", 66],
    ],
    harris2024: 0.5526,
    holder: "D",
    id: "CA-03",
    incumbent: "Kevin Kiley",
    left: { name: "Ami Bera", party: "D" },
    right: { name: "Robb Tucker", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06097", 223],
      ["06055", 190],
      ["06113", 185],
      ["06061", 115],
      ["06101", 114],
      ["06115", 87],
      ["06067", 56],
      ["06011", 20],
      ["06033", 9],
    ],
    harris2024: 0.5747,
    holder: "D",
    id: "CA-04",
    incumbent: "Mike Thompson",
    left: { name: "Mike Thompson", party: "D" },
    right: { name: "Eric Jones", party: "D" },
    state: "CA",
  },
  {
    counties: [
      ["06099", 340],
      ["06019", 237],
      ["06039", 116],
      ["06109", 79],
      ["06009", 73],
      ["06005", 62],
      ["06043", 26],
      ["06027", 25],
      ["06077", 20],
      ["06051", 17],
      ["06017", 4],
      ["06003", 2],
    ],
    harris2024: 0.3938,
    holder: "R",
    id: "CA-05",
    incumbent: "Tom McClintock",
    left: { name: "Michael Masuda", party: "D" },
    right: { name: "Tom McClintock", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06067", 573],
      ["06061", 362],
      ["06113", 66],
    ],
    harris2024: 0.5434,
    holder: "D",
    id: "CA-06",
    incumbent: "Ami Bera",
    left: { name: "Richard Pan", party: "D" },
    right: { name: "Kiley", party: "I" },
    state: "CA",
  },
  {
    counties: [
      ["06067", 682],
      ["06017", 249],
      ["06077", 69],
    ],
    harris2024: 0.5662,
    holder: "D",
    id: "CA-07",
    incumbent: "Doris Matsui",
    left: { name: "Mai Vang", party: "D" },
    right: { name: "Doris Matsui", party: "D" },
    state: "CA",
  },
  {
    counties: [
      ["06095", 607],
      ["06013", 333],
      ["06077", 34],
      ["06113", 22],
      ["06067", 4],
    ],
    harris2024: 0.6758,
    holder: "D",
    id: "CA-08",
    incumbent: "John Garamendi",
    left: { name: "John Garamendi", party: "D" },
    right: { name: "Rudy Recile", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06077", 707],
      ["06013", 293],
    ],
    harris2024: 0.559,
    holder: "D",
    id: "CA-09",
    incumbent: "Josh Harder",
    left: { name: "Josh Harder", party: "D" },
    right: { name: "John McBride", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06013", 915],
      ["06001", 85],
    ],
    harris2024: 0.6735,
    holder: "D",
    id: "CA-10",
    incumbent: "Mark DeSaulnier",
    left: { name: "Mark DeSaulnier", party: "D" },
    right: { name: "Jeffrey Frese", party: "R" },
    state: "CA",
  },
  {
    counties: [["06075", 1000]],
    harris2024: 0.8531,
    holder: "D",
    id: "CA-11",
    incumbent: "Nancy Pelosi",
    left: { name: "Scott Wiener", party: "D" },
    right: { name: "Connie Chan", party: "D" },
    state: "CA",
  },
  {
    counties: [["06001", 1000]],
    harris2024: 0.8882,
    holder: "D",
    id: "CA-12",
    incumbent: "Lateefah Simon",
    left: { name: "Lateefah Simon", party: "D" },
    right: { name: "Jamie Joyce", party: "D" },
    state: "CA",
  },
  {
    counties: [
      ["06047", 414],
      ["06099", 355],
      ["06077", 154],
      ["06039", 59],
      ["06019", 18],
    ],
    harris2024: 0.5019,
    holder: "D",
    id: "CA-13",
    incumbent: "Adam Gray",
    left: { name: "Adam Gray", party: "D" },
    right: { name: "Kevin Lincoln", party: "R" },
    state: "CA",
  },
  {
    counties: [["06001", 1000]],
    harris2024: 0.681,
    holder: "D",
    id: "CA-14",
    incumbent: "Aisha Wahab",
    left: { name: "Aisha Wahab", party: "D" },
    right: { name: "Melissa Hernandez", party: "D" },
    state: "CA",
  },
  {
    counties: [
      ["06081", 863],
      ["06075", 137],
    ],
    harris2024: 0.7482,
    holder: "D",
    id: "CA-15",
    incumbent: "Kevin Mullin",
    left: { name: "Kevin Mullin", party: "D" },
    right: { name: "Charles Hoelter", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06085", 804],
      ["06081", 196],
    ],
    harris2024: 0.7494,
    holder: "D",
    id: "CA-16",
    incumbent: "Sam Liccardo",
    left: { name: "Sam Liccardo", party: "D" },
    right: { name: "Peter Soule", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06085", 873],
      ["06001", 127],
    ],
    harris2024: 0.7037,
    holder: "D",
    id: "CA-17",
    incumbent: "Ro Khanna",
    left: { name: "Ro Khanna", party: "D" },
    right: { name: "Ritesh Tandon", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06085", 503],
      ["06053", 278],
      ["06069", 116],
      ["06087", 82],
      ["06019", 16],
      ["06031", 6],
    ],
    harris2024: 0.6468,
    holder: "D",
    id: "CA-18",
    incumbent: "Zoe Lofgren",
    left: { name: "Zoe Lofgren", party: "D" },
    right: { name: "Shane Lewis", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06085", 336],
      ["06087", 305],
      ["06053", 215],
      ["06079", 144],
    ],
    harris2024: 0.6783,
    holder: "D",
    id: "CA-19",
    incumbent: "Jimmy Panetta",
    left: { name: "Jimmy Panetta", party: "D" },
    right: { name: "Peter Verbica", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06029", 547],
      ["06107", 261],
      ["06031", 97],
      ["06019", 95],
    ],
    harris2024: 0.3351,
    holder: "R",
    id: "CA-20",
    incumbent: "Vince Fong",
    left: { name: "Sandra Van Scotter", party: "D" },
    right: { name: "Vince Fong", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06019", 843],
      ["06107", 157],
    ],
    harris2024: 0.5307,
    holder: "D",
    id: "CA-21",
    incumbent: "Jim Costa",
    left: { name: "Jim Costa", party: "D" },
    right: { name: "Kyle Kirkland", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06029", 613],
      ["06019", 188],
      ["06107", 141],
      ["06031", 56],
      ["06039", 2],
    ],
    harris2024: 0.4905,
    holder: "R",
    id: "CA-22",
    incumbent: "David Valadao",
    left: { name: "Randy Villegas", party: "D" },
    right: { name: "David G. Valadao", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06071", 896],
      ["06065", 66],
      ["06029", 21],
      ["06037", 17],
    ],
    harris2024: 0.4004,
    holder: "R",
    id: "CA-23",
    incumbent: "Jay Obernolte",
    left: { name: "Tessa Lynn Hodge", party: "D" },
    right: { name: "Jay Obernolte", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06083", 525],
      ["06079", 275],
      ["06111", 200],
    ],
    harris2024: 0.6287,
    holder: "D",
    id: "CA-24",
    incumbent: "Salud Carbajal",
    left: { name: "Salud Carbajal", party: "D" },
    right: { name: "Bob Smith", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06065", 780],
      ["06025", 200],
      ["06071", 20],
    ],
    harris2024: 0.5297,
    holder: "D",
    id: "CA-25",
    incumbent: "Raul Ruiz",
    left: { name: "Raul Ruiz", party: "D" },
    right: { name: "Joe Males", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06111", 725],
      ["06037", 275],
    ],
    harris2024: 0.5786,
    holder: "D",
    id: "CA-26",
    incumbent: "Julia Brownley",
    left: { name: "Jacqui Irwin", party: "D" },
    right: { name: "Samuel Gallucci", party: "R" },
    state: "CA",
  },
  {
    counties: [["06037", 1000]],
    harris2024: 0.5502,
    holder: "D",
    id: "CA-27",
    incumbent: "George Whitesides",
    left: { name: "George Whitesides", party: "D" },
    right: { name: "Jason Gibbs", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06037", 798],
      ["06071", 202],
    ],
    harris2024: 0.6307,
    holder: "D",
    id: "CA-28",
    incumbent: "Judy Chu",
    left: { name: "Judy Chu", party: "D" },
    right: { name: "April Verlato", party: "R" },
    state: "CA",
  },
  {
    counties: [["06037", 1000]],
    harris2024: 0.6735,
    holder: "D",
    id: "CA-29",
    incumbent: "Luz Rivas",
    left: { name: "Luz Maria Rivas", party: "D" },
    right: { name: "Angélica María Dueñas", party: "D" },
    state: "CA",
  },
  {
    counties: [["06037", 1000]],
    harris2024: 0.7072,
    holder: "D",
    id: "CA-30",
    incumbent: "Laura Friedman",
    left: { name: "Laura Friedman", party: "D" },
    right: { name: "Scott Meyers", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06037", 850],
      ["06071", 150],
    ],
    harris2024: 0.563,
    holder: "D",
    id: "CA-31",
    incumbent: "Gil Cisneros",
    left: { name: "Gil Cisneros", party: "D" },
    right: { name: "Eric Ching", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06037", 811],
      ["06111", 189],
    ],
    harris2024: 0.6287,
    holder: "D",
    id: "CA-32",
    incumbent: "Brad Sherman",
    left: { name: "Brad Sherman", party: "D" },
    right: { name: "Larry Thompson", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06071", 980],
      ["06065", 20],
    ],
    harris2024: 0.5504,
    holder: "D",
    id: "CA-33",
    incumbent: "Pete Aguilar",
    left: { name: "Pete Aguilar", party: "D" },
    right: { name: "Stephanie Vargas", party: "R" },
    state: "CA",
  },
  {
    counties: [["06037", 1000]],
    harris2024: 0.7652,
    holder: "D",
    id: "CA-34",
    incumbent: "Jimmy Gomez",
    left: { name: "Jimmy Gomez", party: "D" },
    right: { name: "Angela Gonzales-Torres", party: "D" },
    state: "CA",
  },
  {
    counties: [
      ["06071", 592],
      ["06065", 244],
      ["06037", 163],
    ],
    harris2024: 0.5402,
    holder: "D",
    id: "CA-35",
    incumbent: "Norma Torres",
    left: { name: "Norma Torres", party: "D" },
    right: { name: "Mike Cargile", party: "R" },
    state: "CA",
  },
  {
    counties: [["06037", 1000]],
    harris2024: 0.7021,
    holder: "D",
    id: "CA-36",
    incumbent: "Ted Lieu",
    left: { name: "Ted Lieu", party: "D" },
    right: { name: "Houston Brignano", party: "R" },
    state: "CA",
  },
  {
    counties: [["06037", 1000]],
    harris2024: 0.8115,
    holder: "D",
    id: "CA-37",
    incumbent: "Sydney Kamlager-Dove",
    left: { name: "Sydney Kamlager-Dove", party: "D" },
    right: { name: "Samantha Mota", party: "D" },
    state: "CA",
  },
  {
    counties: [
      ["06037", 734],
      ["06059", 266],
    ],
    harris2024: 0.5637,
    holder: "D",
    id: "CA-38",
    incumbent: "Linda Sanchez",
    left: { name: "Hilda Solis", party: "D" },
    right: { name: "Pedro Casas", party: "R" },
    state: "CA",
  },
  {
    counties: [["06065", 1000]],
    harris2024: 0.5489,
    holder: "D",
    id: "CA-39",
    incumbent: "Mark Takano",
    left: { name: "Mark Takano", party: "D" },
    right: { name: "Steve Manos", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06065", 633],
      ["06059", 367],
    ],
    harris2024: 0.437,
    holder: "R",
    id: "CA-40",
    incumbent: "Young Kim",
    left: { name: "Young Kim", party: "R" },
    right: { name: "Ken Calvert", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06037", 791],
      ["06059", 209],
    ],
    harris2024: 0.5732,
    holder: "R",
    id: "CA-41",
    incumbent: "Ken Calvert",
    left: { name: "Linda T. Sánchez", party: "D" },
    right: { name: "Mitch Clemmons", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06059", 623],
      ["06037", 377],
    ],
    harris2024: 0.5678,
    holder: "D",
    id: "CA-42",
    incumbent: "Robert Garcia",
    left: { name: "Robert Garcia", party: "D" },
    right: { name: "Brian Burley", party: "R" },
    state: "CA",
  },
  {
    counties: [["06037", 1000]],
    harris2024: 0.7529,
    holder: "D",
    id: "CA-43",
    incumbent: "Maxine Waters",
    left: { name: "Maxine Waters", party: "D" },
    right: { name: "Cristian Morales", party: "R" },
    state: "CA",
  },
  {
    counties: [["06037", 1000]],
    harris2024: 0.6816,
    holder: "D",
    id: "CA-44",
    incumbent: "Nanette Barragan",
    left: { name: "Nanette Barragán", party: "D" },
    right: { name: "Genevieve Angel", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06059", 799],
      ["06037", 201],
    ],
    harris2024: 0.5203,
    holder: "D",
    id: "CA-45",
    incumbent: "Derek Tran",
    left: { name: "Derek Tran", party: "D" },
    right: { name: "Chuong Vo", party: "R" },
    state: "CA",
  },
  {
    counties: [["06059", 1000]],
    harris2024: 0.5834,
    holder: "D",
    id: "CA-46",
    incumbent: "Lou Correa",
    left: { name: "Lou Correa", party: "D" },
    right: { name: "David Pan", party: "R" },
    state: "CA",
  },
  {
    counties: [["06059", 1000]],
    harris2024: 0.5523,
    holder: "D",
    id: "CA-47",
    incumbent: "Dave Min",
    left: { name: "Dave Min", party: "D" },
    right: { name: "Jenny Rae Le Roux", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06065", 505],
      ["06073", 495],
    ],
    harris2024: 0.5174,
    holder: "R",
    id: "CA-48",
    incumbent: "Darrell Issa",
    left: { name: "Marni von Wilpert", party: "D" },
    right: { name: "Jim Desmond", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["06073", 811],
      ["06059", 189],
    ],
    harris2024: 0.5624,
    holder: "D",
    id: "CA-49",
    incumbent: "Mike Levin",
    left: { name: "Mike Levin", party: "D" },
    right: { name: "Armen Kurdian", party: "R" },
    state: "CA",
  },
  {
    counties: [["06073", 1000]],
    harris2024: 0.5942,
    holder: "D",
    id: "CA-50",
    incumbent: "Scott Peters",
    left: { name: "Scott Peters", party: "D" },
    right: { name: "Steve Cohen", party: "R" },
    state: "CA",
  },
  {
    counties: [["06073", 1000]],
    harris2024: 0.594,
    holder: "D",
    id: "CA-51",
    incumbent: "Sara Jacobs",
    left: { name: "Sara Jacobs", party: "D" },
    right: { name: "Ricardo Cabrera", party: "R" },
    state: "CA",
  },
  {
    counties: [["06073", 1000]],
    harris2024: 0.5902,
    holder: "D",
    id: "CA-52",
    incumbent: "Juan Vargas",
    left: { name: "Juan C. Vargas", party: "D" },
    right: { name: "Jeff Belle", party: "R" },
    state: "CA",
  },
  {
    counties: [
      ["08031", 990],
      ["08005", 10],
    ],
    harris2024: 0.7881,
    holder: "D",
    id: "CO-01",
    incumbent: "Diana DeGette",
    left: { name: "Melat Kiros", party: "D" },
    right: { name: "Christy Peterson", party: "R" },
    state: "CO",
  },
  {
    counties: [
      ["08013", 454],
      ["08069", 328],
      ["08037", 52],
      ["08117", 41],
      ["08107", 38],
      ["08123", 35],
      ["08049", 23],
      ["08019", 14],
      ["08047", 10],
      ["08059", 3],
      ["08057", 2],
    ],
    harris2024: 0.7046,
    holder: "D",
    id: "CO-02",
    incumbent: "Joe Neguse",
    left: { name: "Joe Neguse", party: "D" },
    right: { name: "Kelley Dennison", party: "R" },
    state: "CO",
  },
  {
    counties: [
      ["08077", 225],
      ["08101", 209],
      ["08067", 88],
      ["08045", 75],
      ["08085", 63],
      ["08029", 48],
      ["08083", 37],
      ["08051", 27],
      ["08097", 27],
      ["08007", 23],
      ["08089", 22],
      ["08071", 19],
      ["08003", 18],
      ["08081", 16],
      ["08105", 15],
      ["08037", 13],
      ["08113", 12],
      ["08055", 11],
      ["08021", 10],
      ["08091", 10],
      ["08103", 9],
      ["08109", 8],
      ["08023", 5],
      ["08033", 3],
      ["08079", 2],
      ["08053", 1],
      ["08111", 1],
    ],
    harris2024: 0.4501,
    holder: "R",
    id: "CO-03",
    incumbent: "Jeff Hurd",
    left: { name: "Dwayne Romero", party: "D" },
    right: { name: "Jeff Hurd", party: "R" },
    state: "CO",
  },
  {
    counties: [
      ["08035", 521],
      ["08069", 152],
      ["08123", 93],
      ["08005", 46],
      ["08039", 44],
      ["08087", 29],
      ["08075", 22],
      ["08001", 17],
      ["08041", 11],
      ["08099", 11],
      ["08125", 10],
      ["08063", 8],
      ["08073", 6],
      ["08121", 6],
      ["08011", 5],
      ["08095", 5],
      ["08009", 4],
      ["08025", 4],
      ["08115", 3],
      ["08017", 2],
      ["08061", 2],
    ],
    harris2024: 0.4064,
    holder: "R",
    id: "CO-04",
    incumbent: "Lauren Boebert",
    left: { name: "Eileen Laubacher", party: "D" },
    right: { name: "Lauren Boebert", party: "R" },
    state: "CO",
  },
  {
    counties: [["08041", 1000]],
    harris2024: 0.4533,
    holder: "R",
    id: "CO-05",
    incumbent: "Jeff Crank",
    left: { name: "Jessica Killin", party: "D" },
    right: { name: "Jeff Crank", party: "R" },
    state: "CO",
  },
  {
    counties: [
      ["08005", 836],
      ["08059", 110],
      ["08001", 43],
      ["08035", 10],
      ["08031", 2],
    ],
    harris2024: 0.6018,
    holder: "D",
    id: "CO-06",
    incumbent: "Jason Crow",
    left: { name: "Jason Crow", party: "D" },
    right: { name: "Jason Ray Clark", party: "R" },
    state: "CO",
  },
  {
    counties: [
      ["08059", 720],
      ["08014", 105],
      ["08043", 57],
      ["08119", 37],
      ["08015", 32],
      ["08093", 27],
      ["08027", 9],
      ["08065", 9],
      ["08001", 4],
      ["08041", 1],
    ],
    harris2024: 0.5771,
    holder: "D",
    id: "CO-07",
    incumbent: "Brittany Pettersen",
    left: { name: "Brittany Pettersen", party: "D" },
    right: { name: "Timothy Bennett", party: "R" },
    state: "CO",
  },
  {
    counties: [
      ["08001", 606],
      ["08123", 354],
      ["08069", 40],
    ],
    harris2024: 0.4906,
    holder: "R",
    id: "CO-08",
    incumbent: "Gabe Evans",
    left: { name: "Manny Rutinel", party: "D" },
    right: { name: "Gabe Evans", party: "R" },
    state: "CO",
  },
  {
    counties: [
      ["09003", 857],
      ["09007", 75],
      ["09005", 68],
    ],
    harris2024: 0.6163,
    holder: "D",
    id: "CT-01",
    incumbent: "John Larson",
    left: { name: "Luke Bronin", party: "D" },
    right: { name: "Amy Chai", party: "R" },
    state: "CT",
  },
  {
    counties: [
      ["09011", 354],
      ["09013", 210],
      ["09015", 146],
      ["09007", 137],
      ["09003", 122],
      ["09009", 31],
    ],
    harris2024: 0.5393,
    holder: "D",
    id: "CT-02",
    incumbent: "Joe Courtney",
    left: { name: "Joe Courtney", party: "D" },
    right: { name: "George Austin", party: "R" },
    state: "CT",
  },
  {
    counties: [
      ["09009", 823],
      ["09001", 123],
      ["09007", 54],
    ],
    harris2024: 0.5717,
    holder: "D",
    id: "CT-03",
    incumbent: "Rosa DeLauro",
    left: { name: "Rosa L. DeLauro", party: "D" },
    right: { name: "Christopher Lancia", party: "R" },
    state: "CT",
  },
  {
    counties: [
      ["09001", 975],
      ["09009", 25],
    ],
    harris2024: 0.6186,
    holder: "D",
    id: "CT-04",
    incumbent: "Jim Himes",
    left: { name: "Jim Himes", party: "D" },
    right: { name: "Michael Goldstein", party: "R" },
    state: "CT",
  },
  {
    counties: [
      ["09009", 277],
      ["09003", 252],
      ["09005", 238],
      ["09001", 232],
    ],
    harris2024: 0.5284,
    holder: "D",
    id: "CT-05",
    incumbent: "Jahana Hayes",
    left: { name: "Jahana Hayes", party: "D" },
    right: { name: "Chris Shea", party: "R" },
    state: "CT",
  },
  {
    counties: [
      ["10003", 539],
      ["10005", 289],
      ["10001", 172],
    ],
    harris2024: 0.5748,
    holder: "D",
    id: "DE-AL",
    incumbent: "Sarah McBride",
    left: { name: "Sarah McBride", party: "D" },
    right: { name: "Joseph Arminio", party: "R" },
    state: "DE",
  },
  {
    counties: [
      ["12033", 386],
      ["12091", 270],
      ["12113", 267],
      ["12131", 78],
    ],
    harris2024: 0.3121,
    holder: "R",
    id: "FL-01",
    incumbent: "Jimmy Patronis",
    left: { name: "Gay Valimont", party: "D" },
    right: { name: "Jimmy Patronis", party: "R" },
    state: "FL",
  },
  {
    counties: [
      ["12073", 382],
      ["12005", 238],
      ["12063", 54],
      ["12039", 53],
      ["12129", 48],
      ["12131", 41],
      ["12133", 31],
      ["12123", 24],
      ["12059", 22],
      ["12079", 22],
      ["12045", 21],
      ["12065", 21],
      ["12013", 16],
      ["12037", 16],
      ["12077", 9],
    ],
    harris2024: 0.4091,
    holder: "R",
    id: "FL-02",
    incumbent: "Neal Dunn",
    left: { name: "Amanda Green", party: "D" },
    right: { name: "Austin Rogers", party: "R" },
    state: "FL",
  },
  {
    counties: [
      ["12001", 342],
      ["12083", 300],
      ["12023", 84],
      ["12075", 61],
      ["12121", 55],
      ["12003", 37],
      ["12007", 35],
      ["12041", 27],
      ["12029", 20],
      ["12125", 16],
      ["12047", 14],
      ["12067", 9],
    ],
    harris2024: 0.3934,
    holder: "R",
    id: "FL-03",
    incumbent: "Kat Cammack",
    left: { name: "Seth Harp", party: "D" },
    right: { name: "Kat Cammack", party: "R" },
    state: "FL",
  },
  {
    counties: [
      ["12031", 515],
      ["12019", 319],
      ["12089", 165],
    ],
    harris2024: 0.4402,
    holder: "R",
    id: "FL-04",
    incumbent: "Aaron Bean",
    left: { name: "LaShonda L.J. Holloway", party: "D" },
    right: { name: "Aaron Bean", party: "R" },
    state: "FL",
  },
  {
    counties: [
      ["12031", 611],
      ["12109", 389],
    ],
    harris2024: 0.3916,
    holder: "R",
    id: "FL-05",
    incumbent: "John Rutherford",
    left: { name: "Rachel Grage", party: "D" },
    right: { name: "John Rutherford", party: "R" },
    state: "FL",
  },
  {
    counties: [
      ["12127", 311],
      ["12083", 213],
      ["12035", 181],
      ["12069", 150],
      ["12107", 82],
      ["12109", 63],
    ],
    harris2024: 0.3485,
    holder: "R",
    id: "FL-06",
    incumbent: "Randy Fine",
    left: { name: "Eric Yonce", party: "D" },
    right: { name: "Randy Fine", party: "R" },
    state: "FL",
  },
  {
    counties: [
      ["12117", 594],
      ["12127", 406],
    ],
    harris2024: 0.4369,
    holder: "R",
    id: "FL-07",
    incumbent: "Cory Mills",
    left: { name: "Bale Dalton", party: "D" },
    right: { name: "Ryan Elijah", party: "R" },
    state: "FL",
  },
  {
    counties: [
      ["12009", 840],
      ["12095", 160],
    ],
    harris2024: 0.418,
    holder: "R",
    id: "FL-08",
    incumbent: "Mike Haridopolos",
    left: { name: "Jennifer Jenkins", party: "D" },
    right: { name: "Mike Haridopolos", party: "R" },
    state: "FL",
  },
  {
    counties: [
      ["12097", 376],
      ["12061", 265],
      ["12095", 150],
      ["12055", 139],
      ["12093", 43],
      ["12105", 14],
      ["12043", 14],
    ],
    harris2024: 0.4103,
    holder: "D",
    id: "FL-09",
    incumbent: "Darren Soto",
    left: { name: "Darren Soto", party: "D" },
    right: { name: "Dan Green", party: "R" },
    state: "FL",
  },
  {
    counties: [["12095", 1000]],
    harris2024: 0.6215,
    holder: "D",
    id: "FL-10",
    incumbent: "Maxwell Frost",
    left: { name: "Maxwell Alejandro Frost", party: "D" },
    right: null,
    state: "FL",
  },
  {
    counties: [
      ["12095", 408],
      ["12069", 358],
      ["12119", 234],
    ],
    harris2024: 0.4208,
    holder: "R",
    id: "FL-11",
    incumbent: "Daniel Webster",
    left: { name: "James Pericola", party: "D" },
    right: { name: "Joe Strada", party: "R" },
    state: "FL",
  },
  {
    counties: [
      ["12101", 522],
      ["12057", 478],
    ],
    harris2024: 0.4222,
    holder: "R",
    id: "FL-12",
    incumbent: "Gus Bilirakis",
    left: { name: "Kimberly Overman", party: "D" },
    right: { name: "Gus M. Bilirakis", party: "R" },
    state: "FL",
  },
  {
    counties: [
      ["12103", 927],
      ["12101", 73],
    ],
    harris2024: 0.4327,
    holder: "R",
    id: "FL-13",
    incumbent: "Anna Paulina Luna",
    left: { name: "Leela Gray", party: "D" },
    right: { name: "Anna Paulina Luna", party: "R" },
    state: "FL",
  },
  {
    counties: [["12057", 1000]],
    harris2024: 0.4469,
    holder: "D",
    id: "FL-14",
    incumbent: "Kathy Castor",
    left: { name: "Kathy Castor", party: "D" },
    right: { name: "Mike Beltran", party: "R" },
    state: "FL",
  },
  {
    counties: [
      ["12053", 278],
      ["12057", 253],
      ["12017", 246],
      ["12101", 223],
    ],
    harris2024: 0.3995,
    holder: "R",
    id: "FL-15",
    incumbent: "Laurel Lee",
    left: { name: "Robert People", party: "D" },
    right: { name: "Laurel Lee", party: "R" },
    state: "FL",
  },
  {
    counties: [
      ["12081", 531],
      ["12103", 323],
      ["12115", 86],
      ["12027", 29],
      ["12049", 19],
      ["12105", 12],
    ],
    harris2024: 0.4309,
    holder: "R",
    id: "FL-16",
    incumbent: "Vern Buchanan",
    left: { name: "Kelly Kirschner", party: "D" },
    right: { name: "Sydney Gruters", party: "R" },
    state: "FL",
  },
  {
    counties: [
      ["12115", 533],
      ["12015", 274],
      ["12071", 194],
    ],
    harris2024: 0.3888,
    holder: "R",
    id: "FL-17",
    incumbent: "Greg Steube",
    left: { name: "Matthew Montavon", party: "D" },
    right: { name: "Greg Steube", party: "R" },
    state: "FL",
  },
  {
    counties: [
      ["12105", 913],
      ["12097", 87],
    ],
    harris2024: 0.4145,
    holder: "R",
    id: "FL-18",
    incumbent: "Scott Franklin",
    left: { name: "Curtis Gibson", party: "D" },
    right: { name: "Scott Franklin", party: "R" },
    state: "FL",
  },
  {
    counties: [
      ["12071", 723],
      ["12021", 277],
    ],
    harris2024: 0.3479,
    holder: "R",
    id: "FL-19",
    incumbent: "Byron Donalds",
    left: { name: "Victor Arias", party: "D" },
    right: { name: "Jim Schwartzel", party: "R" },
    state: "FL",
  },
  {
    counties: [["12011", 1000]],
    harris2024: 0.6875,
    holder: "D",
    id: "FL-20",
    incumbent: "Vacant (Cherfilus-McCormick)",
    left: { name: "Debbie Wasserman Schultz", party: "D" },
    right: { name: "Brent Andersen", party: "R" },
    state: "FL",
  },
  {
    counties: [
      ["12111", 413],
      ["12099", 368],
      ["12085", 219],
    ],
    harris2024: 0.418,
    holder: "R",
    id: "FL-21",
    incumbent: "Brian Mast",
    left: { name: "James Martin", party: "D" },
    right: { name: "Brian Mast", party: "R" },
    state: "FL",
  },
  {
    counties: [
      ["12011", 423],
      ["12099", 290],
      ["12021", 253],
      ["12051", 34],
    ],
    harris2024: 0.4481,
    holder: "D",
    id: "FL-22",
    incumbent: "Lois Frankel",
    left: { name: "Pia Dandiya", party: "D" },
    right: { name: "Casey Askar", party: "R" },
    state: "FL",
  },
  {
    counties: [["12099", 1000]],
    harris2024: 0.5693,
    holder: "D",
    id: "FL-23",
    incumbent: "Jared Moskowitz",
    left: { name: "Lois Frankel", party: "D" },
    right: { name: "Deborah Adeimy", party: "R" },
    state: "FL",
  },
  {
    counties: [
      ["12086", 681],
      ["12011", 319],
    ],
    harris2024: 0.6952,
    holder: "D",
    id: "FL-24",
    incumbent: "Frederica Wilson",
    left: { name: "Oliver Gilbert", party: "D" },
    right: { name: "Te Brown", party: "R" },
    state: "FL",
  },
  {
    counties: [
      ["12011", 392],
      ["12099", 347],
      ["12086", 262],
    ],
    harris2024: 0.4539,
    holder: "D",
    id: "FL-25",
    incumbent: "Debbie Wasserman Schultz",
    left: { name: "Jared Evan Moskowitz", party: "D" },
    right: { name: "Scott Singer", party: "R" },
    state: "FL",
  },
  {
    counties: [
      ["12086", 545],
      ["12011", 455],
    ],
    harris2024: 0.4073,
    holder: "R",
    id: "FL-26",
    incumbent: "Mario Diaz-Balart",
    left: { name: "Nicole Locklin", party: "D" },
    right: { name: "Mario Diaz-Balart", party: "R" },
    state: "FL",
  },
  {
    counties: [["12086", 1000]],
    harris2024: 0.4265,
    holder: "R",
    id: "FL-27",
    incumbent: "Maria Elvira Salazar",
    left: { name: "Eliott Rodriguez", party: "D" },
    right: { name: "Maria Elvira Salazar", party: "R" },
    state: "FL",
  },
  {
    counties: [
      ["12086", 868],
      ["12087", 132],
    ],
    harris2024: 0.3719,
    holder: "R",
    id: "FL-28",
    incumbent: "Carlos Gimenez",
    left: { name: "Phil Ehr", party: "D" },
    right: { name: "Carlos Giménez", party: "R" },
    state: "FL",
  },
  {
    counties: [
      ["13051", 388],
      ["13127", 121],
      ["13039", 73],
      ["13103", 72],
      ["13029", 68],
      ["13179", 63],
      ["13299", 40],
      ["13305", 37],
      ["13229", 27],
      ["13001", 23],
      ["13025", 23],
      ["13191", 20],
      ["13183", 19],
      ["13005", 13],
      ["13049", 13],
    ],
    harris2024: 0.4205,
    holder: "R",
    id: "GA-01",
    incumbent: "Buddy Carter",
    left: { name: "Amanda Hollowell", party: "D" },
    right: { name: "James Kingston", party: "R" },
    state: "GA",
  },
  {
    counties: [
      ["13215", 207],
      ["13021", 136],
      ["13095", 107],
      ["13275", 70],
      ["13153", 59],
      ["13177", 56],
      ["13225", 43],
      ["13261", 38],
      ["13087", 37],
      ["13131", 34],
      ["13205", 28],
      ["13079", 20],
      ["13099", 15],
      ["13193", 15],
      ["13273", 14],
      ["13093", 13],
      ["13253", 13],
      ["13269", 13],
      ["13197", 11],
      ["13263", 11],
      ["13201", 9],
      ["13243", 9],
      ["13249", 8],
      ["13037", 6],
      ["13259", 6],
      ["13007", 5],
      ["13053", 5],
      ["13061", 5],
      ["13239", 4],
      ["13307", 4],
    ],
    harris2024: 0.5383,
    holder: "D",
    id: "GA-02",
    incumbent: "Sanford Bishop",
    left: { name: "Sanford Bishop", party: "D" },
    right: { name: "Matt Day", party: "R" },
    state: "GA",
  },
  {
    counties: [
      ["13077", 205],
      ["13113", 154],
      ["13045", 145],
      ["13255", 79],
      ["13285", 75],
      ["13097", 55],
      ["13145", 53],
      ["13143", 39],
      ["13215", 36],
      ["13293", 33],
      ["13231", 30],
      ["13151", 29],
      ["13199", 28],
      ["13171", 25],
      ["13149", 15],
    ],
    harris2024: 0.3506,
    holder: "R",
    id: "GA-03",
    incumbent: "Brian Jack",
    left: { name: "Maura Keller", party: "D" },
    right: { name: "Brian Jack", party: "R" },
    state: "GA",
  },
  {
    counties: [
      ["13089", 732],
      ["13135", 268],
    ],
    harris2024: 0.7652,
    holder: "D",
    id: "GA-04",
    incumbent: "Hank Johnson",
    left: { name: "Hank Johnson", party: "D" },
    right: { name: "James Duffie", party: "R" },
    state: "GA",
  },
  {
    counties: [
      ["13121", 474],
      ["13089", 367],
      ["13063", 159],
    ],
    harris2024: 0.8617,
    holder: "D",
    id: "GA-05",
    incumbent: "Nikema Williams",
    left: { name: "Nikema Williams", party: "D" },
    right: { name: "John Salvesen", party: "R" },
    state: "GA",
  },
  {
    counties: [
      ["13121", 484],
      ["13067", 362],
      ["13097", 127],
      ["13113", 27],
    ],
    harris2024: 0.7517,
    holder: "D",
    id: "GA-06",
    incumbent: "Lucy McBath",
    left: { name: "Lucy McBath", party: "D" },
    right: { name: "Kevin Martin", party: "R" },
    state: "GA",
  },
  {
    counties: [
      ["13121", 431],
      ["13117", 319],
      ["13139", 94],
      ["13057", 69],
      ["13085", 45],
      ["13187", 41],
    ],
    harris2024: 0.3885,
    holder: "R",
    id: "GA-07",
    incumbent: "Rich McCormick",
    left: { name: "Tony Kozycki", party: "D" },
    right: { name: "Rich McCormick", party: "R" },
    state: "GA",
  },
  {
    counties: [
      ["13153", 182],
      ["13185", 138],
      ["13021", 75],
      ["13009", 54],
      ["13207", 51],
      ["13277", 49],
      ["13071", 48],
      ["13169", 47],
      ["13069", 45],
      ["13321", 27],
      ["13091", 24],
      ["13019", 23],
      ["13081", 23],
      ["13027", 21],
      ["13075", 21],
      ["13017", 19],
      ["13023", 17],
      ["13161", 17],
      ["13319", 14],
      ["13155", 13],
      ["13235", 13],
      ["13289", 13],
      ["13271", 12],
      ["13173", 11],
      ["13287", 11],
      ["13315", 10],
      ["13003", 9],
      ["13065", 8],
      ["13101", 4],
    ],
    harris2024: 0.3464,
    holder: "R",
    id: "GA-08",
    incumbent: "Austin Scott",
    left: { name: "Kelly Esti", party: "D" },
    right: { name: "Austin Scott", party: "R" },
    state: "GA",
  },
  {
    counties: [
      ["13135", 392],
      ["13139", 153],
      ["13157", 118],
      ["13137", 58],
      ["13123", 46],
      ["13291", 45],
      ["13311", 42],
      ["13111", 40],
      ["13257", 33],
      ["13011", 26],
      ["13241", 26],
      ["13281", 22],
    ],
    harris2024: 0.3283,
    holder: "R",
    id: "GA-09",
    incumbent: "Andrew Clyde",
    left: { name: "Caitlyn Gegen", party: "D" },
    right: { name: "Andrew Clyde", party: "R" },
    state: "GA",
  },
  {
    counties: [
      ["13151", 154],
      ["13297", 141],
      ["13059", 128],
      ["13013", 106],
      ["13219", 66],
      ["13217", 61],
      ["13195", 41],
      ["13135", 35],
      ["13147", 35],
      ["13211", 32],
      ["13035", 31],
      ["13133", 31],
      ["13237", 31],
      ["13119", 29],
      ["13105", 23],
      ["13159", 22],
      ["13221", 21],
      ["13141", 10],
      ["13265", 2],
      ["13317", 2],
    ],
    harris2024: 0.3954,
    holder: "R",
    id: "GA-10",
    incumbent: "Mike Collins",
    left: { name: "Pamela DeLancy", party: "D" },
    right: { name: "Houston Gaines", party: "R" },
    state: "GA",
  },
  {
    counties: [
      ["13067", 432],
      ["13057", 315],
      ["13015", 137],
      ["13129", 66],
      ["13227", 50],
    ],
    harris2024: 0.3822,
    holder: "R",
    id: "GA-11",
    incumbent: "Barry Loudermilk",
    left: { name: "Chris Harden", party: "D" },
    right: { name: "John Cowan", party: "R" },
    state: "GA",
  },
  {
    counties: [
      ["13073", 246],
      ["13245", 239],
      ["13031", 94],
      ["13175", 67],
      ["13033", 32],
      ["13279", 31],
      ["13189", 30],
      ["13103", 29],
      ["13107", 28],
      ["13303", 27],
      ["13267", 24],
      ["13163", 21],
      ["13251", 20],
      ["13181", 14],
      ["13043", 13],
      ["13109", 12],
      ["13317", 12],
      ["13167", 11],
      ["13209", 11],
      ["13165", 10],
      ["13283", 9],
      ["13301", 7],
      ["13309", 7],
      ["13125", 5],
    ],
    harris2024: 0.4288,
    holder: "R",
    id: "GA-12",
    incumbent: "Rick Allen",
    left: { name: "Ceretta Smith", party: "D" },
    right: { name: "Rick Allen", party: "R" },
    state: "GA",
  },
  {
    counties: [
      ["13135", 456],
      ["13063", 153],
      ["13151", 145],
      ["13247", 124],
      ["13217", 93],
      ["13089", 28],
    ],
    harris2024: 0.7136,
    holder: "D",
    id: "GA-13",
    incumbent: "Everton Blair",
    left: { name: "Jasmine Clark", party: "D" },
    right: { name: "Jonathan Chavez", party: "R" },
    state: "GA",
  },
  {
    counties: [
      ["13223", 247],
      ["13067", 217],
      ["13115", 116],
      ["13313", 103],
      ["13047", 91],
      ["13295", 83],
      ["13233", 50],
      ["13213", 45],
      ["13055", 28],
      ["13083", 21],
    ],
    harris2024: 0.3149,
    holder: "R",
    id: "GA-14",
    incumbent: "Clay Fuller",
    left: { name: "Shawn Harris", party: "D" },
    right: { name: "Clayton Fuller", party: "R" },
    state: "GA",
  },
  {
    counties: [["15003", 1000]],
    harris2024: 0.6258,
    holder: "D",
    id: "HI-01",
    incumbent: "Ed Case",
    left: { name: "Ed Case", party: "D" },
    right: { name: "Adriel Lam", party: "R" },
    state: "HI",
  },
  {
    counties: [
      ["15003", 344],
      ["15001", 309],
      ["15009", 235],
      ["15007", 112],
    ],
    harris2024: 0.6103,
    holder: "D",
    id: "HI-02",
    incumbent: "Jill Tokuda",
    left: { name: "Jill Tokuda", party: "D" },
    right: { name: "Brenton Awa", party: "R" },
    state: "HI",
  },
  {
    counties: [
      ["19163", 212],
      ["19103", 203],
      ["19181", 77],
      ["19045", 56],
      ["19099", 48],
      ["19139", 47],
      ["19125", 46],
      ["19057", 45],
      ["19111", 38],
      ["19183", 27],
      ["19105", 26],
      ["19123", 26],
      ["19031", 25],
      ["19097", 25],
      ["19087", 23],
      ["19095", 23],
      ["19101", 20],
      ["19107", 12],
      ["19115", 12],
      ["19177", 9],
    ],
    harris2024: 0.457,
    holder: "R",
    id: "IA-01",
    incumbent: "Mariannette Miller-Meeks",
    left: { name: "Christina Bohannan", party: "D" },
    right: { name: "Mariannette Miller-Meeks", party: "R" },
    state: "IA",
  },
  {
    counties: [
      ["19113", 292],
      ["19013", 149],
      ["19061", 125],
      ["19033", 55],
      ["19017", 35],
      ["19011", 34],
      ["19191", 28],
      ["19019", 26],
      ["19055", 24],
      ["19157", 24],
      ["19065", 23],
      ["19043", 22],
      ["19083", 20],
      ["19171", 20],
      ["19023", 19],
      ["19067", 18],
      ["19005", 17],
      ["19075", 17],
      ["19037", 15],
      ["19131", 14],
      ["19089", 12],
      ["19195", 10],
    ],
    harris2024: 0.4494,
    holder: "R",
    id: "IA-02",
    incumbent: "Ashley Hinson",
    left: { name: "Lindsay James", party: "D" },
    right: { name: "Joe Mitchell", party: "R" },
    state: "IA",
  },
  {
    counties: [
      ["19153", 605],
      ["19049", 148],
      ["19179", 35],
      ["19121", 24],
      ["19029", 17],
      ["19145", 17],
      ["19007", 15],
      ["19077", 15],
      ["19175", 14],
      ["19073", 12],
      ["19137", 12],
      ["19039", 11],
      ["19117", 11],
      ["19001", 10],
      ["19135", 10],
      ["19051", 9],
      ["19053", 9],
      ["19173", 7],
      ["19185", 7],
      ["19159", 6],
      ["19003", 5],
    ],
    harris2024: 0.4777,
    holder: "R",
    id: "IA-03",
    incumbent: "Zach Nunn",
    left: { name: "Sarah Trone Garriott", party: "D" },
    right: { name: "Zach Nunn", party: "R" },
    state: "IA",
  },
  {
    counties: [
      ["19169", 126],
      ["19155", 113],
      ["19193", 109],
      ["19167", 48],
      ["19127", 44],
      ["19187", 43],
      ["19015", 39],
      ["19149", 36],
      ["19059", 29],
      ["19027", 28],
      ["19041", 22],
      ["19109", 21],
      ["19129", 21],
      ["19085", 20],
      ["19021", 19],
      ["19079", 19],
      ["19141", 19],
      ["19119", 18],
      ["19047", 17],
      ["19165", 17],
      ["19035", 16],
      ["19081", 15],
      ["19197", 15],
      ["19161", 14],
      ["19189", 14],
      ["19025", 13],
      ["19091", 13],
      ["19147", 13],
      ["19063", 12],
      ["19069", 12],
      ["19133", 12],
      ["19071", 10],
      ["19093", 9],
      ["19151", 9],
      ["19009", 8],
      ["19143", 8],
    ],
    harris2024: 0.3405,
    holder: "R",
    id: "IA-04",
    incumbent: "Randy Feenstra",
    left: { name: "Dave Dawson", party: "D" },
    right: { name: "Chris McGowan", party: "R" },
    state: "IA",
  },
  {
    counties: [
      ["16001", 275],
      ["16027", 209],
      ["16055", 200],
      ["16017", 62],
      ["16057", 42],
      ["16069", 42],
      ["16075", 24],
      ["16045", 22],
      ["16049", 20],
      ["16021", 15],
      ["16085", 15],
      ["16079", 13],
      ["16087", 12],
      ["16009", 11],
      ["16015", 10],
      ["16073", 10],
      ["16035", 9],
      ["16003", 6],
      ["16061", 4],
    ],
    harris2024: 0.269,
    holder: "R",
    id: "ID-01",
    incumbent: "Russ Fulcher",
    left: { name: "Kaylee Peterson", party: "D" },
    right: { name: "Russ Fulcher", party: "R" },
    state: "ID",
  },
  {
    counties: [
      ["16001", 319],
      ["16019", 134],
      ["16005", 95],
      ["16083", 88],
      ["16011", 49],
      ["16065", 41],
      ["16051", 37],
      ["16013", 31],
      ["16039", 25],
      ["16031", 23],
      ["16053", 19],
      ["16067", 19],
      ["16041", 17],
      ["16043", 16],
      ["16081", 16],
      ["16047", 14],
      ["16059", 12],
      ["16007", 8],
      ["16029", 8],
      ["16077", 7],
      ["16037", 6],
      ["16071", 6],
      ["16063", 5],
      ["16023", 4],
      ["16025", 2],
      ["16033", 1],
    ],
    harris2024: 0.3622,
    holder: "R",
    id: "ID-02",
    incumbent: "Mike Simpson",
    left: { name: "Elinor Gilbreath", party: "D" },
    right: { name: "Michael K. Simpson", party: "R" },
    state: "ID",
  },
  {
    counties: [
      ["17031", 609],
      ["17197", 335],
      ["17091", 55],
    ],
    harris2024: 0.6623,
    holder: "D",
    id: "IL-01",
    incumbent: "Jonathan Jackson",
    left: { name: "Jonathan Jackson", party: "D" },
    right: { name: "Christian Maxwell", party: "R" },
    state: "IL",
  },
  {
    counties: [
      ["17031", 615],
      ["17091", 99],
      ["17183", 86],
      ["17197", 77],
      ["17075", 45],
      ["17105", 42],
      ["17019", 20],
      ["17053", 17],
    ],
    harris2024: 0.6679,
    holder: "D",
    id: "IL-02",
    incumbent: "Robin Kelly",
    left: { name: "Donna Miller", party: "D" },
    right: { name: "Mike Noack", party: "R" },
    state: "IL",
  },
  {
    counties: [
      ["17031", 679],
      ["17043", 321],
    ],
    harris2024: 0.6592,
    holder: "D",
    id: "IL-03",
    incumbent: "Delia Ramirez",
    left: { name: "Delia Ramirez", party: "D" },
    right: { name: "Angel Oakley", party: "R" },
    state: "IL",
  },
  {
    counties: [
      ["17031", 895],
      ["17043", 105],
    ],
    harris2024: 0.6438,
    holder: "D",
    id: "IL-04",
    incumbent: "Chuy Garcia",
    left: { name: "Patty Garcia", party: "D" },
    right: { name: "Lupe Castillo", party: "R" },
    state: "IL",
  },
  {
    counties: [
      ["17031", 939],
      ["17097", 61],
    ],
    harris2024: 0.6878,
    holder: "D",
    id: "IL-05",
    incumbent: "Mike Quigley",
    left: { name: "Mike Quigley", party: "D" },
    right: { name: "Tom Hanson", party: "R" },
    state: "IL",
  },
  {
    counties: [
      ["17031", 552],
      ["17043", 448],
    ],
    harris2024: 0.5279,
    holder: "D",
    id: "IL-06",
    incumbent: "Sean Casten",
    left: { name: "Sean Casten", party: "D" },
    right: { name: "Niki Conforti", party: "R" },
    state: "IL",
  },
  {
    counties: [["17031", 1000]],
    harris2024: 0.8308,
    holder: "D",
    id: "IL-07",
    incumbent: "Danny Davis",
    left: { name: "La Shawn Ford", party: "D" },
    right: { name: "Chad Koppie", party: "R" },
    state: "IL",
  },
  {
    counties: [
      ["17031", 454],
      ["17089", 311],
      ["17043", 235],
    ],
    harris2024: 0.535,
    holder: "D",
    id: "IL-08",
    incumbent: "Raja Krishnamoorthi",
    left: { name: "Melissa Bean", party: "D" },
    right: { name: "Jennifer Davis", party: "R" },
    state: "IL",
  },
  {
    counties: [
      ["17031", 798],
      ["17111", 133],
      ["17097", 69],
    ],
    harris2024: 0.6849,
    holder: "D",
    id: "IL-09",
    incumbent: "Jan Schakowsky",
    left: { name: "Daniel K. Biss", party: "D" },
    right: { name: "John Elleson", party: "R" },
    state: "IL",
  },
  {
    counties: [
      ["17097", 764],
      ["17031", 159],
      ["17111", 76],
    ],
    harris2024: 0.6117,
    holder: "D",
    id: "IL-10",
    incumbent: "Brad Schneider",
    left: { name: "Brad Schneider", party: "D" },
    right: { name: "Carl Lambrecht", party: "R" },
    state: "IL",
  },
  {
    counties: [
      ["17043", 294],
      ["17089", 288],
      ["17111", 235],
      ["17197", 96],
      ["17097", 30],
      ["17007", 27],
      ["17031", 16],
      ["17037", 14],
    ],
    harris2024: 0.558,
    holder: "D",
    id: "IL-11",
    incumbent: "Bill Foster",
    left: { name: "Bill Foster", party: "D" },
    right: { name: "Jeffrey Walter", party: "R" },
    state: "IL",
  },
  {
    counties: [
      ["17163", 133],
      ["17199", 89],
      ["17077", 60],
      ["17133", 56],
      ["17027", 52],
      ["17049", 51],
      ["17055", 47],
      ["17081", 45],
      ["17121", 45],
      ["17157", 38],
      ["17165", 28],
      ["17145", 25],
      ["17033", 24],
      ["17023", 22],
      ["17181", 22],
      ["17191", 22],
      ["17159", 21],
      ["17189", 20],
      ["17193", 19],
      ["17025", 18],
      ["17127", 18],
      ["17029", 17],
      ["17087", 16],
      ["17101", 16],
      ["17035", 15],
      ["17079", 15],
      ["17185", 14],
      ["17065", 11],
      ["17047", 9],
      ["17059", 7],
      ["17003", 6],
      ["17151", 6],
      ["17153", 6],
      ["17069", 5],
    ],
    harris2024: 0.2796,
    holder: "R",
    id: "IL-12",
    incumbent: "Mike Bost",
    left: { name: "Julie Fortier", party: "D" },
    right: { name: "Mike Bost", party: "R" },
    state: "IL",
  },
  {
    counties: [
      ["17119", 251],
      ["17167", 213],
      ["17163", 211],
      ["17019", 183],
      ["17117", 71],
      ["17115", 53],
      ["17147", 17],
    ],
    harris2024: 0.5532,
    holder: "D",
    id: "IL-13",
    incumbent: "Nikki Budzinski",
    left: { name: "Nikki Budzinski", party: "D" },
    right: { name: "Jeff Wilson", party: "R" },
    state: "IL",
  },
  {
    counties: [
      ["17197", 469],
      ["17093", 197],
      ["17099", 125],
      ["17037", 120],
      ["17089", 66],
      ["17011", 17],
      ["17155", 7],
    ],
    harris2024: 0.5263,
    holder: "D",
    id: "IL-14",
    incumbent: "Lauren Underwood",
    left: { name: "Lauren Underwood", party: "D" },
    right: { name: "James Marter", party: "R" },
    state: "IL",
  },
  {
    counties: [
      ["17119", 129],
      ["17001", 83],
      ["17167", 74],
      ["17115", 72],
      ["17019", 57],
      ["17021", 41],
      ["17029", 40],
      ["17137", 38],
      ["17135", 35],
      ["17107", 33],
      ["17083", 31],
      ["17173", 31],
      ["17051", 25],
      ["17067", 24],
      ["17041", 22],
      ["17005", 21],
      ["17045", 21],
      ["17039", 20],
      ["17149", 20],
      ["17125", 17],
      ["17109", 17],
      ["17129", 17],
      ["17139", 17],
      ["17061", 16],
      ["17017", 14],
      ["17131", 11],
      ["17057", 10],
      ["17147", 10],
      ["17169", 10],
      ["17183", 10],
      ["17071", 9],
      ["17013", 7],
      ["17171", 7],
      ["17187", 7],
      ["17009", 6],
    ],
    harris2024: 0.2978,
    holder: "R",
    id: "IL-15",
    incumbent: "Mary Miller",
    left: { name: "Jennifer Todd", party: "D" },
    right: { name: "Mary Miller", party: "R" },
    state: "IL",
  },
  {
    counties: [
      ["17201", 173],
      ["17179", 160],
      ["17113", 121],
      ["17143", 78],
      ["17063", 68],
      ["17141", 66],
      ["17203", 54],
      ["17103", 41],
      ["17073", 40],
      ["17007", 37],
      ["17085", 32],
      ["17011", 27],
      ["17099", 27],
      ["17123", 16],
      ["17177", 16],
      ["17111", 14],
      ["17105", 10],
      ["17175", 7],
      ["17037", 5],
      ["17053", 4],
      ["17155", 3],
    ],
    harris2024: 0.3848,
    holder: "R",
    id: "IL-16",
    incumbent: "Darin LaHood",
    left: { name: "Paul Nolley", party: "D" },
    right: { name: "Darin LaHood", party: "R" },
    state: "IL",
  },
  {
    counties: [
      ["17161", 200],
      ["17201", 169],
      ["17143", 152],
      ["17113", 123],
      ["17195", 84],
      ["17095", 70],
      ["17177", 46],
      ["17057", 39],
      ["17073", 30],
      ["17015", 25],
      ["17109", 17],
      ["17179", 17],
      ["17187", 15],
      ["17131", 13],
    ],
    harris2024: 0.5241,
    holder: "D",
    id: "IL-17",
    incumbent: "Eric Sorensen",
    left: { name: "Eric Sorensen", party: "D" },
    right: { name: "Dillan Vancil", party: "R" },
    state: "IL",
  },
  {
    counties: [
      ["18089", 640],
      ["18127", 259],
      ["18091", 100],
    ],
    harris2024: 0.502,
    holder: "D",
    id: "IN-01",
    incumbent: "Frank Mrvan",
    left: { name: "Frank Mrvan", party: "D" },
    right: { name: "Barb Regnitz", party: "R" },
    state: "IN",
  },
  {
    counties: [
      ["18141", 369],
      ["18039", 233],
      ["18085", 87],
      ["18099", 65],
      ["18091", 49],
      ["18103", 47],
      ["18169", 47],
      ["18149", 35],
      ["18049", 30],
      ["18017", 20],
      ["18131", 19],
    ],
    harris2024: 0.3654,
    holder: "R",
    id: "IN-02",
    incumbent: "Rudy Yakym",
    left: { name: "Jamee Decio", party: "D" },
    right: { name: "Rudy Yakym", party: "R" },
    state: "IN",
  },
  {
    counties: [
      ["18003", 507],
      ["18033", 62],
      ["18113", 59],
      ["18069", 55],
      ["18183", 55],
      ["18151", 51],
      ["18179", 44],
      ["18001", 43],
      ["18087", 32],
      ["18085", 27],
      ["18075", 25],
      ["18135", 22],
      ["18009", 16],
    ],
    harris2024: 0.3414,
    holder: "R",
    id: "IN-03",
    incumbent: "Marlin Stutzman",
    left: { name: "Kelly Thompson", party: "D" },
    right: { name: "Marlin A. Stutzman", party: "R" },
    state: "IN",
  },
  {
    counties: [
      ["18063", 249],
      ["18157", 200],
      ["18011", 120],
      ["18109", 106],
      ["18107", 50],
      ["18133", 50],
      ["18073", 47],
      ["18023", 37],
      ["18181", 33],
      ["18015", 27],
      ["18017", 24],
      ["18111", 20],
      ["18171", 13],
      ["18007", 12],
      ["18045", 9],
      ["18067", 2],
    ],
    harris2024: 0.3506,
    holder: "R",
    id: "IN-04",
    incumbent: "Jim Baird",
    left: { name: "Drew Cox", party: "D" },
    right: { name: "Jim Baird", party: "R" },
    state: "IN",
  },
  {
    counties: [
      ["18057", 532],
      ["18095", 151],
      ["18035", 124],
      ["18067", 103],
      ["18053", 68],
      ["18159", 22],
    ],
    harris2024: 0.4144,
    holder: "R",
    id: "IN-05",
    incumbent: "Victoria Spartz",
    left: { name: "J.D. Ford", party: "D" },
    right: { name: "Victoria Spartz", party: "R" },
    state: "IN",
  },
  {
    counties: [
      ["18097", 248],
      ["18081", 239],
      ["18059", 136],
      ["18005", 96],
      ["18177", 82],
      ["18065", 63],
      ["18145", 61],
      ["18041", 30],
      ["18139", 24],
      ["18161", 11],
      ["18135", 10],
    ],
    harris2024: 0.3345,
    holder: "R",
    id: "IN-06",
    incumbent: "Jefferson Shreve",
    left: { name: "Cynthia Wirth", party: "D" },
    right: { name: "Jefferson Shreve", party: "R" },
    state: "IN",
  },
  {
    counties: [["18097", 1000]],
    harris2024: 0.7108,
    holder: "D",
    id: "IN-07",
    incumbent: "Andre Carson",
    left: { name: "André Carson", party: "D" },
    right: { name: "Patrick McAuley", party: "R" },
    state: "IN",
  },
  {
    counties: [
      ["18163", 222],
      ["18167", 123],
      ["18173", 100],
      ["18037", 64],
      ["18051", 48],
      ["18083", 45],
      ["18055", 44],
      ["18129", 39],
      ["18021", 36],
      ["18027", 34],
      ["18147", 31],
      ["18119", 30],
      ["18117", 26],
      ["18123", 26],
      ["18153", 26],
      ["18165", 22],
      ["18121", 20],
      ["18125", 18],
      ["18025", 15],
      ["18045", 15],
      ["18101", 15],
    ],
    harris2024: 0.3175,
    holder: "R",
    id: "IN-08",
    incumbent: "Mark Messmer",
    left: { name: "Mary Allen", party: "D" },
    right: { name: "Mark Messmer", party: "R" },
    state: "IN",
  },
  {
    counties: [
      ["18105", 167],
      ["18019", 166],
      ["18043", 116],
      ["18029", 75],
      ["18093", 60],
      ["18061", 58],
      ["18071", 53],
      ["18077", 41],
      ["18137", 41],
      ["18175", 36],
      ["18031", 34],
      ["18047", 34],
      ["18079", 33],
      ["18143", 29],
      ["18013", 24],
      ["18005", 12],
      ["18155", 12],
      ["18115", 9],
    ],
    harris2024: 0.3481,
    holder: "R",
    id: "IN-09",
    incumbent: "Erin Houchin",
    left: { name: "Brad Meyer", party: "D" },
    right: { name: "Erin Houchin", party: "R" },
    state: "IN",
  },
  {
    counties: [
      ["20045", 144],
      ["20155", 87],
      ["20161", 78],
      ["20169", 75],
      ["20113", 45],
      ["20051", 44],
      ["20149", 43],
      ["20055", 35],
      ["20009", 34],
      ["20087", 32],
      ["20041", 29],
      ["20057", 26],
      ["20085", 20],
      ["20117", 16],
      ["20175", 15],
      ["20027", 13],
      ["20029", 13],
      ["20159", 13],
      ["20193", 12],
      ["20167", 11],
      ["20123", 10],
      ["20143", 10],
      ["20053", 9],
      ["20147", 9],
      ["20201", 9],
      ["20157", 8],
      ["20163", 8],
      ["20181", 8],
      ["20067", 7],
      ["20069", 7],
      ["20137", 7],
      ["20171", 7],
      ["20141", 6],
      ["20183", 6],
      ["20189", 6],
      ["20023", 5],
      ["20039", 5],
      ["20089", 5],
      ["20105", 5],
      ["20109", 5],
      ["20119", 5],
      ["20153", 5],
      ["20165", 5],
      ["20195", 5],
      ["20063", 4],
      ["20065", 4],
      ["20081", 4],
      ["20093", 4],
      ["20135", 4],
      ["20145", 4],
      ["20179", 4],
      ["20025", 3],
      ["20075", 3],
      ["20083", 3],
      ["20101", 3],
      ["20129", 3],
      ["20203", 3],
      ["20071", 2],
      ["20187", 2],
      ["20199", 2],
    ],
    harris2024: 0.3408,
    holder: "R",
    id: "KS-01",
    incumbent: "Tracey Mann",
    left: { name: "Lauren Reinhold", party: "D" },
    right: { name: "Tracey Mann", party: "R" },
    state: "KS",
  },
  {
    counties: [
      ["20177", 266],
      ["20103", 119],
      ["20209", 104],
      ["20037", 53],
      ["20045", 43],
      ["20111", 43],
      ["20125", 40],
      ["20061", 30],
      ["20021", 28],
      ["20099", 26],
      ["20139", 26],
      ["20005", 24],
      ["20133", 22],
      ["20011", 21],
      ["20115", 19],
      ["20001", 18],
      ["20131", 18],
      ["20107", 16],
      ["20013", 14],
      ["20031", 14],
      ["20043", 12],
      ["20197", 12],
      ["20205", 12],
      ["20127", 9],
      ["20017", 5],
      ["20207", 5],
      ["20085", 1],
    ],
    harris2024: 0.3997,
    holder: "R",
    id: "KS-02",
    incumbent: "Derek Schmidt",
    left: { name: "Don Coover", party: "D" },
    right: { name: "Derek Schmidt", party: "R" },
    state: "KS",
  },
  {
    counties: [
      ["20091", 865],
      ["20121", 47],
      ["20209", 47],
      ["20059", 32],
      ["20003", 10],
    ],
    harris2024: 0.5209,
    holder: "D",
    id: "KS-03",
    incumbent: "Sharice Davids",
    left: { name: "Sharice Davids", party: "D" },
    right: { name: "Eric Jenkins", party: "R" },
    state: "KS",
  },
  {
    counties: [
      ["20173", 687],
      ["20015", 103],
      ["20079", 52],
      ["20035", 43],
      ["20191", 34],
      ["20095", 13],
      ["20151", 13],
      ["20073", 9],
      ["20077", 8],
      ["20007", 7],
      ["20185", 6],
      ["20019", 5],
      ["20047", 4],
      ["20049", 4],
      ["20097", 4],
      ["20145", 4],
      ["20033", 3],
    ],
    harris2024: 0.3815,
    holder: "R",
    id: "KS-04",
    incumbent: "Ron Estes",
    left: { name: "Katy Tyndell", party: "D" },
    right: { name: "Ron Estes", party: "R" },
    state: "KS",
  },
  {
    counties: [
      ["21145", 93],
      ["21073", 75],
      ["21047", 63],
      ["21107", 60],
      ["21101", 57],
      ["21157", 51],
      ["21035", 49],
      ["21083", 49],
      ["21021", 42],
      ["21217", 36],
      ["21141", 33],
      ["21003", 27],
      ["21155", 27],
      ["21001", 26],
      ["21207", 26],
      ["21213", 26],
      ["21045", 21],
      ["21221", 21],
      ["21033", 18],
      ["21225", 18],
      ["21229", 18],
      ["21233", 16],
      ["21139", 15],
      ["21169", 15],
      ["21171", 15],
      ["21219", 15],
      ["21053", 14],
      ["21007", 12],
      ["21055", 12],
      ["21143", 12],
      ["21057", 10],
      ["21039", 8],
      ["21005", 7],
      ["21075", 6],
      ["21105", 6],
    ],
    harris2024: 0.2604,
    holder: "R",
    id: "KY-01",
    incumbent: "James Comer",
    left: { name: "Drew Williams", party: "D" },
    right: { name: "James Comer", party: "R" },
    state: "KY",
  },
  {
    counties: [
      ["21227", 162],
      ["21093", 137],
      ["21059", 134],
      ["21029", 123],
      ["21111", 61],
      ["21009", 56],
      ["21163", 40],
      ["21177", 39],
      ["21085", 34],
      ["21183", 31],
      ["21027", 29],
      ["21179", 28],
      ["21099", 24],
      ["21123", 21],
      ["21061", 18],
      ["21031", 17],
      ["21087", 17],
      ["21091", 13],
      ["21149", 13],
      ["21141", 3],
    ],
    harris2024: 0.2903,
    holder: "R",
    id: "KY-02",
    incumbent: "Brett Guthrie",
    left: { name: "Megan Wingfield", party: "D" },
    right: { name: "Brett Guthrie", party: "R" },
    state: "KY",
  },
  {
    counties: [["21111", 1000]],
    harris2024: 0.5963,
    holder: "D",
    id: "KY-03",
    incumbent: "Morgan McGarvey",
    left: { name: "Morgan McGarvey", party: "D" },
    right: { name: "Maria Teresa Rodriguez", party: "R" },
    state: "KY",
  },
  {
    counties: [
      ["21117", 216],
      ["21015", 180],
      ["21037", 129],
      ["21185", 102],
      ["21211", 66],
      ["21089", 46],
      ["21179", 35],
      ["21081", 31],
      ["21215", 31],
      ["21097", 24],
      ["21103", 22],
      ["21161", 21],
      ["21191", 18],
      ["21135", 15],
      ["21187", 15],
      ["21023", 11],
      ["21041", 11],
      ["21223", 11],
      ["21077", 10],
      ["21043", 4],
      ["21201", 3],
    ],
    harris2024: 0.3192,
    holder: "R",
    id: "KY-04",
    incumbent: "Thomas Massie",
    left: { name: "Melissa Strange", party: "D" },
    right: { name: "Ed Gallrein", party: "R" },
    state: "KY",
  },
  {
    counties: [
      ["21199", 100],
      ["21125", 88],
      ["21195", 76],
      ["21019", 66],
      ["21071", 49],
      ["21235", 48],
      ["21121", 42],
      ["21137", 35],
      ["21095", 33],
      ["21193", 32],
      ["21043", 31],
      ["21205", 31],
      ["21115", 30],
      ["21013", 29],
      ["21231", 28],
      ["21133", 27],
      ["21051", 24],
      ["21203", 24],
      ["21127", 21],
      ["21147", 20],
      ["21109", 19],
      ["21119", 19],
      ["21153", 17],
      ["21175", 17],
      ["21025", 16],
      ["21131", 14],
      ["21011", 12],
      ["21159", 12],
      ["21165", 10],
      ["21063", 9],
      ["21237", 9],
      ["21129", 8],
      ["21189", 6],
    ],
    harris2024: 0.1767,
    holder: "R",
    id: "KY-05",
    incumbent: "Hal Rogers",
    left: { name: "Ned Pillersdorf", party: "D" },
    right: { name: "Hal Rogers", party: "R" },
    state: "KY",
  },
  {
    counties: [
      ["21067", 404],
      ["21151", 127],
      ["21209", 84],
      ["21113", 75],
      ["21049", 50],
      ["21239", 42],
      ["21173", 36],
      ["21167", 33],
      ["21005", 30],
      ["21017", 27],
      ["21079", 25],
      ["21069", 20],
      ["21065", 18],
      ["21197", 15],
      ["21181", 9],
      ["21011", 5],
    ],
    harris2024: 0.4234,
    holder: "R",
    id: "KY-06",
    incumbent: "Andy Barr",
    left: { name: "Zach Dembo", party: "D" },
    right: { name: "Ralph Alvarado", party: "R" },
    state: "KY",
  },
  {
    counties: [
      ["22103", 382],
      ["22051", 290],
      ["22109", 95],
      ["22071", 74],
      ["22105", 56],
      ["22057", 50],
      ["22075", 27],
      ["22087", 24],
    ],
    harris2024: 0.3053,
    holder: "R",
    id: "LA-01",
    incumbent: "Steve Scalise",
    left: { name: "Lauren Jewett", party: "D" },
    right: { name: "Steve Scalise", party: "R" },
    state: "LA",
  },
  {
    counties: [
      ["22071", 431],
      ["22051", 239],
      ["22033", 123],
      ["22089", 45],
      ["22093", 38],
      ["22095", 33],
      ["22047", 31],
      ["22087", 28],
      ["22121", 17],
      ["22005", 14],
    ],
    harris2024: 0.7417,
    holder: "D",
    id: "LA-02",
    incumbent: "Troy Carter",
    left: { name: "Troy Carter", party: "D" },
    right: { name: "Peter Williams", party: "R" },
    state: "LA",
  },
  {
    counties: [
      ["22055", 330],
      ["22019", 131],
      ["22097", 88],
      ["22045", 87],
      ["22001", 79],
      ["22113", 78],
      ["22099", 72],
      ["22101", 62],
      ["22053", 43],
      ["22109", 20],
      ["22023", 10],
    ],
    harris2024: 0.3175,
    holder: "R",
    id: "LA-03",
    incumbent: "Clay Higgins",
    left: { name: "John Day", party: "D" },
    right: { name: "Clay Higgins", party: "R" },
    state: "LA",
  },
  {
    counties: [
      ["22017", 295],
      ["22015", 163],
      ["22019", 116],
      ["22119", 51],
      ["22011", 50],
      ["22115", 50],
      ["22069", 47],
      ["22039", 44],
      ["22031", 43],
      ["22111", 33],
      ["22085", 32],
      ["22003", 27],
      ["22013", 20],
      ["22027", 18],
      ["22081", 12],
    ],
    harris2024: 0.3267,
    holder: "R",
    id: "LA-04",
    incumbent: "Mike Johnson",
    left: { name: "Conrad Cable", party: "D" },
    right: { name: "Mike Johnson", party: "R" },
    state: "LA",
  },
  {
    counties: [
      ["22073", 201],
      ["22079", 167],
      ["22105", 108],
      ["22117", 58],
      ["22061", 57],
      ["22009", 50],
      ["22037", 31],
      ["22067", 31],
      ["22083", 29],
      ["22043", 28],
      ["22041", 27],
      ["22029", 24],
      ["22097", 24],
      ["22049", 23],
      ["22059", 21],
      ["22125", 19],
      ["22091", 18],
      ["22127", 18],
      ["22021", 14],
      ["22025", 14],
      ["22123", 14],
      ["22065", 12],
      ["22035", 7],
      ["22107", 7],
    ],
    harris2024: 0.3277,
    holder: "R",
    id: "LA-05",
    incumbent: "Julia Letlow",
    left: { name: "Dan McKay", party: "D" },
    right: { name: "Michael Echols", party: "R" },
    state: "LA",
  },
  {
    counties: [
      ["22033", 425],
      ["22063", 183],
      ["22005", 161],
      ["22057", 68],
      ["22089", 36],
      ["22077", 32],
      ["22007", 29],
      ["22095", 24],
      ["22121", 24],
      ["22047", 16],
      ["22099", 2],
    ],
    harris2024: 0.3469,
    holder: "D",
    id: "LA-06",
    incumbent: "Cleo Fields",
    left: { name: "Lindsay Garcia", party: "D" },
    right: { name: "Blake Miguez", party: "R" },
    state: "LA",
  },
  {
    counties: [
      ["25013", 547],
      ["25003", 180],
      ["25027", 149],
      ["25015", 121],
      ["25011", 3],
    ],
    harris2024: 0.5696,
    holder: "D",
    id: "MA-01",
    incumbent: "Richard Neal",
    left: { name: "Richard Neal", party: "D" },
    right: null,
    state: "MA",
  },
  {
    counties: [
      ["25027", 695],
      ["25011", 107],
      ["25015", 100],
      ["25017", 76],
      ["25021", 22],
    ],
    harris2024: 0.6214,
    holder: "D",
    id: "MA-02",
    incumbent: "Jim McGovern",
    left: { name: "Jim McGovern", party: "D" },
    right: null,
    state: "MA",
  },
  {
    counties: [
      ["25017", 595],
      ["25009", 215],
      ["25027", 190],
    ],
    harris2024: 0.597,
    holder: "D",
    id: "MA-03",
    incumbent: "Lori Trahan",
    left: { name: "Lori Trahan", party: "D" },
    right: { name: "Gary Grossi", party: "R" },
    state: "MA",
  },
  {
    counties: [
      ["25005", 445],
      ["25021", 345],
      ["25017", 121],
      ["25027", 70],
      ["25023", 19],
    ],
    harris2024: 0.6007,
    holder: "D",
    id: "MA-04",
    incumbent: "Jake Auchincloss",
    left: { name: "Jake Auchincloss", party: "D" },
    right: { name: "Thomas Stalcup", party: "R" },
    state: "MA",
  },
  {
    counties: [
      ["25017", 894],
      ["25025", 74],
      ["25021", 32],
    ],
    harris2024: 0.7317,
    holder: "D",
    id: "MA-05",
    incumbent: "Katherine Clark",
    left: { name: "Katherine Clark", party: "D" },
    right: { name: "Fleming", party: "I" },
    state: "MA",
  },
  {
    counties: [
      ["25009", 750],
      ["25017", 250],
    ],
    harris2024: 0.6054,
    holder: "D",
    id: "MA-06",
    incumbent: "Seth Moulton",
    left: { name: "Dan Koh", party: "D" },
    right: { name: "Micah Jones", party: "R" },
    state: "MA",
  },
  {
    counties: [
      ["25025", 640],
      ["25017", 281],
      ["25021", 79],
    ],
    harris2024: 0.8257,
    holder: "D",
    id: "MA-07",
    incumbent: "Ayanna Pressley",
    left: { name: "Ayanna Pressley", party: "D" },
    right: { name: "Linardon", party: "I" },
    state: "MA",
  },
  {
    counties: [
      ["25021", 504],
      ["25025", 233],
      ["25023", 227],
      ["25005", 36],
    ],
    harris2024: 0.6349,
    holder: "D",
    id: "MA-08",
    incumbent: "Stephen Lynch",
    left: { name: "Stephen Lynch", party: "D" },
    right: { name: "Robert G. Burke", party: "R" },
    state: "MA",
  },
  {
    counties: [
      ["25023", 442],
      ["25001", 323],
      ["25005", 181],
      ["25007", 27],
      ["25019", 15],
      ["25021", 12],
    ],
    harris2024: 0.5547,
    holder: "D",
    id: "MA-09",
    incumbent: "Bill Keating",
    left: { name: "Bill Keating", party: "D" },
    right: { name: "Robert MacAllister", party: "R" },
    state: "MA",
  },
  {
    counties: [
      ["24025", 351],
      ["24015", 124],
      ["24045", 110],
      ["24005", 81],
      ["24047", 77],
      ["24035", 76],
      ["24041", 53],
      ["24019", 39],
      ["24011", 38],
      ["24029", 26],
      ["24039", 24],
    ],
    harris2024: 0.4135,
    holder: "R",
    id: "MD-01",
    incumbent: "Andy Harris",
    left: { name: "Dan Schwartz", party: "D" },
    right: { name: "Andrew Harris", party: "R" },
    state: "MD",
  },
  {
    counties: [
      ["24005", 730],
      ["24013", 229],
      ["24510", 41],
    ],
    harris2024: 0.5947,
    holder: "D",
    id: "MD-02",
    incumbent: "Johnny Olszewski",
    left: { name: "John Olszewski", party: "D" },
    right: { name: "Dave Wallace", party: "R" },
    state: "MD",
  },
  {
    counties: [
      ["24003", 534],
      ["24027", 437],
      ["24013", 29],
    ],
    harris2024: 0.6225,
    holder: "D",
    id: "MD-03",
    incumbent: "Sarah Elfreth",
    left: { name: "Sarah Elfreth", party: "D" },
    right: { name: "Bernard Flowers", party: "R" },
    state: "MD",
  },
  {
    counties: [
      ["24033", 942],
      ["24031", 58],
    ],
    harris2024: 0.8783,
    holder: "D",
    id: "MD-04",
    incumbent: "Glenn Ivey",
    left: { name: "Glenn Ivey", party: "D" },
    right: { name: "George McDermott", party: "R" },
    state: "MD",
  },
  {
    counties: [
      ["24033", 318],
      ["24017", 214],
      ["24003", 206],
      ["24037", 137],
      ["24009", 126],
    ],
    harris2024: 0.6703,
    holder: "D",
    id: "MD-05",
    incumbent: "Steny Hoyer",
    left: { name: "Adrian Boafo", party: "D" },
    right: { name: "Chris Chaffee", party: "R" },
    state: "MD",
  },
  {
    counties: [
      ["24021", 400],
      ["24031", 289],
      ["24043", 188],
      ["24001", 83],
      ["24023", 41],
    ],
    harris2024: 0.5296,
    holder: "D",
    id: "MD-06",
    incumbent: "April McClain Delaney",
    left: { name: "April McClain Delaney", party: "D" },
    right: { name: "Robin Ficker", party: "R" },
    state: "MD",
  },
  {
    counties: [
      ["24510", 705],
      ["24005", 295],
    ],
    harris2024: 0.8025,
    holder: "D",
    id: "MD-07",
    incumbent: "Kweisi Mfume",
    left: { name: "Kweisi Mfume", party: "D" },
    right: { name: "Scott Collier", party: "R" },
    state: "MD",
  },
  {
    counties: [["24031", 1000]],
    harris2024: 0.7903,
    holder: "D",
    id: "MD-08",
    incumbent: "Jamie Raskin",
    left: { name: "Jamie Raskin", party: "D" },
    right: { name: "Cheryl Riley", party: "R" },
    state: "MD",
  },
  {
    counties: [
      ["23005", 448],
      ["23031", 309],
      ["23011", 70],
      ["23013", 60],
      ["23023", 57],
      ["23015", 56],
    ],
    harris2024: 0.6104,
    holder: "D",
    id: "ME-01",
    incumbent: "Chellie Pingree",
    left: { name: "Chellie Pingree", party: "D" },
    right: { name: "Ronald Russell", party: "R" },
    state: "ME",
  },
  {
    counties: [
      ["23019", 220],
      ["23001", 149],
      ["23011", 108],
      ["23009", 92],
      ["23003", 90],
      ["23017", 88],
      ["23025", 72],
      ["23027", 64],
      ["23029", 46],
      ["23007", 45],
      ["23021", 26],
    ],
    harris2024: 0.4538,
    holder: "D",
    id: "ME-02",
    incumbent: "Jared Golden",
    left: { name: "Matthew Dunlap", party: "D" },
    right: { name: "Paul LePage", party: "R" },
    state: "ME",
  },
  {
    counties: [
      ["26055", 129],
      ["26103", 80],
      ["26047", 47],
      ["26041", 45],
      ["26061", 40],
      ["26033", 38],
      ["26029", 36],
      ["26089", 36],
      ["26007", 35],
      ["26009", 35],
      ["26031", 34],
      ["26137", 33],
      ["26143", 33],
      ["26043", 32],
      ["26069", 32],
      ["26109", 27],
      ["26019", 26],
      ["26129", 26],
      ["26079", 24],
      ["26011", 19],
      ["26113", 19],
      ["26141", 18],
      ["26039", 17],
      ["26053", 17],
      ["26001", 15],
      ["26097", 15],
      ["26071", 14],
      ["26119", 13],
      ["26003", 11],
      ["26135", 11],
      ["26153", 10],
      ["26013", 9],
      ["26131", 8],
      ["26095", 6],
      ["26165", 5],
      ["26083", 3],
    ],
    harris2024: 0.3924,
    holder: "R",
    id: "MI-01",
    incumbent: "Jack Bergman",
    left: { name: "Callie Barr", party: "D" },
    right: { name: "Jack Bergman", party: "R" },
    state: "MI",
  },
  {
    counties: [
      ["26081", 145],
      ["26121", 90],
      ["26015", 87],
      ["26117", 79],
      ["26067", 77],
      ["26073", 70],
      ["26123", 66],
      ["26107", 51],
      ["26057", 45],
      ["26105", 41],
      ["26035", 39],
      ["26165", 38],
      ["26051", 35],
      ["26101", 35],
      ["26127", 34],
      ["26133", 30],
      ["26085", 16],
      ["26111", 13],
      ["26045", 6],
      ["26139", 3],
    ],
    harris2024: 0.3473,
    holder: "R",
    id: "MI-02",
    incumbent: "John Moolenaar",
    left: { name: "Ben Ambrose", party: "D" },
    right: { name: "John Moolenaar", party: "R" },
    state: "MI",
  },
  {
    counties: [
      ["26081", 720],
      ["26139", 150],
      ["26121", 129],
    ],
    harris2024: 0.5399,
    holder: "D",
    id: "MI-03",
    incumbent: "Hillary Scholten",
    left: { name: "Hillary Scholten", party: "D" },
    right: { name: "Terri DeBoer", party: "R" },
    state: "MI",
  },
  {
    counties: [
      ["26077", 310],
      ["26139", 260],
      ["26005", 166],
      ["26025", 97],
      ["26159", 95],
      ["26021", 72],
    ],
    harris2024: 0.4719,
    holder: "R",
    id: "MI-04",
    incumbent: "Bill Huizenga",
    left: { name: "Sean McCann", party: "D" },
    right: { name: "Bill Huizenga", party: "R" },
    state: "MI",
  },
  {
    counties: [
      ["26115", 213],
      ["26075", 198],
      ["26091", 130],
      ["26021", 126],
      ["26149", 69],
      ["26027", 66],
      ["26025", 62],
      ["26059", 59],
      ["26023", 50],
      ["26077", 26],
    ],
    harris2024: 0.363,
    holder: "R",
    id: "MI-05",
    incumbent: "Tim Walberg",
    left: { name: "Christian Vukasovich", party: "D" },
    right: { name: "Tim Walberg", party: "R" },
    state: "MI",
  },
  {
    counties: [
      ["26161", 477],
      ["26163", 447],
      ["26125", 74],
      ["26115", 3],
    ],
    harris2024: 0.6196,
    holder: "D",
    id: "MI-06",
    incumbent: "Debbie Dingell",
    left: { name: "Debbie Dingell", party: "D" },
    right: { name: "Heather Smiley", party: "R" },
    state: "MI",
  },
  {
    counties: [
      ["26065", 320],
      ["26093", 286],
      ["26045", 135],
      ["26037", 108],
      ["26155", 88],
      ["26125", 63],
    ],
    harris2024: 0.4935,
    holder: "R",
    id: "MI-07",
    incumbent: "Tom Barrett",
    left: { name: "William Lawrence", party: "D" },
    right: { name: "Tom Barrett", party: "R" },
    state: "MI",
  },
  {
    counties: [
      ["26049", 514],
      ["26145", 239],
      ["26017", 141],
      ["26111", 103],
      ["26157", 2],
    ],
    harris2024: 0.49,
    holder: "D",
    id: "MI-08",
    incumbent: "Kristen McDonald Rivet",
    left: { name: "Kristen McDonald Rivet", party: "D" },
    right: { name: "Thomas J. Smith", party: "R" },
    state: "MI",
  },
  {
    counties: [
      ["26125", 280],
      ["26099", 260],
      ["26147", 198],
      ["26087", 114],
      ["26157", 61],
      ["26151", 48],
      ["26063", 39],
    ],
    harris2024: 0.3361,
    holder: "R",
    id: "MI-09",
    incumbent: "Lisa McClain",
    left: { name: "Ray Pooley", party: "D" },
    right: { name: "Lisa McClain", party: "R" },
    state: "MI",
  },
  {
    counties: [
      ["26099", 876],
      ["26125", 124],
    ],
    harris2024: 0.4666,
    holder: "R",
    id: "MI-10",
    incumbent: "John James",
    left: { name: "Christina Hines", party: "D" },
    right: { name: "Mike Bouchard", party: "R" },
    state: "MI",
  },
  {
    counties: [["26125", 1000]],
    harris2024: 0.5821,
    holder: "D",
    id: "MI-11",
    incumbent: "Haley Stevens",
    left: { name: "Jeremy Moss", party: "D" },
    right: { name: "Ethan Baker", party: "R" },
    state: "MI",
  },
  {
    counties: [
      ["26163", 845],
      ["26125", 155],
    ],
    harris2024: 0.6995,
    holder: "D",
    id: "MI-12",
    incumbent: "Rashida Tlaib",
    left: { name: "Rashida Tlaib", party: "D" },
    right: { name: "James Hooper", party: "R" },
    state: "MI",
  },
  {
    counties: [["26163", 1000]],
    harris2024: 0.71,
    holder: "D",
    id: "MI-13",
    incumbent: "Shri Thanedar",
    left: { name: "Donavan McKinney", party: "D" },
    right: { name: "Taras Nykoriak", party: "R" },
    state: "MI",
  },
  {
    counties: [
      ["27109", 233],
      ["27013", 94],
      ["27049", 74],
      ["27169", 71],
      ["27147", 54],
      ["27103", 50],
      ["27099", 49],
      ["27047", 43],
      ["27131", 37],
      ["27157", 35],
      ["27015", 32],
      ["27039", 32],
      ["27045", 32],
      ["27055", 29],
      ["27091", 28],
      ["27161", 27],
      ["27105", 21],
      ["27043", 20],
      ["27063", 14],
      ["27133", 14],
      ["27165", 13],
    ],
    harris2024: 0.4388,
    holder: "R",
    id: "MN-01",
    incumbent: "Brad Finstad",
    left: { name: "Jake Johnson", party: "D" },
    right: { name: "Brad Finstad", party: "R" },
    state: "MN",
  },
  {
    counties: [
      ["27037", 609],
      ["27139", 211],
      ["27163", 87],
      ["27131", 52],
      ["27079", 41],
    ],
    harris2024: 0.5298,
    holder: "D",
    id: "MN-02",
    incumbent: "Angie Craig",
    left: { name: "Matt Little", party: "D" },
    right: { name: "Eric Pratt", party: "R" },
    state: "MN",
  },
  {
    counties: [
      ["27053", 893],
      ["27003", 107],
    ],
    harris2024: 0.6086,
    holder: "D",
    id: "MN-03",
    incumbent: "Kelly Morrison",
    left: { name: "Kelly Morrison", party: "D" },
    right: { name: "Tyler Bass", party: "R" },
    state: "MN",
  },
  {
    counties: [
      ["27123", 730],
      ["27163", 270],
    ],
    harris2024: 0.6823,
    holder: "D",
    id: "MN-04",
    incumbent: "Betty McCollum",
    left: { name: "Betty McCollum", party: "D" },
    right: { name: "Paul Wikstrom", party: "R" },
    state: "MN",
  },
  {
    counties: [
      ["27053", 921],
      ["27003", 75],
      ["27123", 5],
    ],
    harris2024: 0.8177,
    holder: "D",
    id: "MN-05",
    incumbent: "Ilhan Omar",
    left: { name: "Ilhan Omar", party: "D" },
    right: { name: "John Nagel", party: "R" },
    state: "MN",
  },
  {
    counties: [
      ["27003", 318],
      ["27171", 208],
      ["27019", 160],
      ["27141", 134],
      ["27145", 125],
      ["27009", 53],
      ["27053", 1],
    ],
    harris2024: 0.3997,
    holder: "R",
    id: "MN-06",
    incumbent: "Tom Emmer",
    left: { name: "Doug Chapin", party: "D" },
    right: { name: "Tom Emmer", party: "R" },
    state: "MN",
  },
  {
    counties: [
      ["27111", 92],
      ["27027", 82],
      ["27145", 82],
      ["27041", 63],
      ["27067", 58],
      ["27085", 53],
      ["27097", 51],
      ["27005", 45],
      ["27119", 38],
      ["27093", 34],
      ["27153", 34],
      ["27083", 32],
      ["27127", 21],
      ["27135", 21],
      ["27143", 21],
      ["27129", 20],
      ["27159", 20],
      ["27057", 19],
      ["27113", 18],
      ["27121", 18],
      ["27023", 16],
      ["27033", 15],
      ["27089", 13],
      ["27149", 13],
      ["27151", 13],
      ["27173", 13],
      ["27101", 12],
      ["27117", 12],
      ["27073", 10],
      ["27051", 9],
      ["27081", 8],
      ["27107", 8],
      ["27167", 8],
      ["27011", 7],
      ["27015", 6],
      ["27069", 6],
      ["27125", 5],
      ["27155", 5],
    ],
    harris2024: 0.3145,
    holder: "R",
    id: "MN-07",
    incumbent: "Michelle Fischbach",
    left: { name: "Erik Osberg", party: "D" },
    right: { name: "Michelle Fischbach", party: "R" },
    state: "MN",
  },
  {
    counties: [
      ["27137", 275],
      ["27035", 98],
      ["27025", 82],
      ["27163", 70],
      ["27061", 62],
      ["27059", 60],
      ["27007", 58],
      ["27017", 48],
      ["27021", 45],
      ["27115", 39],
      ["27095", 35],
      ["27001", 24],
      ["27065", 22],
      ["27071", 16],
      ["27075", 16],
      ["27057", 14],
      ["27029", 11],
      ["27031", 8],
      ["27077", 5],
      ["27087", 5],
      ["27005", 4],
    ],
    harris2024: 0.4273,
    holder: "R",
    id: "MN-08",
    incumbent: "Pete Stauber",
    left: { name: "Trina Swanson", party: "D" },
    right: { name: "Pete Stauber", party: "R" },
    state: "MN",
  },
  {
    counties: [
      ["29189", 631],
      ["29510", 369],
    ],
    harris2024: 0.7909,
    holder: "D",
    id: "MO-01",
    incumbent: "Wesley Bell",
    left: { name: "Wesley Bell", party: "D" },
    right: { name: "Paul Berry", party: "R" },
    state: "MO",
  },
  {
    counties: [
      ["29189", 701],
      ["29183", 140],
      ["29071", 128],
      ["29219", 31],
    ],
    harris2024: 0.4598,
    holder: "R",
    id: "MO-02",
    incumbent: "Ann Wagner",
    left: { name: "Frederick Wellman", party: "D" },
    right: { name: "Ann Wagner", party: "R" },
    state: "MO",
  },
  {
    counties: [
      ["29183", 407],
      ["29019", 130],
      ["29051", 99],
      ["29099", 90],
      ["29027", 53],
      ["29131", 32],
      ["29055", 27],
      ["29221", 25],
      ["29053", 22],
      ["29073", 20],
      ["29151", 19],
      ["29135", 18],
      ["29029", 16],
      ["29219", 16],
      ["29139", 15],
      ["29125", 12],
    ],
    harris2024: 0.3645,
    holder: "R",
    id: "MO-03",
    incumbent: "Bob Onder",
    left: { name: "Bethany Mann", party: "D" },
    right: { name: "Bob Onder", party: "R" },
    state: "MO",
  },
  {
    counties: [
      ["29037", 158],
      ["29095", 111],
      ["29019", 98],
      ["29101", 63],
      ["29029", 50],
      ["29159", 50],
      ["29107", 46],
      ["29105", 45],
      ["29167", 42],
      ["29169", 41],
      ["29225", 31],
      ["29015", 29],
      ["29083", 29],
      ["29141", 26],
      ["29195", 25],
      ["29217", 24],
      ["29013", 22],
      ["29059", 22],
      ["29039", 19],
      ["29011", 16],
      ["29085", 14],
      ["29089", 13],
      ["29185", 13],
      ["29057", 11],
    ],
    harris2024: 0.2859,
    holder: "R",
    id: "MO-04",
    incumbent: "Mark Alford",
    left: { name: "Jordan Herrera", party: "D" },
    right: { name: "Mark Alford", party: "R" },
    state: "MO",
  },
  {
    counties: [
      ["29095", 798],
      ["29047", 202],
    ],
    harris2024: 0.6175,
    holder: "D",
    id: "MO-05",
    incumbent: "Emanuel Cleaver",
    left: { name: "Emanuel Cleaver", party: "D" },
    right: { name: "Rick Brattin", party: "R" },
    state: "MO",
  },
  {
    counties: [
      ["29047", 162],
      ["29165", 151],
      ["29021", 93],
      ["29113", 84],
      ["29127", 34],
      ["29177", 30],
      ["29049", 29],
      ["29175", 29],
      ["29001", 27],
      ["29007", 27],
      ["29003", 26],
      ["29147", 25],
      ["29121", 20],
      ["29163", 20],
      ["29117", 18],
      ["29095", 17],
      ["29115", 15],
      ["29173", 15],
      ["29063", 13],
      ["29025", 12],
      ["29033", 12],
      ["29111", 12],
      ["29041", 11],
      ["29079", 11],
      ["29137", 11],
      ["29061", 10],
      ["29081", 10],
      ["29045", 9],
      ["29075", 9],
      ["29205", 9],
      ["29005", 7],
      ["29087", 6],
      ["29171", 6],
      ["29211", 6],
      ["29103", 5],
      ["29129", 5],
      ["29197", 5],
      ["29199", 5],
      ["29227", 3],
    ],
    harris2024: 0.3034,
    holder: "R",
    id: "MO-06",
    incumbent: "Sam Graves",
    left: { name: "Josh Smead", party: "D" },
    right: { name: "Chris Stigall", party: "R" },
    state: "MO",
  },
  {
    counties: [
      ["29077", 383],
      ["29097", 143],
      ["29043", 135],
      ["29145", 77],
      ["29213", 71],
      ["29209", 51],
      ["29109", 49],
      ["29009", 43],
      ["29119", 25],
      ["29225", 21],
    ],
    harris2024: 0.2844,
    holder: "R",
    id: "MO-07",
    incumbent: "Eric Burlison",
    left: { name: "Missi Hesketh", party: "D" },
    right: { name: "Eric Burlison", party: "R" },
    state: "MO",
  },
  {
    counties: [
      ["29099", 225],
      ["29031", 110],
      ["29187", 78],
      ["29161", 53],
      ["29091", 52],
      ["29023", 49],
      ["29201", 47],
      ["29207", 37],
      ["29215", 31],
      ["29069", 27],
      ["29157", 27],
      ["29186", 27],
      ["29229", 24],
      ["29067", 20],
      ["29065", 19],
      ["29143", 19],
      ["29017", 17],
      ["29123", 16],
      ["29181", 16],
      ["29223", 16],
      ["29155", 14],
      ["29149", 13],
      ["29153", 13],
      ["29093", 12],
      ["29133", 12],
      ["29203", 11],
      ["29035", 8],
      ["29179", 8],
    ],
    harris2024: 0.227,
    holder: "R",
    id: "MO-08",
    incumbent: "Jason Smith",
    left: { name: "Christopher Reichard", party: "D" },
    right: { name: "Jason Smith", party: "R" },
    state: "MO",
  },
  {
    counties: [
      ["28033", 244],
      ["28081", 109],
      ["28087", 75],
      ["28071", 72],
      ["28095", 50],
      ["28003", 47],
      ["28093", 46],
      ["28115", 43],
      ["28137", 40],
      ["28145", 39],
      ["28057", 33],
      ["28117", 32],
      ["28139", 30],
      ["28025", 28],
      ["28141", 28],
      ["28017", 22],
      ["28013", 19],
      ["28155", 16],
      ["28009", 12],
      ["28019", 12],
      ["28105", 4],
    ],
    harris2024: 0.3123,
    holder: "R",
    id: "MS-01",
    incumbent: "Trent Kelly",
    left: { name: "Cliff Johnson", party: "D" },
    right: { name: "Trent Kelly", party: "R" },
    state: "MS",
  },
  {
    counties: [
      ["28049", 267],
      ["28149", 64],
      ["28151", 51],
      ["28107", 50],
      ["28001", 42],
      ["28029", 41],
      ["28089", 37],
      ["28011", 36],
      ["28043", 34],
      ["28083", 33],
      ["28163", 31],
      ["28079", 29],
      ["28007", 27],
      ["28133", 27],
      ["28005", 24],
      ["28027", 24],
      ["28051", 23],
      ["28161", 21],
      ["28015", 18],
      ["28135", 17],
      ["28097", 15],
      ["28037", 14],
      ["28021", 12],
      ["28053", 12],
      ["28063", 12],
      ["28157", 10],
      ["28119", 9],
      ["28143", 9],
      ["28125", 6],
      ["28055", 2],
    ],
    harris2024: 0.6029,
    holder: "D",
    id: "MS-02",
    incumbent: "Bennie Thompson",
    left: { name: "Bennie G. Thompson", party: "D" },
    right: { name: "Ron Eller", party: "R" },
    state: "MS",
  },
  {
    counties: [
      ["28121", 215],
      ["28089", 139],
      ["28075", 85],
      ["28105", 51],
      ["28085", 49],
      ["28113", 48],
      ["28091", 35],
      ["28099", 34],
      ["28127", 34],
      ["28049", 32],
      ["28123", 31],
      ["28101", 29],
      ["28031", 27],
      ["28159", 26],
      ["28061", 24],
      ["28129", 24],
      ["28023", 23],
      ["28147", 20],
      ["28077", 19],
      ["28065", 17],
      ["28103", 14],
      ["28069", 13],
      ["28067", 12],
    ],
    harris2024: 0.3527,
    holder: "R",
    id: "MS-03",
    incumbent: "Michael Guest",
    left: { name: "Michael Chiaradio", party: "D" },
    right: { name: "Michael Guest", party: "R" },
    state: "MS",
  },
  {
    counties: [
      ["28047", 258],
      ["28059", 178],
      ["28035", 97],
      ["28073", 96],
      ["28109", 84],
      ["28067", 81],
      ["28045", 72],
      ["28039", 38],
      ["28153", 31],
      ["28131", 27],
      ["28041", 19],
      ["28111", 19],
    ],
    harris2024: 0.285,
    holder: "R",
    id: "MS-04",
    incumbent: "Mike Ezell",
    left: { name: "Jeffrey Hulum", party: "D" },
    right: { name: "Mike Ezell", party: "R" },
    state: "MS",
  },
  {
    counties: [
      ["30063", 226],
      ["30031", 217],
      ["30029", 196],
      ["30081", 93],
      ["30093", 57],
      ["30047", 53],
      ["30053", 37],
      ["30089", 25],
      ["30057", 20],
      ["30001", 18],
      ["30035", 16],
      ["30023", 15],
      ["30077", 10],
      ["30061", 9],
      ["30039", 7],
      ["30073", 3],
    ],
    harris2024: 0.4404,
    holder: "R",
    id: "MT-01",
    incumbent: "Ryan Zinke",
    left: { name: "Samuel Forstag", party: "D" },
    right: { name: "Aaron Flint", party: "R" },
    state: "MT",
  },
  {
    counties: [
      ["30111", 290],
      ["30049", 150],
      ["30013", 134],
      ["30067", 42],
      ["30043", 30],
      ["30009", 26],
      ["30027", 24],
      ["30041", 24],
      ["30017", 21],
      ["30095", 21],
      ["30083", 19],
      ["30007", 17],
      ["30021", 17],
      ["30003", 16],
      ["30105", 15],
      ["30085", 14],
      ["30087", 13],
      ["30099", 13],
      ["30005", 11],
      ["30065", 11],
      ["30015", 10],
      ["30071", 8],
      ["30097", 8],
      ["30073", 7],
      ["30091", 7],
      ["30101", 7],
      ["30025", 5],
      ["30045", 5],
      ["30051", 4],
      ["30055", 4],
      ["30059", 4],
      ["30075", 4],
      ["30107", 4],
      ["30011", 3],
      ["30019", 3],
      ["30033", 3],
      ["30037", 2],
      ["30079", 2],
      ["30103", 2],
      ["30109", 2],
      ["30069", 1],
    ],
    harris2024: 0.3475,
    holder: "R",
    id: "MT-02",
    incumbent: "Troy Downing",
    left: { name: "Brian Miller", party: "D" },
    right: { name: "Troy Downing", party: "R" },
    state: "MT",
  },
  {
    counties: [
      ["37049", 134],
      ["37127", 126],
      ["37031", 110],
      ["37013", 64],
      ["37055", 60],
      ["37065", 59],
      ["37083", 57],
      ["37139", 49],
      ["37181", 48],
      ["37053", 43],
      ["37117", 29],
      ["37091", 24],
      ["37185", 24],
      ["37015", 22],
      ["37131", 22],
      ["37137", 19],
      ["37041", 18],
      ["37143", 18],
      ["37029", 15],
      ["37073", 14],
      ["37077", 14],
      ["37187", 14],
      ["37133", 7],
      ["37095", 6],
      ["37177", 4],
    ],
    harris2024: 0.4418,
    holder: "D",
    id: "NC-01",
    incumbent: "Don Davis",
    left: { name: "Don Davis", party: "D" },
    right: { name: "Laurie Buckhout", party: "R" },
    state: "NC",
  },
  {
    counties: [["37183", 1000]],
    harris2024: 0.6722,
    holder: "D",
    id: "NC-02",
    incumbent: "Deborah Ross",
    left: { name: "Deborah Ross", party: "D" },
    right: { name: "Eugene Douglass", party: "R" },
    state: "NC",
  },
  {
    counties: [
      ["37147", 251],
      ["37133", 227],
      ["37191", 158],
      ["37195", 116],
      ["37107", 79],
      ["37061", 66],
      ["37163", 62],
      ["37079", 24],
      ["37103", 16],
    ],
    harris2024: 0.4312,
    holder: "R",
    id: "NC-03",
    incumbent: "Greg Murphy",
    left: { name: "Raymond Smith", party: "D" },
    right: { name: "Greg Murphy", party: "R" },
    state: "NC",
  },
  {
    counties: [
      ["37063", 414],
      ["37183", 312],
      ["37135", 201],
      ["37037", 73],
    ],
    harris2024: 0.7303,
    holder: "D",
    id: "NC-04",
    incumbent: "Valerie Foushee",
    left: { name: "Valerie Foushee", party: "D" },
    right: { name: "Mahesh Ganorkar", party: "R" },
    state: "NC",
  },
  {
    counties: [
      ["37081", 337],
      ["37157", 122],
      ["37027", 107],
      ["37171", 92],
      ["37193", 89],
      ["37189", 81],
      ["37169", 67],
      ["37003", 51],
      ["37009", 40],
      ["37005", 16],
    ],
    harris2024: 0.4102,
    holder: "R",
    id: "NC-05",
    incumbent: "Virginia Foxx",
    left: { name: "Chuck Hubbard", party: "D" },
    right: { name: "Virginia Foxx", party: "R" },
    state: "NC",
  },
  {
    counties: [
      ["37057", 238],
      ["37081", 215],
      ["37159", 193],
      ["37067", 159],
      ["37025", 127],
      ["37059", 68],
    ],
    harris2024: 0.4131,
    holder: "R",
    id: "NC-06",
    incumbent: "Addison McDowell",
    left: { name: "Cyril Jefferson", party: "D" },
    right: { name: "Addison McDowell", party: "R" },
    state: "NC",
  },
  {
    counties: [
      ["37129", 312],
      ["37019", 246],
      ["37051", 207],
      ["37141", 88],
      ["37047", 59],
      ["37017", 38],
      ["37155", 35],
      ["37163", 15],
    ],
    harris2024: 0.4303,
    holder: "R",
    id: "NC-07",
    incumbent: "David Rouzer",
    left: { name: "Kimberly Hardy", party: "D" },
    right: { name: "David Rouzer", party: "R" },
    state: "NC",
  },
  {
    counties: [
      ["37179", 340],
      ["37119", 179],
      ["37025", 172],
      ["37167", 90],
      ["37155", 76],
      ["37153", 49],
      ["37165", 36],
      ["37123", 32],
      ["37007", 27],
    ],
    harris2024: 0.4021,
    holder: "R",
    id: "NC-08",
    incumbent: "Mark Harris",
    left: { name: "Colby Watson", party: "D" },
    right: { name: "Mark Harris", party: "R" },
    state: "NC",
  },
  {
    counties: [
      ["37001", 235],
      ["37151", 199],
      ["37081", 165],
      ["37125", 161],
      ["37051", 127],
      ["37093", 60],
      ["37037", 53],
    ],
    harris2024: 0.4199,
    holder: "R",
    id: "NC-09",
    incumbent: "Richard Hudson",
    left: { name: "Richard Ojeda", party: "D" },
    right: { name: "Richard Hudson", party: "R" },
    state: "NC",
  },
  {
    counties: [
      ["37067", 342],
      ["37097", 266],
      ["37035", 209],
      ["37109", 134],
      ["37197", 49],
    ],
    harris2024: 0.4105,
    holder: "R",
    id: "NC-10",
    incumbent: "Pat Harrigan",
    left: { name: "Ashley Bell", party: "D" },
    right: { name: "Pat Harrigan", party: "R" },
    state: "NC",
  },
  {
    counties: [
      ["37021", 364],
      ["37089", 158],
      ["37087", 86],
      ["37111", 54],
      ["37099", 50],
      ["37113", 50],
      ["37175", 47],
      ["37039", 40],
      ["37115", 31],
      ["37199", 26],
      ["37011", 22],
      ["37121", 20],
      ["37043", 18],
      ["37173", 16],
      ["37075", 11],
      ["37149", 9],
    ],
    harris2024: 0.4519,
    holder: "R",
    id: "NC-11",
    incumbent: "Chuck Edwards",
    left: { name: "Jamie Ager", party: "D" },
    right: { name: "Jennifer Balkcom", party: "R" },
    state: "NC",
  },
  {
    counties: [["37119", 1000]],
    harris2024: 0.7353,
    holder: "D",
    id: "NC-12",
    incumbent: "Alma Adams",
    left: { name: "Alma Adams", party: "D" },
    right: { name: "Jack Codiga", party: "R" },
    state: "NC",
  },
  {
    counties: [
      ["37101", 293],
      ["37183", 245],
      ["37085", 150],
      ["37069", 100],
      ["37105", 71],
      ["37077", 62],
      ["37145", 52],
      ["37033", 28],
    ],
    harris2024: 0.4167,
    holder: "R",
    id: "NC-13",
    incumbent: "Brad Knott",
    left: { name: "Paul Barringer", party: "D" },
    right: { name: "Brad Knott", party: "R" },
    state: "NC",
  },
  {
    counties: [
      ["37119", 362],
      ["37071", 292],
      ["37045", 127],
      ["37023", 112],
      ["37161", 85],
      ["37149", 22],
    ],
    harris2024: 0.4239,
    holder: "R",
    id: "NC-14",
    incumbent: "Tim Moore",
    left: { name: "Lakesha Womack", party: "D" },
    right: { name: "Tim Moore", party: "R" },
    state: "NC",
  },
  {
    counties: [
      ["38017", 246],
      ["38015", 142],
      ["38035", 85],
      ["38101", 78],
      ["38059", 46],
      ["38089", 41],
      ["38105", 41],
      ["38093", 28],
      ["38077", 22],
      ["38003", 15],
      ["38053", 15],
      ["38055", 15],
      ["38071", 14],
      ["38057", 12],
      ["38099", 12],
      ["38061", 11],
      ["38079", 11],
      ["38097", 11],
      ["38009", 9],
      ["38067", 8],
      ["38021", 7],
      ["38049", 7],
      ["38073", 7],
      ["38025", 6],
      ["38045", 6],
      ["38081", 6],
      ["38103", 6],
      ["38005", 5],
      ["38019", 5],
      ["38029", 5],
      ["38031", 5],
      ["38063", 5],
      ["38069", 5],
      ["38011", 4],
      ["38037", 4],
      ["38039", 4],
      ["38041", 4],
      ["38043", 4],
      ["38051", 4],
      ["38001", 3],
      ["38013", 3],
      ["38023", 3],
      ["38027", 3],
      ["38033", 3],
      ["38047", 3],
      ["38065", 3],
      ["38075", 3],
      ["38085", 3],
      ["38091", 3],
      ["38095", 3],
      ["38007", 2],
      ["38083", 2],
      ["38087", 1],
    ],
    harris2024: 0.313,
    holder: "R",
    id: "ND-AL",
    incumbent: "Julie Fedorchak",
    left: { name: "Trygve Hammer", party: "D" },
    right: { name: "Julie Fedorchak", party: "R" },
    state: "ND",
  },
  {
    counties: [
      ["31109", 495],
      ["31153", 223],
      ["31053", 52],
      ["31025", 49],
      ["31119", 49],
      ["31141", 49],
      ["31159", 29],
      ["31023", 14],
      ["31039", 14],
      ["31037", 11],
      ["31167", 10],
      ["31143", 4],
    ],
    harris2024: 0.4339,
    holder: "R",
    id: "NE-01",
    incumbent: "Mike Flood",
    left: { name: "Christopher Backemeyer", party: "D" },
    right: { name: "Mike Flood", party: "R" },
    state: "NE",
  },
  {
    counties: [
      ["31055", 863],
      ["31153", 94],
      ["31155", 43],
    ],
    harris2024: 0.5234,
    holder: "R",
    id: "NE-02",
    incumbent: "Don Bacon",
    left: { name: "Denise Powell", party: "D" },
    right: { name: "Brinker Harding", party: "R" },
    state: "NE",
  },
  {
    counties: [
      ["31019", 76],
      ["31079", 73],
      ["31111", 53],
      ["31157", 48],
      ["31001", 46],
      ["31177", 40],
      ["31067", 35],
      ["31047", 27],
      ["31131", 26],
      ["31185", 22],
      ["31043", 20],
      ["31041", 19],
      ["31081", 18],
      ["31151", 18],
      ["31089", 17],
      ["31145", 17],
      ["31013", 16],
      ["31027", 16],
      ["31137", 16],
      ["31033", 15],
      ["31107", 14],
      ["31121", 14],
      ["31101", 13],
      ["31147", 13],
      ["31179", 13],
      ["31021", 12],
      ["31045", 12],
      ["31095", 12],
      ["31099", 12],
      ["31139", 12],
      ["31003", 11],
      ["31035", 11],
      ["31093", 11],
      ["31127", 11],
      ["31011", 10],
      ["31031", 10],
      ["31059", 10],
      ["31051", 9],
      ["31169", 9],
      ["31065", 8],
      ["31123", 8],
      ["31161", 8],
      ["31097", 7],
      ["31129", 7],
      ["31173", 7],
      ["31175", 7],
      ["31029", 6],
      ["31083", 6],
      ["31105", 6],
      ["31125", 6],
      ["31181", 6],
      ["31017", 5],
      ["31061", 5],
      ["31063", 5],
      ["31087", 5],
      ["31135", 5],
      ["31143", 5],
      ["31163", 5],
      ["31069", 4],
      ["31073", 4],
      ["31077", 4],
      ["31133", 4],
      ["31015", 3],
      ["31049", 3],
      ["31057", 3],
      ["31071", 3],
      ["31149", 3],
      ["31085", 2],
      ["31103", 2],
      ["31165", 2],
      ["31183", 2],
      ["31005", 1],
      ["31007", 1],
      ["31009", 1],
      ["31075", 1],
      ["31091", 1],
      ["31113", 1],
      ["31115", 1],
      ["31117", 1],
      ["31171", 1],
    ],
    harris2024: 0.2278,
    holder: "R",
    id: "NE-03",
    incumbent: "Adrian Smith",
    left: { name: "Becky Lynn Stille", party: "D" },
    right: { name: "Adrian Smith", party: "R" },
    state: "NE",
  },
  {
    counties: [
      ["33015", 393],
      ["33011", 230],
      ["33017", 185],
      ["33001", 92],
      ["33003", 78],
      ["33013", 22],
    ],
    harris2024: 0.5101,
    holder: "D",
    id: "NH-01",
    incumbent: "Chris Pappas",
    left: { name: "Stefany Shaheen", party: "D" },
    right: { name: "Anthony DiLorenzo", party: "R" },
    state: "NH",
  },
  {
    counties: [
      ["33011", 338],
      ["33013", 204],
      ["33009", 136],
      ["33005", 110],
      ["33015", 98],
      ["33019", 61],
      ["33007", 42],
      ["33001", 6],
      ["33003", 6],
    ],
    harris2024: 0.5181,
    holder: "D",
    id: "NH-02",
    incumbent: "Maggie Goodlander",
    left: { name: "Maggie Goodlander", party: "D" },
    right: { name: "Lily Williams", party: "R" },
    state: "NH",
  },
  {
    counties: [
      ["34007", 656],
      ["34015", 313],
      ["34005", 31],
    ],
    harris2024: 0.5951,
    holder: "D",
    id: "NJ-01",
    incumbent: "Donald Norcross",
    left: { name: "Donald Norcross", party: "D" },
    right: { name: "Damon Galdo", party: "R" },
    state: "NJ",
  },
  {
    counties: [
      ["34001", 335],
      ["34029", 178],
      ["34011", 144],
      ["34009", 141],
      ["34015", 121],
      ["34033", 80],
    ],
    harris2024: 0.4363,
    holder: "R",
    id: "NJ-02",
    incumbent: "Jeff Van Drew",
    left: { name: "Zack Mullock", party: "D" },
    right: { name: "Jeff Van Drew", party: "R" },
    state: "NJ",
  },
  {
    counties: [
      ["34005", 546],
      ["34025", 238],
      ["34021", 216],
    ],
    harris2024: 0.5425,
    holder: "D",
    id: "NJ-03",
    incumbent: "Herb Conaway",
    left: { name: "Herbert C. Conaway", party: "D" },
    right: { name: "Michael McGuire", party: "R" },
    state: "NJ",
  },
  {
    counties: [
      ["34029", 645],
      ["34025", 355],
    ],
    harris2024: 0.3473,
    holder: "R",
    id: "NJ-04",
    incumbent: "Chris Smith",
    left: { name: "Rachel Peace", party: "D" },
    right: { name: "Chris Smith", party: "R" },
    state: "NJ",
  },
  {
    counties: [
      ["34003", 798],
      ["34037", 120],
      ["34031", 82],
    ],
    harris2024: 0.5077,
    holder: "D",
    id: "NJ-05",
    incumbent: "Josh Gottheimer",
    left: { name: "Josh Gottheimer", party: "D" },
    right: { name: "Sean Kirrane", party: "R" },
    state: "NJ",
  },
  {
    counties: [
      ["34023", 636],
      ["34025", 364],
    ],
    harris2024: 0.5329,
    holder: "D",
    id: "NJ-06",
    incumbent: "Frank Pallone",
    left: { name: "Frank Pallone", party: "D" },
    right: { name: "Hillary Herzig", party: "R" },
    state: "NJ",
  },
  {
    counties: [
      ["34039", 245],
      ["34035", 203],
      ["34019", 181],
      ["34027", 154],
      ["34041", 135],
      ["34037", 81],
    ],
    harris2024: 0.494,
    holder: "R",
    id: "NJ-07",
    incumbent: "Tom Kean",
    left: { name: "Rebecca Bennett", party: "D" },
    right: { name: "Thomas Kean", party: "R" },
    state: "NJ",
  },
  {
    counties: [
      ["34017", 759],
      ["34039", 140],
      ["34013", 102],
    ],
    harris2024: 0.6241,
    holder: "D",
    id: "NJ-08",
    incumbent: "Rob Menendez",
    left: { name: "Robert Menendez", party: "D" },
    right: null,
    state: "NJ",
  },
  {
    counties: [
      ["34003", 481],
      ["34031", 448],
      ["34017", 72],
    ],
    harris2024: 0.4941,
    holder: "D",
    id: "NJ-09",
    incumbent: "Nellie Pou",
    left: { name: "Nellie Pou", party: "D" },
    right: { name: "Rosemary Pino", party: "R" },
    state: "NJ",
  },
  {
    counties: [
      ["34013", 517],
      ["34039", 324],
      ["34017", 159],
    ],
    harris2024: 0.7583,
    holder: "D",
    id: "NJ-10",
    incumbent: "LaMonica McIver",
    left: { name: "LaMonica McIver", party: "D" },
    right: { name: "Carmen Bucco", party: "R" },
    state: "NJ",
  },
  {
    counties: [
      ["34027", 524],
      ["34013", 375],
      ["34031", 101],
    ],
    harris2024: 0.5445,
    holder: "D",
    id: "NJ-11",
    incumbent: "Analilia Mejia",
    left: { name: "Analilia Mejia", party: "D" },
    right: { name: "Joe Hathaway", party: "R" },
    state: "NJ",
  },
  {
    counties: [
      ["34023", 474],
      ["34035", 255],
      ["34021", 228],
      ["34039", 43],
    ],
    harris2024: 0.6227,
    holder: "D",
    id: "NJ-12",
    incumbent: "Bonnie Watson Coleman",
    left: { name: "Adam Hamawy", party: "D" },
    right: { name: "Gregg Mele", party: "R" },
    state: "NJ",
  },
  {
    counties: [
      ["35001", 680],
      ["35043", 201],
      ["35061", 39],
      ["35027", 29],
      ["35057", 20],
      ["35049", 16],
      ["35005", 6],
      ["35019", 5],
      ["35011", 2],
      ["35035", 1],
    ],
    harris2024: 0.565,
    holder: "D",
    id: "NM-01",
    incumbent: "Melanie Stansbury",
    left: { name: "Melanie Ann Stansbury", party: "D" },
    right: { name: "Ndidiamaka Okpareke", party: "R" },
    state: "NM",
  },
  {
    counties: [
      ["35013", 314],
      ["35001", 259],
      ["35035", 88],
      ["35061", 71],
      ["35015", 62],
      ["35017", 52],
      ["35006", 33],
      ["35029", 30],
      ["35053", 27],
      ["35051", 22],
      ["35025", 17],
      ["35003", 9],
      ["35031", 9],
      ["35023", 7],
    ],
    harris2024: 0.4908,
    holder: "D",
    id: "NM-02",
    incumbent: "Gabe Vasquez",
    left: { name: "Gabriel Vasquez", party: "D" },
    right: { name: "Greg Cunningham", party: "R" },
    state: "NM",
  },
  {
    counties: [
      ["35049", 262],
      ["35045", 178],
      ["35031", 79],
      ["35005", 67],
      ["35025", 56],
      ["35055", 56],
      ["35039", 54],
      ["35009", 51],
      ["35028", 41],
      ["35047", 37],
      ["35043", 29],
      ["35015", 22],
      ["35041", 22],
      ["35007", 20],
      ["35037", 12],
      ["35033", 8],
      ["35059", 6],
      ["35021", 1],
    ],
    harris2024: 0.5266,
    holder: "D",
    id: "NM-03",
    incumbent: "Teresa Leger Fernandez",
    left: { name: "Teresa Leger Fernandez", party: "D" },
    right: { name: "Martin Ruben Zamora", party: "R" },
    state: "NM",
  },
  {
    counties: [["32003", 1000]],
    harris2024: 0.5115,
    holder: "D",
    id: "NV-01",
    incumbent: "Dina Titus",
    left: { name: "Dina Titus", party: "D" },
    right: { name: "Carrie Buck", party: "R" },
    state: "NV",
  },
  {
    counties: [
      ["32031", 626],
      ["32005", 84],
      ["32019", 79],
      ["32510", 74],
      ["32007", 53],
      ["32001", 32],
      ["32013", 19],
      ["32033", 10],
      ["32029", 7],
      ["32015", 6],
      ["32027", 5],
      ["32011", 2],
    ],
    harris2024: 0.4287,
    holder: "R",
    id: "NV-02",
    incumbent: "Mark Amodei",
    left: { name: "Teresa Benitez-Thompson", party: "D" },
    right: { name: "David Flippo", party: "R" },
    state: "NV",
  },
  {
    counties: [["32003", 1000]],
    harris2024: 0.4963,
    holder: "D",
    id: "NV-03",
    incumbent: "Susie Lee",
    left: { name: "Susie Lee", party: "D" },
    right: { name: "Marty O'Donnell", party: "R" },
    state: "NV",
  },
  {
    counties: [
      ["32003", 905],
      ["32023", 79],
      ["32017", 7],
      ["32021", 7],
      ["32009", 1],
      ["32019", 1],
    ],
    harris2024: 0.5118,
    holder: "D",
    id: "NV-04",
    incumbent: "Steven Horsford",
    left: { name: "Steven Horsford", party: "D" },
    right: { name: "Cody Whipple", party: "R" },
    state: "NV",
  },
  {
    counties: [["36103", 1000]],
    harris2024: 0.449,
    holder: "R",
    id: "NY-01",
    incumbent: "Nick LaLota",
    left: { name: "Christopher Gallant", party: "D" },
    right: { name: "Nicholas J. LaLota", party: "R" },
    state: "NY",
  },
  {
    counties: [
      ["36103", 869],
      ["36059", 131],
    ],
    harris2024: 0.4296,
    holder: "R",
    id: "NY-02",
    incumbent: "Andrew Garbarino",
    left: { name: "Patrick Halpin", party: "D" },
    right: { name: "Andrew Garbarino", party: "R" },
    state: "NY",
  },
  {
    counties: [
      ["36059", 739],
      ["36081", 194],
      ["36103", 67],
    ],
    harris2024: 0.4783,
    holder: "D",
    id: "NY-03",
    incumbent: "Tom Suozzi",
    left: { name: "Tom Suozzi", party: "D" },
    right: { name: "Michael LiPetri", party: "R" },
    state: "NY",
  },
  {
    counties: [["36059", 1000]],
    harris2024: 0.5065,
    holder: "D",
    id: "NY-04",
    incumbent: "Laura Gillen",
    left: { name: "Laura Gillen", party: "D" },
    right: { name: "Jeanine Driscoll", party: "R" },
    state: "NY",
  },
  {
    counties: [["36081", 1000]],
    harris2024: 0.714,
    holder: "D",
    id: "NY-05",
    incumbent: "Gregory Meeks",
    left: { name: "Gregory W. Meeks", party: "D" },
    right: { name: "George Marsh", party: "R" },
    state: "NY",
  },
  {
    counties: [["36081", 1000]],
    harris2024: 0.5326,
    holder: "D",
    id: "NY-06",
    incumbent: "Grace Meng",
    left: { name: "Grace Meng", party: "D" },
    right: { name: "Joseph Chou", party: "R" },
    state: "NY",
  },
  {
    counties: [
      ["36047", 605],
      ["36081", 395],
    ],
    harris2024: 0.736,
    holder: "D",
    id: "NY-07",
    incumbent: "Nydia Velazquez",
    left: { name: "Claire Valdez", party: "D" },
    right: { name: "Melvin Rivera", party: "R" },
    state: "NY",
  },
  {
    counties: [["36047", 1000]],
    harris2024: 0.7235,
    holder: "D",
    id: "NY-08",
    incumbent: "Hakeem Jeffries",
    left: { name: "Hakeem Jeffries", party: "D" },
    right: { name: "Lewis Mizrahi", party: "R" },
    state: "NY",
  },
  {
    counties: [["36047", 1000]],
    harris2024: 0.7073,
    holder: "D",
    id: "NY-09",
    incumbent: "Yvette Clarke",
    left: { name: "Yvette D. Clarke", party: "D" },
    right: { name: "Joel Anabilah-Azumah", party: "R" },
    state: "NY",
  },
  {
    counties: [
      ["36047", 540],
      ["36061", 460],
    ],
    harris2024: 0.8095,
    holder: "D",
    id: "NY-10",
    incumbent: "Dan Goldman",
    left: { name: "Brad Lander", party: "D" },
    right: { name: "Jennifer Moore", party: "R" },
    state: "NY",
  },
  {
    counties: [
      ["36085", 735],
      ["36047", 265],
    ],
    harris2024: 0.3759,
    holder: "R",
    id: "NY-11",
    incumbent: "Nicole Malliotakis",
    left: { name: "Michael DeCillis", party: "D" },
    right: { name: "Nicole Malliotakis", party: "R" },
    state: "NY",
  },
  {
    counties: [["36061", 1000]],
    harris2024: 0.8245,
    holder: "D",
    id: "NY-12",
    incumbent: "Jerry Nadler",
    left: { name: "Micah Lasher", party: "D" },
    right: { name: "Caroline Shinkle", party: "R" },
    state: "NY",
  },
  {
    counties: [
      ["36061", 811],
      ["36005", 189],
    ],
    harris2024: 0.8014,
    holder: "D",
    id: "NY-13",
    incumbent: "Adriano Espaillat",
    left: { name: "Darializa Avila Chevalier", party: "D" },
    right: { name: "Manual Williams", party: "R" },
    state: "NY",
  },
  {
    counties: [
      ["36005", 516],
      ["36081", 484],
    ],
    harris2024: 0.6618,
    holder: "D",
    id: "NY-14",
    incumbent: "Alexandria Ocasio-Cortez",
    left: { name: "Alexandria Ocasio-Cortez", party: "D" },
    right: { name: "Diamant Hysenaj", party: "R" },
    state: "NY",
  },
  {
    counties: [["36005", 1000]],
    harris2024: 0.744,
    holder: "D",
    id: "NY-15",
    incumbent: "Ritchie Torres",
    left: { name: "Ritchie Torres", party: "D" },
    right: { name: "Stylo A. Sapaskis", party: "R" },
    state: "NY",
  },
  {
    counties: [
      ["36119", 917],
      ["36005", 83],
    ],
    harris2024: 0.6665,
    holder: "D",
    id: "NY-16",
    incumbent: "George Latimer",
    left: { name: "George Latimer", party: "D" },
    right: { name: "Joseph Cinquemani", party: "R" },
    state: "NY",
  },
  {
    counties: [
      ["36119", 408],
      ["36087", 387],
      ["36079", 144],
      ["36027", 61],
    ],
    harris2024: 0.5028,
    holder: "R",
    id: "NY-17",
    incumbent: "Mike Lawler",
    left: { name: "Cait Conley", party: "D" },
    right: { name: "Mike Lawler", party: "R" },
    state: "NY",
  },
  {
    counties: [
      ["36071", 473],
      ["36027", 349],
      ["36111", 178],
    ],
    harris2024: 0.5168,
    holder: "D",
    id: "NY-18",
    incumbent: "Pat Ryan",
    left: { name: "Pat Ryan", party: "D" },
    right: { name: "Jacqueline Auringer", party: "R" },
    state: "NY",
  },
  {
    counties: [
      ["36007", 235],
      ["36109", 122],
      ["36083", 101],
      ["36021", 93],
      ["36105", 91],
      ["36111", 84],
      ["36077", 74],
      ["36039", 66],
      ["36025", 60],
      ["36017", 59],
      ["36023", 14],
    ],
    harris2024: 0.509,
    holder: "D",
    id: "NY-19",
    incumbent: "Josh Riley",
    left: { name: "Josh Riley", party: "D" },
    right: { name: "Peter Oberacker", party: "R" },
    state: "NY",
  },
  {
    counties: [
      ["36001", 400],
      ["36091", 270],
      ["36093", 194],
      ["36083", 107],
      ["36057", 28],
    ],
    harris2024: 0.5716,
    holder: "D",
    id: "NY-20",
    incumbent: "Paul Tonko",
    left: { name: "Paul Tonko", party: "D" },
    right: { name: "Ralph Ambrosio", party: "R" },
    state: "NY",
  },
  {
    counties: [
      ["36089", 124],
      ["36065", 116],
      ["36113", 101],
      ["36019", 100],
      ["36091", 84],
      ["36043", 80],
      ["36115", 80],
      ["36035", 67],
      ["36031", 54],
      ["36033", 54],
      ["36095", 45],
      ["36049", 36],
      ["36057", 29],
      ["36045", 18],
      ["36041", 10],
    ],
    harris2024: 0.3962,
    holder: "R",
    id: "NY-21",
    incumbent: "Elise Stefanik",
    left: { name: "Blake Gendebien", party: "D" },
    right: { name: "Anthony Constantino", party: "R" },
    state: "NY",
  },
  {
    counties: [
      ["36067", 630],
      ["36065", 162],
      ["36053", 94],
      ["36011", 68],
      ["36023", 46],
    ],
    harris2024: 0.5385,
    holder: "D",
    id: "NY-22",
    incumbent: "John Mannion",
    left: { name: "John Mannion", party: "D" },
    right: { name: "Kailee Buller", party: "R" },
    state: "NY",
  },
  {
    counties: [
      ["36029", 421],
      ["36013", 144],
      ["36101", 97],
      ["36015", 95],
      ["36009", 86],
      ["36107", 62],
      ["36003", 52],
      ["36063", 30],
      ["36097", 12],
    ],
    harris2024: 0.3941,
    holder: "R",
    id: "NY-23",
    incumbent: "Nick Langworthy",
    left: { name: "Aaron Gies", party: "D" },
    right: { name: "Nick Langworthy", party: "R" },
    state: "NY",
  },
  {
    counties: [
      ["36075", 144],
      ["36069", 131],
      ["36063", 119],
      ["36117", 119],
      ["36045", 97],
      ["36051", 83],
      ["36037", 76],
      ["36121", 51],
      ["36073", 48],
      ["36099", 40],
      ["36011", 32],
      ["36123", 28],
      ["36101", 19],
      ["36097", 12],
    ],
    harris2024: 0.3838,
    holder: "R",
    id: "NY-24",
    incumbent: "Claudia Tenney",
    left: { name: "Alissa Ellman", party: "D" },
    right: { name: "Claudia Tenney", party: "R" },
    state: "NY",
  },
  {
    counties: [
      ["36055", 970],
      ["36069", 30],
    ],
    harris2024: 0.5933,
    holder: "D",
    id: "NY-25",
    incumbent: "Joe Morelle",
    left: { name: "Joseph Morelle", party: "D" },
    right: { name: "Virginia McIntyre", party: "R" },
    state: "NY",
  },
  {
    counties: [
      ["36029", 864],
      ["36063", 136],
    ],
    harris2024: 0.5978,
    holder: "D",
    id: "NY-26",
    incumbent: "Tim Kennedy",
    left: { name: "Timothy M. Kennedy", party: "D" },
    right: { name: "Dennis Hannon", party: "R" },
    state: "NY",
  },
  {
    counties: [
      ["39061", 596],
      ["39165", 351],
      ["39027", 52],
    ],
    harris2024: 0.4869,
    holder: "D",
    id: "OH-01",
    incumbent: "Greg Landsman",
    left: { name: "Greg Landsman", party: "D" },
    right: { name: "Eric Conroy", party: "R" },
    state: "OH",
  },
  {
    counties: [
      ["39025", 303],
      ["39141", 88],
      ["39145", 83],
      ["39167", 82],
      ["39087", 71],
      ["39009", 68],
      ["39015", 57],
      ["39079", 38],
      ["39073", 36],
      ["39053", 35],
      ["39001", 33],
      ["39131", 32],
      ["39105", 28],
      ["39115", 18],
      ["39163", 15],
      ["39127", 12],
    ],
    harris2024: 0.2876,
    holder: "R",
    id: "OH-02",
    incumbent: "David Taylor",
    left: { name: "Jen Mazzuckelli", party: "D" },
    right: { name: "David Taylor", party: "R" },
    state: "OH",
  },
  {
    counties: [["39049", 1000]],
    harris2024: 0.7033,
    holder: "D",
    id: "OH-03",
    incumbent: "Joyce Beatty",
    left: { name: "Joyce Beatty", party: "D" },
    right: { name: "Cleophus Dulaney", party: "R" },
    state: "OH",
  },
  {
    counties: [
      ["39023", 128],
      ["39003", 117],
      ["39041", 110],
      ["39159", 94],
      ["39101", 69],
      ["39139", 66],
      ["39011", 65],
      ["39149", 64],
      ["39107", 60],
      ["39091", 59],
      ["39021", 52],
      ["39117", 48],
      ["39161", 37],
      ["39065", 33],
    ],
    harris2024: 0.2849,
    holder: "R",
    id: "OH-04",
    incumbent: "Jim Jordan",
    left: { name: "Joshua Kolasinski", party: "D" },
    right: { name: "Jim Jordan", party: "R" },
    state: "OH",
  },
  {
    counties: [
      ["39093", 410],
      ["39173", 115],
      ["39063", 98],
      ["39139", 83],
      ["39143", 77],
      ["39077", 70],
      ["39147", 65],
      ["39033", 52],
      ["39175", 29],
    ],
    harris2024: 0.3801,
    holder: "R",
    id: "OH-05",
    incumbent: "Bob Latta",
    left: { name: "Brian Shaver", party: "D" },
    right: { name: "Bob Latta", party: "R" },
    state: "OH",
  },
  {
    counties: [
      ["39151", 247],
      ["39099", 226],
      ["39029", 131],
      ["39157", 118],
      ["39081", 86],
      ["39013", 85],
      ["39169", 44],
      ["39019", 38],
      ["39067", 19],
      ["39075", 6],
    ],
    harris2024: 0.3255,
    holder: "R",
    id: "OH-06",
    incumbent: "Michael Rulli",
    left: { name: "Elizabeth Kirtley", party: "D" },
    right: { name: "Michael Rulli", party: "R" },
    state: "OH",
  },
  {
    counties: [
      ["39035", 599],
      ["39103", 251],
      ["39169", 87],
      ["39005", 63],
    ],
    harris2024: 0.4442,
    holder: "R",
    id: "OH-07",
    incumbent: "Max Miller",
    left: { name: "Brian Poindexter", party: "D" },
    right: { name: "Max Miller", party: "R" },
    state: "OH",
  },
  {
    counties: [
      ["39061", 429],
      ["39017", 369],
      ["39109", 80],
      ["39037", 67],
      ["39135", 54],
    ],
    harris2024: 0.4211,
    holder: "R",
    id: "OH-08",
    incumbent: "Warren Davidson",
    left: { name: "Vanessa Enoch", party: "D" },
    right: { name: "Warren Davidson", party: "R" },
    state: "OH",
  },
  {
    counties: [
      ["39095", 500],
      ["39043", 104],
      ["39123", 63],
      ["39173", 61],
      ["39051", 59],
      ["39137", 52],
      ["39039", 50],
      ["39171", 48],
      ["39069", 39],
      ["39125", 24],
    ],
    harris2024: 0.4466,
    holder: "D",
    id: "OH-09",
    incumbent: "Marcy Kaptur",
    left: { name: "Marcy Kaptur", party: "D" },
    right: { name: "Derek Merrin", party: "R" },
    state: "OH",
  },
  {
    counties: [
      ["39113", 672],
      ["39057", 237],
      ["39017", 91],
    ],
    harris2024: 0.4607,
    holder: "R",
    id: "OH-10",
    incumbent: "Mike Turner",
    left: { name: "Kristina Knickerbocker", party: "D" },
    right: { name: "Mike Turner", party: "R" },
    state: "OH",
  },
  {
    counties: [["39035", 1000]],
    harris2024: 0.7773,
    holder: "D",
    id: "OH-11",
    incumbent: "Shontel Brown",
    left: { name: "Shontel Brown", party: "D" },
    right: { name: "Mike Kirchner", party: "R" },
    state: "OH",
  },
  {
    counties: [
      ["39089", 232],
      ["39041", 219],
      ["39045", 206],
      ["39119", 96],
      ["39083", 78],
      ["39059", 43],
      ["39031", 40],
      ["39127", 30],
      ["39075", 25],
      ["39111", 17],
      ["39121", 15],
    ],
    harris2024: 0.3482,
    holder: "R",
    id: "OH-12",
    incumbent: "Troy Balderson",
    left: { name: "Jerrad Christian", party: "D" },
    right: { name: "Troy Balderson", party: "R" },
    state: "OH",
  },
  {
    counties: [
      ["39153", 700],
      ["39151", 241],
      ["39133", 59],
    ],
    harris2024: 0.5166,
    holder: "D",
    id: "OH-13",
    incumbent: "Emilia Sykes",
    left: { name: "Emilia Sykes", party: "D" },
    right: { name: "Carey Coleman", party: "R" },
    state: "OH",
  },
  {
    counties: [
      ["39085", 311],
      ["39155", 233],
      ["39133", 146],
      ["39055", 133],
      ["39007", 105],
      ["39099", 72],
    ],
    harris2024: 0.3973,
    holder: "R",
    id: "OH-14",
    incumbent: "Dave Joyce",
    left: { name: "Maria Jukic", party: "D" },
    right: { name: "David Joyce", party: "R" },
    state: "OH",
  },
  {
    counties: [
      ["39049", 663],
      ["39129", 81],
      ["39109", 74],
      ["39097", 57],
      ["39071", 55],
      ["39047", 35],
      ["39023", 34],
    ],
    harris2024: 0.4494,
    holder: "R",
    id: "OH-15",
    incumbent: "Mike Carey",
    left: { name: "Don Leonard", party: "D" },
    right: { name: "Mike Carey", party: "R" },
    state: "OH",
  },
  {
    counties: [
      ["40143", 816],
      ["40145", 100],
      ["40037", 56],
      ["40131", 28],
    ],
    harris2024: 0.39,
    holder: "R",
    id: "OK-01",
    incumbent: "Kevin Hern",
    left: { name: "John Croisant", party: "D" },
    right: { name: "Mark Tedford", party: "R" },
    state: "OK",
  },
  {
    counties: [
      ["40131", 117],
      ["40101", 75],
      ["40147", 71],
      ["40079", 58],
      ["40041", 56],
      ["40013", 55],
      ["40021", 55],
      ["40121", 54],
      ["40097", 53],
      ["40135", 48],
      ["40111", 44],
      ["40089", 35],
      ["40115", 34],
      ["40091", 26],
      ["40001", 22],
      ["40145", 21],
      ["40095", 20],
      ["40035", 19],
      ["40005", 17],
      ["40023", 17],
      ["40061", 15],
      ["40063", 14],
      ["40105", 14],
      ["40127", 14],
      ["40069", 13],
      ["40077", 13],
      ["40107", 12],
      ["40029", 8],
    ],
    harris2024: 0.2174,
    holder: "R",
    id: "OK-02",
    incumbent: "Josh Brecheen",
    left: { name: "Brandon Wade", party: "D" },
    right: { name: "Josh Brecheen", party: "R" },
    state: "OK",
  },
  {
    counties: [
      ["40109", 121],
      ["40017", 116],
      ["40119", 108],
      ["40047", 80],
      ["40113", 76],
      ["40071", 62],
      ["40037", 51],
      ["40039", 37],
      ["40015", 35],
      ["40065", 30],
      ["40009", 28],
      ["40153", 27],
      ["40073", 25],
      ["40117", 25],
      ["40139", 19],
      ["40103", 18],
      ["40149", 17],
      ["40011", 14],
      ["40093", 13],
      ["40151", 13],
      ["40075", 12],
      ["40083", 9],
      ["40003", 8],
      ["40007", 8],
      ["40043", 8],
      ["40053", 8],
      ["40045", 7],
      ["40055", 7],
      ["40129", 6],
      ["40059", 5],
      ["40025", 3],
      ["40057", 3],
    ],
    harris2024: 0.2679,
    holder: "R",
    id: "OK-03",
    incumbent: "Frank Lucas",
    left: { name: "Suzie Byrd", party: "D" },
    right: { name: "Frank Lucas", party: "R" },
    state: "OK",
  },
  {
    counties: [
      ["40027", 386],
      ["40031", 111],
      ["40109", 87],
      ["40051", 82],
      ["40087", 69],
      ["40019", 63],
      ["40137", 60],
      ["40123", 49],
      ["40049", 36],
      ["40099", 19],
      ["40085", 14],
      ["40033", 8],
      ["40067", 8],
      ["40141", 8],
    ],
    harris2024: 0.3306,
    holder: "R",
    id: "OK-04",
    incumbent: "Tom Cole",
    left: { name: "Mitchell Jacob", party: "D" },
    right: { name: "Tom Cole", party: "R" },
    state: "OK",
  },
  {
    counties: [
      ["40109", 665],
      ["40017", 120],
      ["40125", 84],
      ["40083", 63],
      ["40081", 45],
      ["40133", 23],
    ],
    harris2024: 0.4094,
    holder: "R",
    id: "OK-05",
    incumbent: "Stephanie Bice",
    left: { name: "Jena Nelson", party: "D" },
    right: { name: "Stephanie Bice", party: "R" },
    state: "OK",
  },
  {
    counties: [
      ["41067", 549],
      ["41051", 258],
      ["41009", 85],
      ["41007", 63],
      ["41057", 44],
    ],
    harris2024: 0.6956,
    holder: "D",
    id: "OR-01",
    incumbent: "Suzanne Bonamici",
    left: { name: "Suzanne Bonamici", party: "D" },
    right: { name: "Barbara Kahl", party: "R" },
    state: "OR",
  },
  {
    counties: [
      ["41029", 325],
      ["41033", 135],
      ["41035", 97],
      ["41059", 85],
      ["41013", 44],
      ["41017", 44],
      ["41061", 40],
      ["41065", 36],
      ["41019", 34],
      ["41031", 32],
      ["41045", 30],
      ["41001", 26],
      ["41063", 14],
      ["41049", 13],
      ["41023", 12],
      ["41025", 12],
      ["41037", 11],
      ["41021", 3],
      ["41055", 3],
      ["41069", 2],
    ],
    harris2024: 0.3606,
    holder: "R",
    id: "OR-02",
    incumbent: "Cliff Bentz",
    left: { name: "Chris Beck", party: "D" },
    right: { name: "Cliff Bentz", party: "R" },
    state: "OR",
  },
  {
    counties: [
      ["41051", 824],
      ["41005", 140],
      ["41027", 36],
    ],
    harris2024: 0.7381,
    holder: "D",
    id: "OR-03",
    incumbent: "Maxine Dexter",
    left: { name: "Maxine Dexter", party: "D" },
    right: { name: "Loran Ayles", party: "R" },
    state: "OR",
  },
  {
    counties: [
      ["41039", 540],
      ["41003", 128],
      ["41019", 126],
      ["41011", 92],
      ["41041", 76],
      ["41015", 36],
      ["41043", 2],
    ],
    harris2024: 0.5622,
    holder: "D",
    id: "OR-04",
    incumbent: "Val Hoyle",
    left: { name: "Val Hoyle", party: "D" },
    right: { name: "Monique DeSpain", party: "R" },
    state: "OR",
  },
  {
    counties: [
      ["41005", 420],
      ["41017", 268],
      ["41043", 171],
      ["41051", 71],
      ["41047", 70],
    ],
    harris2024: 0.544,
    holder: "D",
    id: "OR-05",
    incumbent: "Janelle Bynum",
    left: { name: "Janelle Bynum", party: "D" },
    right: { name: "Patti Adair", party: "R" },
    state: "OR",
  },
  {
    counties: [
      ["41047", 363],
      ["41067", 273],
      ["41071", 165],
      ["41053", 135],
      ["41005", 64],
    ],
    harris2024: 0.5587,
    holder: "D",
    id: "OR-06",
    incumbent: "Andrea Salinas",
    left: { name: "Andrea Salinas", party: "D" },
    right: { name: "David Russ", party: "R" },
    state: "OR",
  },
  {
    counties: [
      ["42017", 847],
      ["42091", 153],
    ],
    harris2024: 0.5016,
    holder: "R",
    id: "PA-01",
    incumbent: "Brian Fitzpatrick",
    left: { name: "Bob Harvie", party: "D" },
    right: { name: "Brian Fitzpatrick", party: "R" },
    state: "PA",
  },
  {
    counties: [["42101", 1000]],
    harris2024: 0.6808,
    holder: "D",
    id: "PA-02",
    incumbent: "Brendan Boyle",
    left: { name: "Brendan Boyle", party: "D" },
    right: { name: "Jessica Arriaga", party: "R" },
    state: "PA",
  },
  {
    counties: [["42101", 1000]],
    harris2024: 0.8913,
    holder: "D",
    id: "PA-03",
    incumbent: "Dwight Evans",
    left: { name: "Christopher Rabb", party: "D" },
    right: { name: "Mahoney", party: "I" },
    state: "PA",
  },
  {
    counties: [
      ["42091", 834],
      ["42011", 166],
    ],
    harris2024: 0.5798,
    holder: "D",
    id: "PA-04",
    incumbent: "Madeleine Dean",
    left: { name: "Madeleine Dean", party: "D" },
    right: { name: "Aurora Stuski", party: "R" },
    state: "PA",
  },
  {
    counties: [
      ["42045", 784],
      ["42091", 140],
      ["42101", 76],
    ],
    harris2024: 0.6447,
    holder: "D",
    id: "PA-05",
    incumbent: "Mary Gay Scanlon",
    left: { name: "Mary Gay Scanlon", party: "D" },
    right: { name: "Nick Manganaro", party: "R" },
    state: "PA",
  },
  {
    counties: [
      ["42029", 765],
      ["42011", 235],
    ],
    harris2024: 0.5576,
    holder: "D",
    id: "PA-06",
    incumbent: "Chrissy Houlahan",
    left: { name: "Chrissy Houlahan", party: "D" },
    right: { name: "Marty Young", party: "R" },
    state: "PA",
  },
  {
    counties: [
      ["42077", 462],
      ["42095", 434],
      ["42025", 86],
      ["42089", 18],
    ],
    harris2024: 0.4838,
    holder: "R",
    id: "PA-07",
    incumbent: "Ryan Mackenzie",
    left: { name: "Bob Brooks", party: "D" },
    right: { name: "Ryan Mackenzie", party: "R" },
    state: "PA",
  },
  {
    counties: [
      ["42079", 337],
      ["42069", 299],
      ["42089", 200],
      ["42103", 90],
      ["42127", 75],
    ],
    harris2024: 0.4572,
    holder: "R",
    id: "PA-08",
    incumbent: "Rob Bresnahan",
    left: { name: "Paige Cognetti", party: "D" },
    right: { name: "Rob Bresnahan", party: "R" },
    state: "PA",
  },
  {
    counties: [
      ["42075", 185],
      ["42107", 184],
      ["42097", 109],
      ["42081", 92],
      ["42037", 82],
      ["42011", 80],
      ["42015", 78],
      ["42079", 62],
      ["42115", 56],
      ["42131", 38],
      ["42093", 25],
      ["42113", 9],
    ],
    harris2024: 0.3086,
    holder: "R",
    id: "PA-09",
    incumbent: "Dan Meuser",
    left: { name: "Rachel Wallace", party: "D" },
    right: { name: "Dan Meuser", party: "R" },
    state: "PA",
  },
  {
    counties: [
      ["42043", 363],
      ["42041", 331],
      ["42133", 306],
    ],
    harris2024: 0.4735,
    holder: "R",
    id: "PA-10",
    incumbent: "Scott Perry",
    left: { name: "Janelle Stelson", party: "D" },
    right: { name: "Scott Perry", party: "R" },
    state: "PA",
  },
  {
    counties: [
      ["42071", 701],
      ["42133", 299],
    ],
    harris2024: 0.3921,
    holder: "R",
    id: "PA-11",
    incumbent: "Lloyd Smucker",
    left: { name: "Nancy Mannion", party: "D" },
    right: { name: "Lloyd Smucker", party: "R" },
    state: "PA",
  },
  {
    counties: [
      ["42003", 835],
      ["42129", 165],
    ],
    harris2024: 0.5968,
    holder: "D",
    id: "PA-12",
    incumbent: "Summer Lee",
    left: { name: "Summer Lee", party: "D" },
    right: { name: "James Hayes", party: "R" },
    state: "PA",
  },
  {
    counties: [
      ["42055", 203],
      ["42021", 172],
      ["42013", 157],
      ["42001", 147],
      ["42009", 68],
      ["42099", 62],
      ["42061", 56],
      ["42087", 53],
      ["42041", 29],
      ["42067", 29],
      ["42057", 20],
      ["42111", 2],
    ],
    harris2024: 0.2705,
    holder: "R",
    id: "PA-13",
    incumbent: "John Joyce",
    left: { name: "Beth Farnham", party: "D" },
    right: { name: "John Joyce", party: "R" },
    state: "PA",
  },
  {
    counties: [
      ["42129", 334],
      ["42125", 289],
      ["42051", 151],
      ["42111", 95],
      ["42063", 91],
      ["42059", 41],
    ],
    harris2024: 0.332,
    holder: "R",
    id: "PA-14",
    incumbent: "Guy Reschenthaler",
    left: { name: "Alan Bradstock", party: "D" },
    right: { name: "Guy Reschenthaler", party: "R" },
    state: "PA",
  },
  {
    counties: [
      ["42027", 203],
      ["42033", 102],
      ["42005", 93],
      ["42065", 58],
      ["42081", 58],
      ["42117", 54],
      ["42119", 53],
      ["42123", 52],
      ["42031", 50],
      ["42109", 50],
      ["42083", 49],
      ["42035", 47],
      ["42047", 43],
      ["42121", 41],
      ["42105", 23],
      ["42063", 10],
      ["42053", 7],
      ["42023", 6],
    ],
    harris2024: 0.3086,
    holder: "R",
    id: "PA-15",
    incumbent: "Glenn Thompson",
    left: { name: "Ray Bilger", party: "D" },
    right: { name: "Glenn Thompson", party: "R" },
    state: "PA",
  },
  {
    counties: [
      ["42049", 329],
      ["42019", 291],
      ["42085", 140],
      ["42073", 113],
      ["42039", 103],
      ["42121", 25],
    ],
    harris2024: 0.3852,
    holder: "R",
    id: "PA-16",
    incumbent: "Mike Kelly",
    left: { name: "Justin Wagner", party: "D" },
    right: { name: "Mike Kelly", party: "R" },
    state: "PA",
  },
  {
    counties: [
      ["42003", 793],
      ["42007", 207],
    ],
    harris2024: 0.5278,
    holder: "D",
    id: "PA-17",
    incumbent: "Chris Deluzio",
    left: { name: "Chris Deluzio", party: "D" },
    right: { name: "Tony Guy", party: "R" },
    state: "PA",
  },
  {
    counties: [
      ["44007", 690],
      ["44005", 190],
      ["44001", 120],
    ],
    harris2024: 0.6133,
    holder: "D",
    id: "RI-01",
    incumbent: "Gabe Amo",
    left: { name: "Gabe Amo", party: "D" },
    right: { name: "Kellie Keenan", party: "R" },
    state: "RI",
  },
  {
    counties: [
      ["44007", 389],
      ["44003", 337],
      ["44009", 275],
    ],
    harris2024: 0.5347,
    holder: "D",
    id: "RI-02",
    incumbent: "Seth Magaziner",
    left: { name: "Seth Magaziner", party: "D" },
    right: { name: "Victor Mellor", party: "R" },
    state: "RI",
  },
  {
    counties: [
      ["45019", 290],
      ["45015", 282],
      ["45013", 261],
      ["45035", 151],
      ["45053", 12],
      ["45029", 4],
    ],
    harris2024: 0.434,
    holder: "R",
    id: "SC-01",
    incumbent: "Nancy Mace",
    left: { name: "Nancy Lacore", party: "D" },
    right: { name: "Jenny Costa Honeycutt", party: "R" },
    state: "SC",
  },
  {
    counties: [
      ["45063", 401],
      ["45079", 307],
      ["45003", 235],
      ["45075", 30],
      ["45011", 27],
    ],
    harris2024: 0.4294,
    holder: "R",
    id: "SC-02",
    incumbent: "Joe Wilson",
    left: { name: "Zyon Khalifa", party: "D" },
    right: { name: "Joe Wilson", party: "R" },
    state: "SC",
  },
  {
    counties: [
      ["45007", 276],
      ["45077", 170],
      ["45073", 119],
      ["45045", 98],
      ["45047", 87],
      ["45059", 85],
      ["45071", 51],
      ["45037", 39],
      ["45001", 34],
      ["45081", 25],
      ["45065", 17],
    ],
    harris2024: 0.2819,
    holder: "R",
    id: "SC-03",
    incumbent: "Sheri Biggs",
    left: { name: "Eunice Lehmacher", party: "D" },
    right: { name: "Sheri Biggs", party: "R" },
    state: "SC",
  },
  {
    counties: [
      ["45045", 644],
      ["45083", 356],
    ],
    harris2024: 0.3802,
    holder: "R",
    id: "SC-04",
    incumbent: "William Timmons",
    left: { name: "Courtney McClain", party: "D" },
    right: { name: "William Timmons", party: "R" },
    state: "SC",
  },
  {
    counties: [
      ["45091", 402],
      ["45057", 146],
      ["45055", 90],
      ["45085", 90],
      ["45083", 79],
      ["45021", 67],
      ["45023", 42],
      ["45087", 33],
      ["45039", 30],
      ["45061", 22],
    ],
    harris2024: 0.3846,
    holder: "R",
    id: "SC-05",
    incumbent: "Ralph Norman",
    left: { name: "Mallory Dittmer", party: "D" },
    right: { name: "Wes Climer", party: "R" },
    state: "SC",
  },
  {
    counties: [
      ["45019", 314],
      ["45079", 224],
      ["45075", 83],
      ["45035", 55],
      ["45029", 53],
      ["45027", 52],
      ["45089", 46],
      ["45053", 43],
      ["45085", 37],
      ["45049", 26],
      ["45017", 25],
      ["45009", 18],
      ["45041", 13],
      ["45005", 10],
    ],
    harris2024: 0.6152,
    holder: "D",
    id: "SC-06",
    incumbent: "Jim Clyburn",
    left: { name: "James Clyburn", party: "D" },
    right: { name: "John Peterson", party: "R" },
    state: "SC",
  },
  {
    counties: [
      ["45051", 535],
      ["45041", 148],
      ["45043", 98],
      ["45031", 79],
      ["45025", 48],
      ["45067", 35],
      ["45033", 31],
      ["45069", 26],
    ],
    harris2024: 0.3669,
    holder: "R",
    id: "SC-07",
    incumbent: "Russell Fry",
    left: { name: "John Vincent", party: "D" },
    right: { name: "Russell Fry", party: "R" },
    state: "SC",
  },
  {
    counties: [
      ["46099", 219],
      ["46103", 132],
      ["46083", 85],
      ["46013", 40],
      ["46081", 36],
      ["46011", 35],
      ["46093", 34],
      ["46029", 31],
      ["46135", 25],
      ["46035", 21],
      ["46127", 21],
      ["46065", 20],
      ["46005", 16],
      ["46033", 14],
      ["46079", 14],
      ["46027", 13],
      ["46019", 12],
      ["46125", 11],
      ["46047", 10],
      ["46109", 10],
      ["46067", 9],
      ["46023", 8],
      ["46051", 8],
      ["46057", 8],
      ["46009", 7],
      ["46037", 7],
      ["46077", 7],
      ["46087", 7],
      ["46101", 7],
      ["46102", 7],
      ["46115", 7],
      ["46015", 6],
      ["46123", 6],
      ["46129", 6],
      ["46039", 5],
      ["46045", 5],
      ["46053", 5],
      ["46061", 5],
      ["46091", 5],
      ["46121", 5],
      ["46025", 4],
      ["46041", 4],
      ["46043", 4],
      ["46059", 4],
      ["46105", 4],
      ["46117", 4],
      ["46003", 3],
      ["46007", 3],
      ["46031", 3],
      ["46049", 3],
      ["46055", 3],
      ["46071", 3],
      ["46085", 3],
      ["46089", 3],
      ["46097", 3],
      ["46107", 3],
      ["46111", 3],
      ["46021", 2],
      ["46063", 2],
      ["46069", 2],
      ["46073", 2],
      ["46095", 2],
      ["46119", 2],
      ["46137", 2],
      ["46017", 1],
      ["46075", 1],
    ],
    harris2024: 0.3505,
    holder: "R",
    id: "SD-AL",
    incumbent: "Dusty Johnson",
    left: { name: "Nicole Gronli", party: "D" },
    right: { name: "Marty J. Jackley", party: "R" },
    state: "SD",
  },
  {
    counties: [
      ["47163", 217],
      ["47179", 176],
      ["47155", 126],
      ["47059", 89],
      ["47073", 75],
      ["47063", 73],
      ["47089", 71],
      ["47019", 71],
      ["47029", 45],
      ["47171", 25],
      ["47091", 23],
      ["47067", 8],
    ],
    harris2024: 0.2078,
    holder: "R",
    id: "TN-01",
    incumbent: "Diana Harshbarger",
    left: { name: "Kristi Burke", party: "D" },
    right: { name: "Diana Harshbarger", party: "R" },
    state: "TN",
  },
  {
    counties: [
      ["47093", 605],
      ["47009", 189],
      ["47105", 91],
      ["47025", 37],
      ["47057", 30],
      ["47173", 24],
      ["47013", 22],
      ["47089", 3],
    ],
    harris2024: 0.3284,
    holder: "R",
    id: "TN-02",
    incumbent: "Tim Burchett",
    left: { name: "Michaela Barnett", party: "D" },
    right: { name: "Tim Burchett", party: "R" },
    state: "TN",
  },
  {
    counties: [
      ["47065", 480],
      ["47011", 136],
      ["47001", 101],
      ["47145", 75],
      ["47107", 66],
      ["47123", 61],
      ["47143", 39],
      ["47139", 24],
      ["47121", 17],
    ],
    harris2024: 0.319,
    holder: "R",
    id: "TN-03",
    incumbent: "Chuck Fleischmann",
    left: { name: "Anna Golladay", party: "D" },
    right: { name: "Charles J. Fleischmann", party: "R" },
    state: "TN",
  },
  {
    counties: [
      ["47149", 425],
      ["47037", 226],
      ["47031", 82],
      ["47051", 65],
      ["47177", 56],
      ["47115", 46],
      ["47153", 26],
      ["47015", 23],
      ["47061", 21],
      ["47007", 20],
      ["47175", 11],
    ],
    harris2024: 0.3786,
    holder: "R",
    id: "TN-04",
    incumbent: "Scott DesJarlais",
    left: { name: "Victoria Broderick", party: "D" },
    right: { name: "Scott DesJarlais", party: "R" },
    state: "TN",
  },
  {
    counties: [
      ["47187", 254],
      ["47157", 199],
      ["47119", 122],
      ["47079", 48],
      ["47045", 46],
      ["47125", 45],
      ["47183", 43],
      ["47131", 41],
      ["47167", 36],
      ["47081", 33],
      ["47085", 26],
      ["47097", 26],
      ["47005", 23],
      ["47161", 21],
      ["47101", 19],
      ["47083", 12],
      ["47095", 6],
    ],
    harris2024: 0.383,
    holder: "R",
    id: "TN-05",
    incumbent: "Andy Ogles",
    left: { name: "Chaz Molder", party: "D" },
    right: { name: "Charlie Hatcher", party: "R" },
    state: "TN",
  },
  {
    counties: [
      ["47037", 308],
      ["47189", 224],
      ["47035", 96],
      ["47141", 96],
      ["47185", 36],
      ["47133", 31],
      ["47049", 27],
      ["47151", 27],
      ["47041", 26],
      ["47159", 26],
      ["47165", 25],
      ["47129", 24],
      ["47013", 21],
      ["47087", 16],
      ["47027", 10],
      ["47137", 8],
    ],
    harris2024: 0.3656,
    holder: "R",
    id: "TN-06",
    incumbent: "John Rose",
    left: { name: "Mike Croley", party: "D" },
    right: { name: "Johnny Garrett", party: "R" },
    state: "TN",
  },
  {
    counties: [
      ["47037", 303],
      ["47165", 245],
      ["47125", 187],
      ["47147", 97],
      ["47043", 70],
      ["47021", 57],
      ["47111", 29],
      ["47169", 12],
    ],
    harris2024: 0.3864,
    holder: "R",
    id: "TN-07",
    incumbent: "Matt Van Epps",
    left: { name: "Darden Copeland", party: "D" },
    right: { name: "Matt Van Epps", party: "R" },
    state: "TN",
  },
  {
    counties: [
      ["47157", 569],
      ["47113", 124],
      ["47053", 67],
      ["47167", 48],
      ["47017", 37],
      ["47077", 37],
      ["47047", 26],
      ["47023", 24],
      ["47075", 21],
      ["47033", 18],
      ["47039", 17],
      ["47135", 12],
    ],
    harris2024: 0.3978,
    holder: "R",
    id: "TN-08",
    incumbent: "David Kustoff",
    left: { name: "Heidi Kuhn", party: "D" },
    right: { name: "David Kustoff", party: "R" },
    state: "TN",
  },
  {
    counties: [
      ["47157", 252],
      ["47187", 201],
      ["47003", 62],
      ["47099", 61],
      ["47149", 56],
      ["47103", 50],
      ["47117", 50],
      ["47047", 48],
      ["47119", 43],
      ["47055", 42],
      ["47071", 38],
      ["47109", 35],
      ["47069", 29],
      ["47181", 21],
      ["47127", 11],
    ],
    harris2024: 0.3929,
    holder: "D",
    id: "TN-09",
    incumbent: "Steve Cohen",
    left: { name: "Justin Pearson", party: "D" },
    right: { name: "Brent Taylor", party: "R" },
    state: "TN",
  },
  {
    counties: [
      ["48423", 319],
      ["48183", 144],
      ["48203", 93],
      ["48037", 84],
      ["48347", 78],
      ["48401", 67],
      ["48073", 63],
      ["48067", 43],
      ["48365", 35],
      ["48419", 31],
      ["48403", 17],
      ["48315", 14],
      ["48405", 12],
    ],
    harris2024: 0.2505,
    holder: "R",
    id: "TX-01",
    incumbent: "Nathaniel Moran",
    left: { name: "Yolanda Prince", party: "D" },
    right: { name: "Nathaniel Moran", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48201", 533],
      ["48339", 467],
    ],
    harris2024: 0.3843,
    holder: "R",
    id: "TX-02",
    incumbent: "Dan Crenshaw",
    left: { name: "Shaun Finnie", party: "D" },
    right: { name: "Steve Toth", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48085", 806],
      ["48231", 84],
      ["48223", 45],
      ["48449", 28],
      ["48343", 15],
      ["48159", 14],
      ["48119", 7],
    ],
    harris2024: 0.3801,
    holder: "R",
    id: "TX-03",
    incumbent: "Keith Self",
    left: { name: "Evan Hunt", party: "D" },
    right: { name: "Keith Self", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48085", 548],
      ["48181", 180],
      ["48121", 128],
      ["48277", 58],
      ["48147", 45],
      ["48037", 26],
      ["48387", 16],
    ],
    harris2024: 0.3742,
    holder: "R",
    id: "TX-04",
    incumbent: "Pat Fallon",
    left: { name: "Jason Pearce", party: "D" },
    right: { name: "Pat Fallon", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48113", 469],
      ["48257", 237],
      ["48213", 132],
      ["48467", 96],
      ["48001", 66],
    ],
    harris2024: 0.3908,
    holder: "R",
    id: "TX-05",
    incumbent: "Lance Gooden",
    left: { name: "Chelsey Hockett", party: "D" },
    right: { name: "Lance Gooden", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48139", 322],
      ["48439", 318],
      ["48113", 157],
      ["48251", 140],
      ["48349", 64],
    ],
    harris2024: 0.3836,
    holder: "R",
    id: "TX-06",
    incumbent: "Jake Ellzey",
    left: { name: "Danny Minton", party: "D" },
    right: { name: "Jake Ellzey", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48201", 750],
      ["48157", 250],
    ],
    harris2024: 0.6205,
    holder: "D",
    id: "TX-07",
    incumbent: "Lizzie Fletcher",
    left: { name: "Lizzie Pannill Fletcher", party: "D" },
    right: { name: "Alexander Hale", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48339", 486],
      ["48201", 396],
      ["48473", 89],
      ["48471", 29],
    ],
    harris2024: 0.36,
    holder: "R",
    id: "TX-08",
    incumbent: "Morgan Luttrell",
    left: { name: "Laura Jones", party: "D" },
    right: { name: "Jessica Steinmann", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48201", 841],
      ["48291", 159],
    ],
    harris2024: 0.4002,
    holder: "D",
    id: "TX-09",
    incumbent: "Al Green",
    left: { name: "Leticia Gutierrez", party: "D" },
    right: { name: "Alex Mealer", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48453", 408],
      ["48041", 261],
      ["48373", 69],
      ["48471", 46],
      ["48185", 40],
      ["48407", 36],
      ["48051", 27],
      ["48225", 27],
      ["48289", 26],
      ["48287", 24],
      ["48455", 21],
      ["48313", 16],
      ["48021", 1],
    ],
    harris2024: 0.3853,
    holder: "R",
    id: "TX-10",
    incumbent: "Michael McCaul",
    left: { name: "Caitlin Rourk", party: "D" },
    right: { name: "Chris Gober", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48453", 246],
      ["48329", 201],
      ["48451", 156],
      ["48135", 146],
      ["48049", 58],
      ["48299", 47],
      ["48491", 42],
      ["48053", 17],
      ["48083", 14],
      ["48399", 14],
      ["48307", 12],
      ["48319", 9],
      ["48411", 9],
      ["48267", 8],
      ["48081", 6],
      ["48095", 4],
      ["48327", 4],
      ["48235", 3],
      ["48173", 2],
      ["48431", 2],
    ],
    harris2024: 0.3261,
    holder: "R",
    id: "TX-11",
    incumbent: "August Pfluger",
    left: { name: "Claire Reynolds", party: "D" },
    right: { name: "August Pfluger", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48439", 782],
      ["48367", 218],
    ],
    harris2024: 0.3792,
    holder: "R",
    id: "TX-12",
    incumbent: "Craig Goldman",
    left: { name: "Heli Rodriguez Prilliman", party: "D" },
    right: { name: "Craig Goldman", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48381", 220],
      ["48121", 220],
      ["48485", 147],
      ["48375", 106],
      ["48337", 37],
      ["48233", 27],
      ["48179", 25],
      ["48497", 21],
      ["48077", 19],
      ["48341", 18],
      ["48009", 17],
      ["48487", 15],
      ["48117", 14],
      ["48065", 10],
      ["48357", 10],
      ["48075", 7],
      ["48195", 7],
      ["48205", 7],
      ["48483", 7],
      ["48023", 6],
      ["48129", 6],
      ["48111", 5],
      ["48197", 5],
      ["48211", 5],
      ["48275", 5],
      ["48011", 4],
      ["48087", 4],
      ["48191", 4],
      ["48295", 4],
      ["48125", 3],
      ["48359", 3],
      ["48421", 3],
      ["48045", 2],
      ["48101", 2],
      ["48155", 2],
      ["48345", 2],
      ["48393", 2],
    ],
    harris2024: 0.2667,
    holder: "R",
    id: "TX-13",
    incumbent: "Ronny Jackson",
    left: { name: "Mark Nair", party: "D" },
    right: { name: "Ronny L. Jackson", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48167", 474],
      ["48039", 178],
      ["48245", 134],
      ["48361", 108],
      ["48157", 105],
    ],
    harris2024: 0.3771,
    holder: "R",
    id: "TX-14",
    incumbent: "Randy Weber",
    left: { name: "Thurman Bill Bartie", party: "D" },
    right: { name: "Randy Weber", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48215", 633],
      ["48409", 70],
      ["48249", 58],
      ["48285", 46],
      ["48007", 45],
      ["48025", 39],
      ["48123", 34],
      ["48177", 34],
      ["48175", 17],
      ["48391", 12],
      ["48047", 11],
    ],
    harris2024: 0.4099,
    holder: "R",
    id: "TX-15",
    incumbent: "Monica De La Cruz",
    left: { name: "Bobby Pulido", party: "D" },
    right: { name: "Monica De La Cruz", party: "R" },
    state: "TX",
  },
  {
    counties: [["48141", 1000]],
    harris2024: 0.5832,
    holder: "D",
    id: "TX-16",
    incumbent: "Veronica Escobar",
    left: { name: "Veronica Escobar", party: "D" },
    right: { name: "Adam Bauman", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48491", 403],
      ["48309", 311],
      ["48217", 52],
      ["48027", 40],
      ["48331", 35],
      ["48035", 30],
      ["48161", 28],
      ["48293", 28],
      ["48251", 27],
      ["48395", 25],
      ["48145", 20],
    ],
    harris2024: 0.3902,
    holder: "R",
    id: "TX-17",
    incumbent: "Pete Sessions",
    left: { name: "Casey Shepard", party: "D" },
    right: { name: "Pete Sessions", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48201", 763],
      ["48157", 237],
    ],
    harris2024: 0.7786,
    holder: "D",
    id: "TX-18",
    incumbent: "Christian Menefee",
    left: { name: "Christian Menefee", party: "D" },
    right: { name: "Ronald Whitfield", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48303", 443],
      ["48441", 196],
      ["48227", 34],
      ["48189", 33],
      ["48219", 28],
      ["48253", 25],
      ["48165", 23],
      ["48003", 21],
      ["48415", 20],
      ["48353", 18],
      ["48279", 15],
      ["48115", 12],
      ["48445", 12],
      ["48305", 9],
      ["48335", 9],
      ["48369", 9],
      ["48207", 8],
      ["48437", 8],
      ["48501", 8],
      ["48069", 7],
      ["48107", 7],
      ["48153", 7],
      ["48317", 7],
      ["48017", 6],
      ["48151", 6],
      ["48169", 6],
      ["48417", 6],
      ["48079", 3],
      ["48433", 3],
      ["48447", 3],
      ["48059", 3],
      ["48263", 2],
      ["48033", 1],
    ],
    harris2024: 0.2392,
    holder: "R",
    id: "TX-19",
    incumbent: "Jodey Arrington",
    left: { name: "Kyle Rable", party: "D" },
    right: { name: "Tom Sell", party: "R" },
    state: "TX",
  },
  {
    counties: [["48029", 1000]],
    harris2024: 0.6444,
    holder: "D",
    id: "TX-20",
    incumbent: "Joaquin Castro",
    left: { name: "Joaquin Castro", party: "D" },
    right: { name: "Edgardo Baez", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48029", 374],
      ["48091", 250],
      ["48209", 139],
      ["48259", 71],
      ["48265", 68],
      ["48171", 40],
      ["48019", 33],
      ["48031", 21],
      ["48385", 5],
    ],
    harris2024: 0.3896,
    holder: "R",
    id: "TX-21",
    incumbent: "Chip Roy",
    left: { name: "Kristin Hook", party: "D" },
    right: { name: "Mark Teixeira", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48157", 616],
      ["48201", 196],
      ["48039", 188],
    ],
    harris2024: 0.3864,
    holder: "R",
    id: "TX-22",
    incumbent: "Troy Nehls",
    left: { name: "Marquette Greene-Scott", party: "D" },
    right: { name: "Trever Nehls", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48029", 605],
      ["48325", 77],
      ["48141", 70],
      ["48465", 46],
      ["48323", 40],
      ["48463", 31],
      ["48163", 16],
      ["48043", 14],
      ["48371", 13],
      ["48475", 12],
      ["48389", 11],
      ["48507", 11],
      ["48377", 6],
      ["48495", 6],
      ["48103", 4],
      ["48105", 4],
      ["48243", 4],
      ["48271", 4],
      ["48435", 4],
      ["48461", 4],
      ["48137", 3],
      ["48229", 3],
      ["48383", 3],
      ["48413", 3],
      ["48109", 2],
      ["48443", 1],
    ],
    harris2024: 0.4251,
    holder: "R",
    id: "TX-23",
    incumbent: "Vacant (Gonzales)",
    left: { name: "Katy Padilla Stout", party: "D" },
    right: { name: "Brandon Herrera", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48439", 687],
      ["48113", 313],
    ],
    harris2024: 0.4181,
    holder: "R",
    id: "TX-24",
    incumbent: "Beth Van Duyne",
    left: { name: "Kevin Burge", party: "D" },
    right: { name: "Beth Van Duyne", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48439", 475],
      ["48221", 118],
      ["48251", 93],
      ["48367", 73],
      ["48143", 59],
      ["48363", 43],
      ["48133", 27],
      ["48503", 27],
      ["48093", 21],
      ["48059", 20],
      ["48425", 17],
      ["48237", 14],
      ["48429", 12],
    ],
    harris2024: 0.3783,
    holder: "R",
    id: "TX-25",
    incumbent: "Roger Williams",
    left: { name: "Dione Sims", party: "D" },
    right: { name: "Roger Williams", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48121", 865],
      ["48497", 83],
      ["48097", 53],
    ],
    harris2024: 0.3793,
    holder: "R",
    id: "TX-26",
    incumbent: "Brandon Gill",
    left: { name: "Steven Shook", party: "D" },
    right: { name: "Brandon Gill", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48209", 211],
      ["48021", 121],
      ["48453", 119],
      ["48469", 109],
      ["48477", 56],
      ["48481", 51],
      ["48015", 48],
      ["48055", 48],
      ["48149", 41],
      ["48321", 41],
      ["48355", 41],
      ["48089", 31],
      ["48409", 30],
      ["48057", 24],
      ["48239", 20],
      ["48007", 8],
      ["48391", 1],
    ],
    harris2024: 0.3927,
    holder: "R",
    id: "TX-27",
    incumbent: "Michael Cloud",
    left: { name: "Tanya Lloyd", party: "D" },
    right: { name: "Michael Cloud", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48215", 367],
      ["48479", 331],
      ["48013", 93],
      ["48427", 83],
      ["48297", 26],
      ["48505", 24],
      ["48131", 22],
      ["48127", 17],
      ["48323", 15],
      ["48283", 12],
      ["48247", 8],
      ["48311", 2],
    ],
    harris2024: 0.4477,
    holder: "D",
    id: "TX-28",
    incumbent: "Henry Cuellar",
    left: { name: "Henry Cuellar", party: "D" },
    right: { name: "Tano Tijerina", party: "R" },
    state: "TX",
  },
  {
    counties: [["48201", 1000]],
    harris2024: 0.6542,
    holder: "D",
    id: "TX-29",
    incumbent: "Sylvia Garcia",
    left: { name: "Sylvia Garcia", party: "D" },
    right: { name: "Martha Fierro", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48113", 685],
      ["48439", 315],
    ],
    harris2024: 0.739,
    holder: "D",
    id: "TX-30",
    incumbent: "Jasmine Crockett",
    left: { name: "Frederick Haynes", party: "D" },
    right: { name: "Everett Jackson", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48491", 477],
      ["48027", 336],
      ["48099", 68],
      ["48053", 66],
      ["48281", 32],
      ["48193", 13],
      ["48333", 8],
    ],
    harris2024: 0.3893,
    holder: "R",
    id: "TX-31",
    incumbent: "John Carter",
    left: { name: "Justin Early", party: "D" },
    right: { name: "John Carter", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48113", 532],
      ["48397", 193],
      ["48499", 76],
      ["48459", 62],
      ["48085", 53],
      ["48231", 48],
      ["48379", 20],
      ["48063", 16],
    ],
    harris2024: 0.4094,
    holder: "D",
    id: "TX-32",
    incumbent: "Julie Johnson",
    left: { name: "Dan Barrios", party: "D" },
    right: { name: "Jace Yarbrough", party: "R" },
    state: "TX",
  },
  {
    counties: [["48113", 1000]],
    harris2024: 0.6667,
    holder: "D",
    id: "TX-33",
    incumbent: "Marc Veasey",
    left: { name: "Colin Allred", party: "D" },
    right: { name: "Patrick Gillespie", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48061", 483],
      ["48355", 451],
      ["48273", 42],
      ["48489", 23],
      ["48261", 1],
    ],
    harris2024: 0.4489,
    holder: "D",
    id: "TX-34",
    incumbent: "Vicente Gonzalez",
    left: { name: "Vicente Gonzalez", party: "D" },
    right: { name: "Eric Flores", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48029", 610],
      ["48187", 283],
      ["48493", 91],
      ["48255", 17],
    ],
    harris2024: 0.4472,
    holder: "D",
    id: "TX-35",
    incumbent: "Greg Casar",
    left: { name: "Johnny Garcia", party: "D" },
    right: { name: "Carlos De La Cruz", party: "R" },
    state: "TX",
  },
  {
    counties: [
      ["48201", 361],
      ["48245", 133],
      ["48039", 126],
      ["48005", 110],
      ["48199", 90],
      ["48071", 80],
      ["48241", 51],
      ["48457", 31],
      ["48351", 18],
    ],
    harris2024: 0.3734,
    holder: "R",
    id: "TX-36",
    incumbent: "Brian Babin",
    left: { name: "Rhonda Hart", party: "D" },
    right: { name: "Brian Babin", party: "R" },
    state: "TX",
  },
  {
    counties: [["48453", 1000]],
    harris2024: 0.7885,
    holder: "D",
    id: "TX-37",
    incumbent: "Lloyd Doggett",
    left: { name: "Greg Casar", party: "D" },
    right: { name: "Lauren Peña", party: "R" },
    state: "TX",
  },
  {
    counties: [["48201", 1000]],
    harris2024: 0.3935,
    holder: "R",
    id: "TX-38",
    incumbent: "Wesley Hunt",
    left: { name: "Melissa McDonough", party: "D" },
    right: { name: "Jon Bonck", party: "R" },
    state: "TX",
  },
  {
    counties: [["49035", 1000]],
    harris2024: 0.6216,
    holder: "R",
    id: "UT-01",
    incumbent: "Blake Moore",
    left: { name: "Ben McAdams", party: "D" },
    right: { name: "Riley Owen", party: "R" },
    state: "UT",
  },
  {
    counties: [
      ["49011", 451],
      ["49057", 303],
      ["49005", 163],
      ["49003", 78],
      ["49033", 4],
    ],
    harris2024: 0.3504,
    holder: "R",
    id: "UT-02",
    incumbent: "Celeste Maloy",
    left: { name: "Peter Crosby", party: "D" },
    right: { name: "Blake Moore", party: "R" },
    state: "UT",
  },
  {
    counties: [
      ["49049", 376],
      ["49053", 252],
      ["49021", 72],
      ["49043", 67],
      ["49051", 48],
      ["49047", 41],
      ["49007", 24],
      ["49013", 23],
      ["49029", 17],
      ["49037", 16],
      ["49019", 14],
      ["49015", 13],
      ["49025", 12],
      ["49001", 8],
      ["49017", 7],
      ["49055", 4],
      ["49031", 2],
      ["49009", 1],
      ["49057", 1],
    ],
    harris2024: 0.2879,
    holder: "R",
    id: "UT-03",
    incumbent: "Mike Kennedy",
    left: { name: "Kent Udell", party: "D" },
    right: { name: "Celeste Maloy", party: "R" },
    state: "UT",
  },
  {
    counties: [
      ["49035", 449],
      ["49049", 377],
      ["49045", 84],
      ["49039", 32],
      ["49041", 27],
      ["49023", 16],
      ["49027", 16],
    ],
    harris2024: 0.3328,
    holder: "R",
    id: "UT-04",
    incumbent: "Burgess Owens",
    left: { name: "Jonny Larsen", party: "D" },
    right: { name: "Mike Kennedy", party: "R" },
    state: "UT",
  },
  {
    counties: [
      ["51041", 225],
      ["51087", 213],
      ["51085", 126],
      ["51095", 105],
      ["51199", 82],
      ["51073", 48],
      ["51127", 35],
      ["51101", 24],
      ["51193", 22],
      ["51133", 17],
      ["51735", 17],
      ["51830", 16],
      ["51103", 15],
      ["51119", 14],
      ["51057", 13],
      ["51115", 12],
      ["51097", 9],
      ["51159", 9],
    ],
    harris2024: 0.475,
    holder: "R",
    id: "VA-01",
    incumbent: "Rob Wittman",
    left: { name: "Shannon Taylor", party: "D" },
    right: { name: "Robert J. Wittman", party: "R" },
    state: "VA",
  },
  {
    counties: [
      ["51810", 552],
      ["51550", 177],
      ["51800", 129],
      ["51093", 60],
      ["51001", 42],
      ["51131", 17],
      ["51175", 15],
      ["51620", 9],
    ],
    harris2024: 0.4987,
    holder: "R",
    id: "VA-02",
    incumbent: "Jen Kiggans",
    left: { name: "Elaine Luria", party: "D" },
    right: { name: "Jen A. Kiggans", party: "R" },
    state: "VA",
  },
  {
    counties: [
      ["51710", 268],
      ["51700", 237],
      ["51650", 196],
      ["51550", 171],
      ["51740", 129],
    ],
    harris2024: 0.6759,
    holder: "D",
    id: "VA-03",
    incumbent: "Bobby Scott",
    left: { name: "Robert C. Scott", party: "D" },
    right: { name: "Edwin Rivera", party: "R" },
    state: "VA",
  },
  {
    counties: [
      ["51760", 283],
      ["51041", 264],
      ["51087", 202],
      ["51149", 46],
      ["51053", 41],
      ["51730", 34],
      ["51670", 24],
      ["51570", 23],
      ["51025", 20],
      ["51183", 13],
      ["51181", 12],
      ["51036", 11],
      ["51081", 11],
      ["51175", 10],
      ["51595", 6],
    ],
    harris2024: 0.6659,
    holder: "D",
    id: "VA-04",
    incumbent: "Jennifer McClellan",
    left: { name: "Jennifer McClellan", party: "D" },
    right: { name: "Robert Murray", party: "R" },
    state: "VA",
  },
  {
    counties: [
      ["51003", 151],
      ["51680", 83],
      ["51143", 77],
      ["51031", 70],
      ["51109", 54],
      ["51540", 53],
      ["51145", 47],
      ["51075", 44],
      ["51019", 43],
      ["51590", 40],
      ["51083", 40],
      ["51009", 39],
      ["51065", 38],
      ["51117", 37],
      ["51085", 27],
      ["51011", 22],
      ["51125", 21],
      ["51147", 21],
      ["51007", 18],
      ["51029", 18],
      ["51135", 15],
      ["51037", 14],
      ["51111", 13],
      ["51049", 12],
    ],
    harris2024: 0.438,
    holder: "R",
    id: "VA-05",
    incumbent: "John McGuire",
    left: { name: "Tom Perriello", party: "D" },
    right: { name: "John McGuire", party: "R" },
    state: "VA",
  },
  {
    counties: [
      ["51069", 126],
      ["51165", 118],
      ["51015", 107],
      ["51770", 102],
      ["51161", 79],
      ["51171", 59],
      ["51187", 55],
      ["51023", 53],
      ["51660", 42],
      ["51790", 33],
      ["51139", 32],
      ["51775", 32],
      ["51163", 31],
      ["51840", 29],
      ["51820", 27],
      ["51043", 24],
      ["51005", 20],
      ["51530", 7],
      ["51678", 7],
      ["51017", 6],
      ["51580", 6],
      ["51091", 4],
    ],
    harris2024: 0.3792,
    holder: "R",
    id: "VA-06",
    incumbent: "Ben Cline",
    left: { name: "Beth Macy", party: "D" },
    right: { name: "Benjamin Lee Cline", party: "R" },
    state: "VA",
  },
  {
    counties: [
      ["51153", 303],
      ["51179", 207],
      ["51177", 197],
      ["51047", 71],
      ["51137", 55],
      ["51033", 44],
      ["51099", 38],
      ["51630", 34],
      ["51079", 30],
      ["51113", 21],
    ],
    harris2024: 0.5146,
    holder: "D",
    id: "VA-07",
    incumbent: "Eugene Vindman",
    left: { name: "Eugene Vindman", party: "D" },
    right: { name: "Douglas Ollivant", party: "R" },
    state: "VA",
  },
  {
    counties: [
      ["51059", 438],
      ["51013", 332],
      ["51510", 207],
      ["51610", 23],
    ],
    harris2024: 0.7545,
    holder: "D",
    id: "VA-08",
    incumbent: "Don Beyer",
    left: { name: "Don Beyer", party: "D" },
    right: { name: "Tony Sabio", party: "R" },
    state: "VA",
  },
  {
    counties: [
      ["51121", 115],
      ["51019", 78],
      ["51067", 76],
      ["51191", 72],
      ["51089", 62],
      ["51161", 60],
      ["51185", 49],
      ["51155", 43],
      ["51195", 41],
      ["51035", 40],
      ["51197", 38],
      ["51173", 35],
      ["51167", 33],
      ["51169", 27],
      ["51105", 25],
      ["51063", 24],
      ["51141", 24],
      ["51027", 23],
      ["51071", 23],
      ["51077", 20],
      ["51520", 18],
      ["51051", 17],
      ["51750", 16],
      ["51690", 14],
      ["51021", 9],
      ["51045", 8],
      ["51640", 7],
      ["51720", 4],
    ],
    harris2024: 0.2779,
    holder: "R",
    id: "VA-09",
    incumbent: "Morgan Griffith",
    left: { name: "Joy Powers", party: "D" },
    right: { name: "H. Morgan Griffith", party: "R" },
    state: "VA",
  },
  {
    counties: [
      ["51107", 546],
      ["51153", 252],
      ["51061", 107],
      ["51683", 38],
      ["51059", 30],
      ["51685", 14],
      ["51157", 12],
    ],
    harris2024: 0.5429,
    holder: "D",
    id: "VA-10",
    incumbent: "Suhas Subramanyam",
    left: { name: "Suhas Subramanyam", party: "D" },
    right: { name: "Dave T. Beckwith", party: "R" },
    state: "VA",
  },
  {
    counties: [
      ["51059", 968],
      ["51600", 32],
    ],
    harris2024: 0.6765,
    holder: "D",
    id: "VA-11",
    incumbent: "James Walkinshaw",
    left: { name: "James Walkinshaw", party: "D" },
    right: { name: "Arthur Purves", party: "R" },
    state: "VA",
  },
  {
    counties: [
      ["50007", 263],
      ["50023", 96],
      ["50027", 93],
      ["50021", 92],
      ["50011", 72],
      ["50025", 70],
      ["50001", 61],
      ["50003", 56],
      ["50017", 48],
      ["50005", 45],
      ["50015", 40],
      ["50019", 40],
      ["50013", 14],
      ["50009", 9],
    ],
    harris2024: 0.6639,
    holder: "D",
    id: "VT-AL",
    incumbent: "Becca Balint",
    left: { name: "Becca Balint", party: "D" },
    right: { name: "Gerald Malloy", party: "R" },
    state: "VT",
  },
  {
    counties: [
      ["53061", 615],
      ["53033", 385],
    ],
    harris2024: 0.6486,
    holder: "D",
    id: "WA-01",
    incumbent: "Suzan DelBene",
    left: { name: "Suzan DelBene", party: "D" },
    right: { name: "Mary Silva", party: "R" },
    state: "WA",
  },
  {
    counties: [
      ["53061", 356],
      ["53073", 324],
      ["53057", 165],
      ["53029", 123],
      ["53055", 31],
    ],
    harris2024: 0.6222,
    holder: "D",
    id: "WA-02",
    incumbent: "Rick Larsen",
    left: { name: "Rick Larsen", party: "D" },
    right: { name: "Edwin H. Feller", party: "R" },
    state: "WA",
  },
  {
    counties: [
      ["53011", 652],
      ["53015", 140],
      ["53041", 107],
      ["53067", 43],
      ["53049", 34],
      ["53059", 17],
      ["53069", 7],
    ],
    harris2024: 0.483,
    holder: "D",
    id: "WA-03",
    incumbent: "Marie Gluesenkamp Perez",
    left: { name: "Marie Gluesenkamp Pérez", party: "D" },
    right: { name: "John Braun", party: "R" },
    state: "WA",
  },
  {
    counties: [
      ["53005", 322],
      ["53077", 284],
      ["53025", 116],
      ["53021", 92],
      ["53017", 67],
      ["53047", 66],
      ["53039", 44],
      ["53001", 9],
    ],
    harris2024: 0.3938,
    holder: "R",
    id: "WA-04",
    incumbent: "Dan Newhouse",
    left: { name: "John Duresky", party: "D" },
    right: { name: "Amanda McKinney", party: "R" },
    state: "WA",
  },
  {
    counties: [
      ["53063", 707],
      ["53071", 73],
      ["53065", 70],
      ["53075", 49],
      ["53003", 28],
      ["53051", 21],
      ["53043", 18],
      ["53019", 10],
      ["53021", 8],
      ["53001", 6],
      ["53013", 6],
      ["53023", 3],
    ],
    harris2024: 0.4445,
    holder: "R",
    id: "WA-05",
    incumbent: "Michael Baumgartner",
    left: { name: "Carmela Conroy", party: "D" },
    right: { name: "Michael Baumgartner", party: "R" },
    state: "WA",
  },
  {
    counties: [
      ["53035", 359],
      ["53053", 301],
      ["53009", 112],
      ["53027", 87],
      ["53045", 84],
      ["53031", 57],
    ],
    harris2024: 0.5995,
    holder: "D",
    id: "WA-06",
    incumbent: "Emily Randall",
    left: { name: "Emily Randall", party: "D" },
    right: { name: "Teresa Fox", party: "R" },
    state: "WA",
  },
  {
    counties: [["53033", 1000]],
    harris2024: 0.8878,
    holder: "D",
    id: "WA-07",
    incumbent: "Pramila Jayapal",
    left: { name: "Pramila Jayapal", party: "D" },
    right: { name: "Nirav Sheth", party: "R" },
    state: "WA",
  },
  {
    counties: [
      ["53033", 532],
      ["53053", 222],
      ["53007", 98],
      ["53061", 85],
      ["53037", 62],
      ["53017", 1],
    ],
    harris2024: 0.5298,
    holder: "D",
    id: "WA-08",
    incumbent: "Kim Schrier",
    left: { name: "Kim Schrier", party: "D" },
    right: { name: "Spencer Meline", party: "R" },
    state: "WA",
  },
  {
    counties: [["53033", 1000]],
    harris2024: 0.7135,
    holder: "D",
    id: "WA-09",
    incumbent: "Adam Smith",
    left: { name: "D. Adam Smith", party: "D" },
    right: { name: "Doug Basler", party: "R" },
    state: "WA",
  },
  {
    counties: [
      ["53053", 593],
      ["53067", 407],
    ],
    harris2024: 0.593,
    holder: "D",
    id: "WA-10",
    incumbent: "Marilyn Strickland",
    left: { name: "Marilyn Strickland", party: "D" },
    right: { name: "Chris Chung", party: "R" },
    state: "WA",
  },
  {
    counties: [
      ["55101", 266],
      ["55059", 224],
      ["55079", 212],
      ["55105", 162],
      ["55127", 135],
    ],
    harris2024: 0.4771,
    holder: "R",
    id: "WI-01",
    incumbent: "Bryan Steil",
    left: { name: "Mitchell Berman", party: "D" },
    right: { name: "Bryan Steil", party: "R" },
    state: "WI",
  },
  {
    counties: [
      ["55025", 779],
      ["55111", 76],
      ["55105", 48],
      ["55045", 47],
      ["55049", 31],
      ["55065", 19],
    ],
    harris2024: 0.7037,
    holder: "D",
    id: "WI-02",
    incumbent: "Mark Pocan",
    left: { name: "Mark Pocan", party: "D" },
    right: null,
    state: "WI",
  },
  {
    counties: [
      ["55063", 172],
      ["55035", 150],
      ["55097", 103],
      ["55043", 65],
      ["55033", 61],
      ["55093", 60],
      ["55141", 59],
      ["55017", 49],
      ["55081", 49],
      ["55123", 39],
      ["55121", 38],
      ["55001", 31],
      ["55057", 26],
      ["55023", 22],
      ["55053", 22],
      ["55103", 22],
      ["55011", 19],
      ["55091", 10],
      ["55111", 5],
    ],
    harris2024: 0.4624,
    holder: "R",
    id: "WI-03",
    incumbent: "Derrick Van Orden",
    left: { name: "Rebecca Cooke", party: "D" },
    right: { name: "Derrick Van Orden", party: "R" },
    state: "WI",
  },
  {
    counties: [["55079", 1000]],
    harris2024: 0.7623,
    holder: "D",
    id: "WI-04",
    incumbent: "Gwen Moore",
    left: { name: "Gwen Moore", party: "D" },
    right: { name: "Tim Rogers", party: "R" },
    state: "WI",
  },
  {
    counties: [
      ["55133", 572],
      ["55131", 190],
      ["55055", 104],
      ["55079", 68],
      ["55027", 53],
      ["55127", 12],
    ],
    harris2024: 0.3877,
    holder: "R",
    id: "WI-05",
    incumbent: "Scott Fitzgerald",
    left: { name: "Andrew Beck", party: "D" },
    right: { name: "Scott Fitzgerald", party: "R" },
    state: "WI",
  },
  {
    counties: [
      ["55139", 218],
      ["55117", 158],
      ["55089", 148],
      ["55039", 137],
      ["55071", 108],
      ["55021", 82],
      ["55027", 58],
      ["55137", 34],
      ["55047", 26],
      ["55077", 22],
      ["55015", 9],
    ],
    harris2024: 0.4165,
    holder: "R",
    id: "WI-06",
    incumbent: "Glenn Grothman",
    left: { name: "Brad Smith", party: "D" },
    right: { name: "Glenn Grothman", party: "R" },
    state: "WI",
  },
  {
    counties: [
      ["55073", 178],
      ["55109", 137],
      ["55095", 64],
      ["55005", 61],
      ["55031", 57],
      ["55085", 56],
      ["55017", 40],
      ["55141", 40],
      ["55069", 39],
      ["55125", 37],
      ["55019", 35],
      ["55067", 26],
      ["55007", 25],
      ["55013", 25],
      ["55113", 25],
      ["55119", 25],
      ["55129", 25],
      ["55003", 20],
      ["55099", 20],
      ["55107", 19],
      ["55041", 12],
      ["55051", 9],
      ["55057", 9],
      ["55037", 7],
      ["55081", 6],
      ["55053", 3],
    ],
    harris2024: 0.3858,
    holder: "R",
    id: "WI-07",
    incumbent: "Tom Tiffany",
    left: { name: "Fred Clark", party: "D" },
    right: { name: "Michael Alfonso", party: "R" },
    state: "WI",
  },
  {
    counties: [
      ["55009", 347],
      ["55087", 260],
      ["55135", 71],
      ["55015", 67],
      ["55083", 58],
      ["55075", 57],
      ["55115", 55],
      ["55029", 49],
      ["55061", 29],
      ["55139", 5],
      ["55078", 4],
    ],
    harris2024: 0.4177,
    holder: "R",
    id: "WI-08",
    incumbent: "Tony Wied",
    left: { name: "Rick Crosson", party: "D" },
    right: { name: "Tony Wied", party: "R" },
    state: "WI",
  },
  {
    counties: [
      ["54039", 206],
      ["54011", 97],
      ["54081", 85],
      ["54079", 75],
      ["54055", 65],
      ["54019", 43],
      ["54099", 43],
      ["54025", 41],
      ["54035", 35],
      ["54045", 31],
      ["54053", 29],
      ["54067", 28],
      ["54059", 23],
      ["54005", 22],
      ["54109", 21],
      ["54043", 20],
      ["54063", 17],
      ["54007", 15],
      ["54047", 15],
      ["54087", 15],
      ["54089", 14],
      ["54075", 11],
      ["54015", 9],
      ["54071", 9],
      ["54013", 8],
      ["54101", 8],
      ["54105", 7],
      ["54021", 6],
    ],
    harris2024: 0.274,
    holder: "R",
    id: "WV-01",
    incumbent: "Carol Miller",
    left: { name: "Vince George", party: "D" },
    right: { name: "Carol Miller", party: "R" },
    state: "WV",
  },
  {
    counties: [
      ["54003", 141],
      ["54061", 104],
      ["54107", 94],
      ["54033", 74],
      ["54037", 73],
      ["54049", 62],
      ["54069", 47],
      ["54077", 36],
      ["54029", 33],
      ["54051", 33],
      ["54057", 32],
      ["54083", 29],
      ["54027", 26],
      ["54009", 25],
      ["54097", 25],
      ["54065", 23],
      ["54041", 18],
      ["54091", 18],
      ["54001", 16],
      ["54031", 16],
      ["54103", 16],
      ["54023", 14],
      ["54085", 10],
      ["54093", 9],
      ["54095", 9],
      ["54073", 8],
      ["54017", 7],
    ],
    harris2024: 0.2981,
    holder: "R",
    id: "WV-02",
    incumbent: "Riley Moore",
    left: { name: "Ace Parsi", party: "D" },
    right: { name: "Riley Moore", party: "R" },
    state: "WV",
  },
  {
    counties: [
      ["56021", 161],
      ["56025", 126],
      ["56005", 68],
      ["56001", 66],
      ["56013", 64],
      ["56029", 62],
      ["56037", 62],
      ["56033", 61],
      ["56039", 49],
      ["56023", 40],
      ["56041", 34],
      ["56009", 25],
      ["56007", 24],
      ["56015", 23],
      ["56003", 21],
      ["56019", 18],
      ["56031", 18],
      ["56035", 18],
      ["56011", 16],
      ["56043", 14],
      ["56045", 13],
      ["56017", 10],
      ["56027", 5],
    ],
    harris2024: 0.2652,
    holder: "R",
    id: "WY-AL",
    incumbent: "Harriet Hageman",
    left: { name: "Lisa Kinney", party: "D" },
    right: { name: "Chuck Gray", party: "R" },
    state: "WY",
  },
];
